import { DiveSite } from '../types/DiveSite';

// Regional expansion catalog: Florida, the Caribbean, and Mexico.
// Generated from curated regional batches; keep entries factual and concise.
export const expansionDiveSiteCatalog: DiveSite[] = [
  {
    id: 'forty-fathom-grotto',
    slug: 'forty-fathom-grotto',
    name: '40 Fathom Grotto',
    region: 'Ocala, Florida',
    country: 'United States',
    latitude: 29.285,
    longitude: -82.265,
    matchRadiusKm: 6,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A privately operated, 240-foot-deep sinkhole northwest of Ocala used for decades as a deep and technical dive training facility. Suspended platforms, wrecks, and fossil ledges line the descent.',
    highlights: ['240-ft training sinkhole', 'Platforms and sunken boats', 'Ancient fossil ledges'],
    tags: ['sinkhole', 'deep', 'technical', 'training', 'central-florida'],
    maxDepthM: 73,
    requiredCertification: 'AOW',
    requirementNote: 'Facility orientation required; depths beyond 40 m require technical certification',
  },
  {
    id: 'accokeek',
    slug: 'accokeek',
    name: 'Accokeek',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.08,
    longitude: -85.78,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 143-foot former Navy fleet tug scuttled in 2000 off Panama City Beach. The upright wreck offers open compartments and steady fish action in deeper Gulf water.',
    highlights: ['Ex-Navy fleet tug', 'Open compartments', 'Deep Gulf wreck'],
    tags: ['wreck', 'navy', 'tugboat', 'deep', 'panama city'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'adelaide-baker',
    slug: 'adelaide-baker',
    name: 'Adelaide Baker',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.708,
    longitude: -80.887,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered iron-framed remains of a three-masted ship that wrecked near Duck Key in 1889, a stop on the Florida Keys Shipwreck Trail. Ribs, mast sections, and rigging hardware spread across shallow sand and coral.',
    highlights: ['Shipwreck Trail site', '1889 sailing ship remains', 'Shallow scattered debris field'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shipwreck-trail', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'adolphus-busch',
    slug: 'adolphus-busch',
    name: 'Adolphus Busch Sr.',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.5302,
    longitude: -81.4607,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 210-foot island freighter scuttled in 1998 between Looe Key and American Shoal, standing upright in about 33 meters. The intact wheelhouse and holds host goliath grouper and schooling baitfish.',
    highlights: ['Upright intact freighter', 'Resident goliath grouper', 'Penetrable cargo holds'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'deep', 'lower-keys'],
    aliases: ['Adolphus Busch'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
    requirementNote: 'Deck at 24 m, sand at 33 m.',
  },
  {
    id: 'airport-reef-wall-jamaica',
    slug: 'airport-reef-wall-jamaica',
    name: 'Airport Reef & Wall',
    region: 'Montego Bay, Jamaica',
    country: 'Jamaica',
    latitude: 18.502,
    longitude: -77.925,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A reef and wall complex off the Sangster Airport peninsula inside the Montego Bay Marine Park. Coral spurs run out to a drop-off with sponges, gorgonians and frequent turtle sightings.',
    highlights: ['Marine park wall', 'Coral spur formations', 'Turtle sightings'],
    tags: ['wall', 'montego-bay', 'marine-park', 'turtles', 'reef'],
    aliases: ['Airport Wall'],
    maxDepthM: 30,
  },
  {
    id: 'airport-wall-sosua',
    slug: 'airport-wall-sosua',
    name: 'Airport Wall',
    region: 'Sosúa, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 19.76,
    longitude: -70.545,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A coral wall beneath the flight path of Puerto Plata\'s airport just west of Sosúa Bay, dropping in steps from about 12 to 30-plus meters. Overhangs and crevices shelter lobster, eels and schooling fish.',
    highlights: ['Stepped coral wall', 'Overhangs full of life', 'Sosúa\'s signature deep dive'],
    tags: ['wall', 'sosua', 'north-coast', 'overhangs', 'deep'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Main wall sections below 18 m.',
  },
  {
    id: 'alexander-springs',
    slug: 'alexander-springs',
    name: 'Alexander Springs',
    region: 'Ocala National Forest, Florida',
    country: 'United States',
    latitude: 29.0806,
    longitude: -81.5768,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A first-magnitude spring in the Ocala National Forest and one of the few Florida springs where open-water scuba is welcomed. The wide, bowl-shaped basin slopes gently to a rocky vent.',
    highlights: ['Scuba-friendly national forest spring', 'Gentle bowl to 25 ft', 'Clear 72 F water'],
    tags: ['spring', 'open-water', 'ocala-forest', 'training', 'snorkel'],
    maxDepthM: 8,
  },
  {
    id: 'alexanders-wreck',
    slug: 'alexanders-wreck',
    name: 'Alexander\'s Wreck',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.619,
    longitude: -81.977,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The former destroyer escort USS Amesbury, which grounded and broke apart while being towed for reefing in 1962. Two shallow debris sections on the Gulf side of Key West teem with snapper and nurse sharks.',
    highlights: ['WWII destroyer escort remains', 'Two shallow debris fields', 'Shipwreck Trail site'],
    tags: ['florida', 'keys', 'wreck', 'wwii', 'shipwreck-trail', 'shallow'],
    aliases: ['USS Amesbury'],
    maxDepthM: 8,
  },
  {
    id: 'almirante',
    slug: 'almirante',
    name: 'Almirante',
    region: 'Miami, Florida',
    country: 'United States',
    latitude: 25.828,
    longitude: -80.077,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 200-foot steel freighter scuttled in 1974 on the deep wreck line off Miami Beach. Decades underwater have covered the wreck in corals and sponges, and large grouper patrol the hull.',
    highlights: ['Veteran 1974 wreck', 'Coral-covered hull', 'Resident grouper'],
    tags: ['wreck', 'deep', 'freighter', 'artificial reef', 'miami'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'amberjack-reef-exuma',
    slug: 'amberjack-reef-exuma',
    name: 'Amberjack Reef',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 24.39,
    longitude: -76.63,
    matchRadiusKm: 7,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A patch reef in the Exuma Cays Land and Sea Park alive with fish thanks to decades of no-take protection. Amberjacks, groupers, and reef sharks swarm the coral heads at around 15 meters.',
    highlights: ['No-take park fish density', 'Curious amberjacks and sharks', 'Healthy coral heads'],
    tags: ['reef', 'marine-park', 'exumas', 'fish-life', 'liveaboard'],
    maxDepthM: 15,
  },
  {
    id: 'american-shoal',
    slug: 'american-shoal',
    name: 'American Shoal',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.5242,
    longitude: -81.5203,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef beneath the 1880 American Shoal lighthouse off Sugarloaf Key, with coral ridges and sandy troughs. The iron tower is the last of the classic reef lights along this stretch.',
    highlights: ['1880 iron lighthouse', 'Coral ridges and troughs', 'Uncrowded Lower Keys reef'],
    tags: ['florida', 'keys', 'reef', 'lighthouse', 'shallow', 'lower-keys'],
    maxDepthM: 9,
  },
  {
    id: 'ancient-mariner',
    slug: 'ancient-mariner',
    name: 'Ancient Mariner',
    region: 'Deerfield Beach, Florida',
    country: 'United States',
    latitude: 26.3,
    longitude: -80.06,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 165-foot former Coast Guard cutter that later served as a floating restaurant before being scuttled in 1991 off Deerfield Beach. The wreck sits at friendly depth and swarms with tropicals.',
    highlights: ['Ex-cutter turned restaurant', 'Colorful backstory', 'Friendly depth'],
    tags: ['wreck', 'coast guard', 'artificial reef', 'deerfield', 'intermediate'],
    aliases: ['USCGC Nemesis'],
    maxDepthM: 21,
  },
  {
    id: 'ancla-del-pirata-cuba',
    slug: 'ancla-del-pirata-cuba',
    name: 'Ancla del Pirata',
    region: 'María la Gorda, Cuba',
    country: 'Cuba',
    latitude: 21.79,
    longitude: -84.505,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A María la Gorda site named for a huge 18th-century anchor lodged in the coral, a relic of the area\'s pirate lore. The reef around it is dense with sea fans, snappers and angelfish.',
    highlights: ['Giant antique anchor', 'Pirate-era relic', 'Healthy coral gardens'],
    tags: ['reef', 'maria-la-gorda', 'anchor', 'historic', 'national-park'],
    aliases: ['Pirate\'s Anchor'],
    maxDepthM: 20,
  },
  {
    id: 'andes-wreck',
    slug: 'andes-wreck',
    name: 'Andes Wreck (Deep Bay)',
    region: 'Deep Bay, Antigua',
    country: 'Antigua and Barbuda',
    latitude: 17.136,
    longitude: -61.868,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A three-masted merchant barque that caught fire and sank in Deep Bay in 1905, resting in under 10 meters with its ribs sometimes visible from the surface. The calm bay makes it a popular snorkel and novice wreck dive.',
    highlights: ['1905 barque', 'snorkel-depth wreck', 'calm protected bay'],
    tags: ['wreck', 'historic', 'shallow', 'antigua', 'snorkel'],
    maxDepthM: 9,
  },
  {
    id: 'andrea-i-and-ii',
    slug: 'andrea-i-and-ii',
    name: 'Andrea I & II',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.186,
    longitude: -68.304,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Twin shore sites north of Kralendijk with easy entries and a gentle reef slope known for fish density. Popular check-out and night dive locations close to town.',
    highlights: ['Abundant reef fish', 'Easy shore entry', 'Good night diving'],
    tags: ['shore-dive', 'coral', 'beginner-friendly', 'bonaire', 'night-dive'],
    maxDepthM: 30,
  },
  {
    id: 'angel-city',
    slug: 'angel-city',
    name: 'Angel City',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.103,
    longitude: -68.2895,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'One of the best-known sites in Bonaire\'s southern double-reef complex, named for its abundant queen and French angelfish. The channel between the two reef ridges shelters rays, tarpon, and large groupers.',
    highlights: ['Angelfish abundance', 'Double reef ridges', 'Large groupers'],
    tags: ['shore-dive', 'double-reef', 'bonaire', 'coral', 'angelfish'],
    maxDepthM: 33,
  },
  {
    id: 'angelfish-blue-hole',
    slug: 'angelfish-blue-hole',
    name: 'Angelfish Blue Hole',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 23.53,
    longitude: -75.76,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Intermediate',
    summary: 'A blue hole near Stocking Island off George Town, Great Exuma, dropping to about 28 meters and connecting to the Mystery Cave system. Tidal flow draws schools of fish and rays around the entrance shaft.',
    highlights: ['Blue hole shaft to 28 m', 'Gateway to Mystery Cave', 'Fish gathered by tidal flow'],
    tags: ['blue-hole', 'exumas', 'george-town', 'tidal', 'cave-entrance'],
    maxDepthM: 28,
    requirementNote: 'Open-water divers stay in the shaft; the Mystery Cave passages beyond require full cave certification.',
  },
  {
    id: 'angelfish-reef',
    slug: 'angelfish-reef',
    name: 'Angelfish Reef',
    region: 'Norman Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.3145,
    longitude: -64.6305,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sloping reef off the western point of Norman Island where coral ridges descend from the shallows to a sandy bottom near 27 meters. True to its name, French and queen angelfish are regulars along the slope.',
    highlights: ['resident angelfish', 'sloping coral ridges', 'sheltered conditions'],
    tags: ['reef', 'bvi', 'slope', 'beginner', 'boat-dive'],
    maxDepthM: 27,
  },
  {
    id: 'anse-chastanet-reef',
    slug: 'anse-chastanet-reef',
    name: 'Anse Chastanet Reef',
    region: 'Soufriere, St. Lucia',
    country: 'Saint Lucia',
    latitude: 13.8645,
    longitude: -61.0765,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-accessible reef plateau in the marine reserve fronting Anse Chastanet beach, starting at about 5 meters before sloping into deeper water. Its density of small fish life makes it St. Lucia\'s classic first dive and night dive.',
    highlights: ['shore-entry reef plateau', 'marine reserve fish density', 'excellent night diving'],
    tags: ['reef', 'shore-dive', 'st-lucia', 'marine-reserve', 'beginner', 'night-dive'],
    maxDepthM: 20,
  },
  {
    id: 'aquarium-reef-grand-cayman',
    slug: 'aquarium-reef-grand-cayman',
    name: 'Aquarium Reef',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.34,
    longitude: -81.392,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow patch reef off Seven Mile Beach so thick with fish it earned its aquarium nickname. Ideal for training dives, long relaxed profiles and fish photography.',
    highlights: ['Dense reef fish life', 'Shallow relaxed profile', 'Great for new divers'],
    tags: ['reef', 'shallow', 'seven-mile-beach', 'fish-life', 'training'],
    maxDepthM: 12,
  },
  {
    id: 'arashi-reef',
    slug: 'arashi-reef',
    name: 'Arashi Reef',
    region: 'Arashi, Aruba',
    country: 'Aruba',
    latitude: 12.5855,
    longitude: -70.049,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Gentle reef off Arashi Beach at Aruba\'s northwest tip, with sea fans, brain corals, and scattered aircraft debris in the shallows. Calm conditions make it the island\'s favorite easy shore dive and snorkel spot.',
    highlights: ['Easy shore access', 'Sea fans and brain coral', 'Calm shallow profile'],
    tags: ['shore-dive', 'reef', 'aruba', 'beginner-friendly', 'snorkeling'],
    maxDepthM: 12,
  },
  {
    id: 'astron-wreck-punta-cana',
    slug: 'astron-wreck-punta-cana',
    name: 'Astron Wreck',
    region: 'Punta Cana, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.556,
    longitude: -68.342,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A Russian freighter that ran aground on the reef off Cabeza de Toro in 1978, its bow long visible above the surface. The shallow broken hull is now an easy, fish-filled dive and snorkel site.',
    highlights: ['Grounded freighter remains', 'Very shallow and easy', 'Abundant reef fish'],
    tags: ['wreck', 'punta-cana', 'shallow', 'snorkel-friendly', 'historic'],
    maxDepthM: 12,
  },
  {
    id: 'atlantic-princess-wreck-bayahibe',
    slug: 'atlantic-princess-wreck-bayahibe',
    name: 'Atlantic Princess Wreck',
    region: 'Bayahibe, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.365,
    longitude: -68.835,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A small tourist cruise boat sunk off Bayahibe in 2009 as an artificial reef, resting in about 12 meters of clear water. Its open decks and shallow depth make it a favorite for new wreck divers and photographers.',
    highlights: ['Shallow easy wreck', 'Open swim-through decks', 'Great for photos'],
    tags: ['wreck', 'bayahibe', 'shallow', 'artificial-reef', 'beginner-friendly'],
    maxDepthM: 12,
  },
  {
    id: 'augustin-fresnel-wreck',
    slug: 'augustin-fresnel-wreck',
    name: 'Augustin Fresnel',
    region: 'Malendure, Guadeloupe',
    country: 'Guadeloupe',
    latitude: 16.162,
    longitude: -61.782,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A former lighthouse-tender scuttled in 2003 south of the Pigeon Islands, resting in about 28 meters. Deeper and less visited than the Franjack, it offers an atmospheric hull dressed in whip corals and hydroids.',
    highlights: ['lighthouse tender wreck', 'whip coral growth', 'quieter deep alternative'],
    tags: ['wreck', 'deep', 'guadeloupe', 'artificial-reef', 'advanced'],
    maxDepthM: 28,
    requiredCertification: 'AOW',
  },
  {
    id: 'austin-smith-wreck',
    slug: 'austin-smith-wreck',
    name: 'Austin Smith Wreck',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 24.78,
    longitude: -76.83,
    matchRadiusKm: 7,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 27-meter Bahamian Defence Force cutter that sank in 1995 while under tow and now rests on sand in the northern Exumas. The intact patrol boat is patrolled itself by Caribbean reef sharks and schooling snapper.',
    highlights: ['Intact patrol-boat wreck', 'Reef sharks on the hull', 'Northern Exumas setting'],
    tags: ['wreck', 'sharks', 'exumas', 'artificial-reef', 'boat-dive'],
    maxDepthM: 18,
  },
  {
    id: 'baby-beach-reef',
    slug: 'baby-beach-reef',
    name: 'Baby Beach Reef',
    region: 'Seroe Colorado, Aruba',
    country: 'Aruba',
    latitude: 12.418,
    longitude: -69.879,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Reef outside the sheltered lagoon at Aruba\'s southeastern tip, with elkhorn stands and larger fish along the drop toward the channel. Current at the point can be strong, so it is usually dived with a guide.',
    highlights: ['Elkhorn coral stands', 'Bigger fish at the point', 'Lagoon-side snorkeling'],
    tags: ['reef', 'aruba', 'current', 'snorkeling', 'boat-dive'],
    maxDepthM: 25,
  },
  {
    id: 'bachelors-beach',
    slug: 'bachelors-beach',
    name: 'Bachelor\'s Beach',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.123,
    longitude: -68.2855,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Small pocket beach below a low cliff with stairs, south of the airport, leading to a gently sloping reef. A relaxed site with good fish life and easy navigation.',
    highlights: ['Stairway beach entry', 'Gentle reef slope', 'Uncrowded'],
    tags: ['shore-dive', 'beginner-friendly', 'bonaire', 'beach', 'coral'],
    maxDepthM: 30,
  },
  {
    id: 'bahama-mama-wreck',
    slug: 'bahama-mama-wreck',
    name: 'Bahama Mama Wreck',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.99,
    longitude: -77.54,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A former party cruise boat scuttled in 1995 off southwest New Providence, sitting upright on sand within the Stuart Cove\'s dive area. Its open decks make an easy, shallow wreck tour often combined with a shark dive.',
    highlights: ['Upright former party boat', 'Easy open decks', 'Frequent shark fly-bys'],
    tags: ['wreck', 'artificial-reef', 'nassau', 'shallow', 'beginner-friendly'],
    maxDepthM: 14,
  },
  {
    id: 'baja-california',
    slug: 'baja-california',
    name: 'Baja California',
    region: 'Boca Grande, Florida',
    country: 'United States',
    latitude: 26.4,
    longitude: -82.55,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A freighter torpedoed by a German U-boat in 1942 while carrying wartime cargo across the Gulf, now lying offshore between Boca Grande and Fort Myers. The wreck\'s scattered holds still contain cargo remnants and draw big grouper.',
    highlights: ['U-boat casualty', 'Cargo remnants', 'WWII Gulf history'],
    tags: ['wreck', 'wwii', 'deep', 'offshore', 'gulf'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
  },
  {
    id: 'balboa-wreck-grand-cayman',
    slug: 'balboa-wreck-grand-cayman',
    name: 'Balboa Wreck',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.296,
    longitude: -81.386,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A freighter sunk in George Town harbour by the 1932 hurricane, its flattened remains scattered across the shallow seabed. Due to harbour ship traffic it is dived mostly at night, when the wreckage crawls with life.',
    highlights: ['Historic 1932 hurricane wreck', 'Classic night dive', 'Octopus and eels in the wreckage'],
    tags: ['wreck', 'night-dive', 'george-town', 'historic', 'shallow'],
    maxDepthM: 10,
  },
  {
    id: 'banana-reef',
    slug: 'banana-reef',
    name: 'Banana Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.06,
    longitude: -80.33,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow banana-shaped reef inside John Pennekamp waters, used heavily for training and snorkel trips. Low coral ridges and grass patches hold grunts, parrotfish, and rays.',
    highlights: ['Easy training reef', 'Snorkel friendly', 'Rays on the sand'],
    tags: ['florida', 'keys', 'reef', 'snorkel', 'shallow', 'pennekamp'],
    maxDepthM: 6,
  },
  {
    id: 'bari-reef',
    slug: 'bari-reef',
    name: 'Bari Reef',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.1665,
    longitude: -68.2865,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'House reef at Sand Dollar, repeatedly ranked among the fishiest dive sites in the Caribbean by REEF fish surveys, with well over 300 recorded species. Easy entry and gentle profile make it ideal for long, relaxed dives.',
    highlights: ['Highest fish counts in the Caribbean', 'Easy entry', 'Great for photographers'],
    tags: ['shore-dive', 'house-reef', 'fish-diversity', 'bonaire', 'beginner-friendly'],
    maxDepthM: 30,
  },
  {
    id: 'barracuda-reef-cozumel',
    slug: 'barracuda-reef-cozumel',
    name: 'Barracuda Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.545,
    longitude: -86.985,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'A remote reef on Cozumel\'s exposed northwest coast, dived only in calm conditions due to strong, shifting currents and open-ocean exposure. The payoff is big animals: eagle rays, sharks, and its namesake barracuda.',
    highlights: ['Big animal encounters', 'Exposed northern reef', 'Expert-level currents'],
    tags: ['drift', 'advanced', 'pelagics', 'cozumel', 'current'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Operators require advanced certification and strong drift experience; dived only with favorable conditions.',
  },
  {
    id: 'barracuda-playa-del-carmen',
    slug: 'barracuda-playa-del-carmen',
    name: 'Barracuda Reef (Playa del Carmen)',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.67,
    longitude: -87.04,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A low coral ridge north of Playa del Carmen swept by a steady current that funnels barracuda, jacks, and rays along the reef line. It is a classic mid-depth drift on the Riviera Maya circuit.',
    highlights: ['Barracuda in the current', 'Classic Riviera drift', 'Rays over sand'],
    tags: ['drift', 'reef', 'current', 'playa-del-carmen', 'riviera-maya'],
    maxDepthM: 20,
  },
  {
    id: 'bat-cave-st-vincent',
    slug: 'bat-cave-st-vincent',
    name: 'Bat Cave',
    region: 'Leeward coast, St. Vincent',
    country: 'Saint Vincent and the Grenadines',
    latitude: 13.198,
    longitude: -61.275,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A sea cave on St. Vincent\'s leeward coast whose ceiling shelters roosting bats while its underwater entrance swarms with copper sweepers and juvenile fish. Outside, the volcanic slope is a renowned critter hunting ground.',
    highlights: ['bat-roost sea cave', 'copper sweeper swarms', 'volcanic critter slope'],
    tags: ['cavern', 'st-vincent', 'muck', 'critters', 'boat-dive'],
    maxDepthM: 18,
  },
  {
    id: 'bathtub-reef',
    slug: 'bathtub-reef',
    name: 'Bathtub Reef',
    region: 'Stuart, Florida',
    country: 'United States',
    latitude: 27.192,
    longitude: -80.16,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected lagoon at Bathtub Reef Beach formed by a rare Sabellariid worm-rock reef on Hutchinson Island. The calm, shallow water makes it one of the Treasure Coast\'s most popular snorkel and beginner dive spots.',
    highlights: ['Worm-rock reef', 'Calm protected lagoon', 'Family friendly'],
    tags: ['reef', 'shore dive', 'snorkel', 'shallow', 'stuart'],
    maxDepthM: 4,
  },
  {
    id: 'bayronto',
    slug: 'bayronto',
    name: 'Bayronto',
    region: 'Venice, Florida',
    country: 'United States',
    latitude: 26.95,
    longitude: -82.87,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A British steamer that capsized and sank in the 1919 hurricane, lying inverted on the Gulf floor roughly 30 miles off the Venice area. The large, historic wreck attracts goliath grouper and big pelagics.',
    highlights: ['1919 hurricane victim', 'Inverted steamer', 'Goliath grouper'],
    tags: ['wreck', 'historic', 'deep', 'offshore', 'venice'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
    requirementNote: 'Long offshore run; open-Gulf conditions',
  },
  {
    id: 'becton-springs',
    slug: 'becton-springs',
    name: 'Becton Spring',
    region: 'Vernon, Florida',
    country: 'United States',
    latitude: 30.6493,
    longitude: -85.6903,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A second-magnitude spring on Holmes Creek a short paddle from Cypress Spring. Its clear pool and limestone outcrops draw snorkelers and freedivers touring the creek\'s spring group.',
    highlights: ['Quiet paddle-in spring', 'Limestone ledges', 'Pairs with Cypress Spring trips'],
    tags: ['spring', 'snorkel', 'panhandle', 'kayak', 'freshwater'],
    maxDepthM: 6,
  },
  {
    id: 'bell-buoy-barbados',
    slug: 'bell-buoy-barbados',
    name: 'Bell Buoy',
    region: 'South west coast, Barbados',
    country: 'Barbados',
    latitude: 13.07,
    longitude: -59.62,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A large dome-shaped reef off Barbados\' southwest corner marked by a navigation buoy, where coral ridges and sand channels attract turtles and schooling reef fish. Mild current usually turns it into an easy drift.',
    highlights: ['dome-shaped reef', 'sand channel ridges', 'easy drift conditions'],
    tags: ['reef', 'drift', 'barbados', 'turtles', 'boat-dive'],
    maxDepthM: 18,
  },
  {
    id: 'bens-cavern',
    slug: 'bens-cavern',
    name: 'Ben\'s Cavern',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.552,
    longitude: -78.478,
    matchRadiusKm: 4,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A collapsed inland cavern within Lucayan National Park, part of one of the world\'s longest surveyed underwater cave systems. Divers descend through a freshwater lens into a decorated chamber with stalactites and a marked cavern zone.',
    highlights: ['Stalactite-decorated chamber', 'Freshwater halocline', 'Lucayan cave system'],
    tags: ['cavern', 'cave', 'grand-bahama', 'freshwater', 'national-park'],
    maxDepthM: 12,
    requiredCertification: 'Cavern',
    requirementNote: 'Dived by permit with a guide; cavern certification required, full cave beyond the daylight zone.',
  },
  {
    id: 'benwood-wreck',
    slug: 'benwood-wreck',
    name: 'Benwood',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.0517,
    longitude: -80.33,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 360-foot merchant freighter sunk in 1942 after a wartime collision, now one of the most dived wrecks in the Keys. The bow rises intact in about 14 meters while the stern flattens into the sand.',
    highlights: ['WWII-era freighter', 'Intact bow section', 'Night dive favorite'],
    tags: ['florida', 'keys', 'wreck', 'wwii', 'shipwreck-trail', 'night-dive'],
    aliases: ['Benwood Wreck'],
    maxDepthM: 14,
  },
  {
    id: 'big-blue-spring-wacissa',
    slug: 'big-blue-spring-wacissa',
    name: 'Big Blue Spring (Wacissa River)',
    region: 'Wacissa, Florida',
    country: 'United States',
    latitude: 30.326,
    longitude: -83.99,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'The largest of the Wacissa River\'s headwater springs, a deep blue basin reached by a short paddle from the boat ramp. Divers and freedivers drop into the funnel-shaped vent amid heavy eelgrass and wildlife.',
    highlights: ['Deep blue vent on a wild river', 'Paddle-in access', 'Abundant wildlife'],
    tags: ['spring', 'river', 'kayak', 'freshwater', 'north-florida'],
    maxDepthM: 14,
  },
  {
    id: 'big-pine-key',
    slug: 'big-pine-key',
    name: 'Big Pine Key',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.67,
    longitude: -81.354,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'The jumping-off point for Lower Keys diving, including Looe Key\'s famous spur-and-groove and the Adolphus Busch wreck. Quieter and more residential than the tourist centers up the island chain.',
    highlights: ['Gateway to Looe Key', 'Adolphus Busch wreck', 'Laid-back Lower Keys base'],
    tags: ['florida', 'keys', 'destination', 'reef', 'lower-keys'],
  },
  {
    id: 'big-tunnels-grand-cayman',
    slug: 'big-tunnels-grand-cayman',
    name: 'Big Tunnels',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.377,
    longitude: -81.408,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A dramatic West Bay site built around a huge coral archway that drops divers out onto the wall at about 30 meters. Black coral and barrel sponges decorate the structure.',
    highlights: ['Massive coral archway', 'Deep wall exit', 'Black coral formations'],
    tags: ['wall', 'arch', 'swim-throughs', 'deep', 'west-bay'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
    requirementNote: 'Main tunnel exits onto the wall near 30 m.',
  },
  {
    id: 'bimini-barge',
    slug: 'bimini-barge',
    name: 'Bimini Barge',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.69,
    longitude: -79.32,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A large sunken barge on the sand off Bimini\'s western edge in the mid-20s of meters, swept by Gulf Stream water. The structure attracts big groupers, jacks, and passing bull and reef sharks.',
    highlights: ['Big groupers and jacks', 'Passing sharks', 'Gulf Stream fish action'],
    tags: ['wreck', 'bimini', 'deep', 'sharks', 'boat-dive'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
  },
  {
    id: 'bimini-road',
    slug: 'bimini-road',
    name: 'Bimini Road',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.76,
    longitude: -79.28,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A striking line of huge rectangular limestone blocks in about six meters of water off North Bimini, popularly linked to Atlantis legends. The shallow formation is an easy dive or snorkel with abundant small reef fish.',
    highlights: ['Mysterious stone formation', 'Very shallow and clear', 'Snorkel-friendly'],
    tags: ['reef', 'shallow', 'bimini', 'landmark', 'snorkel'],
    aliases: ['Atlantis Road', 'Bimini Wall Stones'],
    maxDepthM: 6,
  },
  {
    id: 'bird-key-harbor-brick-wreck',
    slug: 'bird-key-harbor-brick-wreck',
    name: 'Bird Key Harbor Brick Wreck',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.606,
    longitude: -82.891,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The remains of a 19th-century vessel carrying bricks, resting in shallow water near Bird Key southwest of Fort Jefferson. Its cargo mound and iron machinery are an easy snorkel inside the park.',
    highlights: ['Brick cargo mound', 'Shallow snorkel wreck', '19th-century machinery'],
    tags: ['florida', 'dry-tortugas', 'wreck', 'historic', 'national-park', 'shallow'],
    maxDepthM: 4,
  },
  {
    id: 'black-bart',
    slug: 'black-bart',
    name: 'Black Bart',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.13,
    longitude: -85.77,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 185-foot oilfield supply vessel scuttled in 1993 and named in honor of Navy salvage diver Charles \'Black Bart\' Bartholomew. Upright and intact with an easily toured wheelhouse, it is Panama City\'s signature wreck.',
    highlights: ['Signature PCB wreck', 'Upright and intact', 'Wheelhouse tour'],
    tags: ['wreck', 'supply vessel', 'artificial reef', 'panama city', 'intermediate'],
    maxDepthM: 24,
  },
  {
    id: 'black-forest-grand-turk',
    slug: 'black-forest-grand-turk',
    name: 'Black Forest',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.47,
    longitude: -71.155,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'One of Grand Turk\'s most celebrated wall dives, named for the unusually shallow stands of black coral growing beneath its undercut lip. The overhanging face darkens the water and concentrates sponges and fish along the ledge.',
    highlights: ['Shallow black coral trees', 'Undercut overhanging wall', 'Signature Grand Turk dive'],
    tags: ['wall', 'black-coral', 'grand-turk', 'drop-off', 'photography'],
    maxDepthM: 30,
  },
  {
    id: 'black-wall-la-parguera',
    slug: 'black-wall-la-parguera',
    name: 'Black Wall',
    region: 'La Parguera, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 17.905,
    longitude: -67.035,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'The best-known site on La Parguera\'s shelf-edge wall, which begins around 18 meters and plummets hundreds of meters into the Caribbean. Black corals, deep-water gorgonians and sheer drops define the dive.',
    highlights: ['Shelf-edge mega-wall', 'Black coral colonies', 'Bottomless blue drop'],
    tags: ['wall', 'la-parguera', 'black-coral', 'deep', 'boat-dive'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Wall top near 18 m; easy to exceed recreational depth.',
  },
  {
    id: 'blonde-rock',
    slug: 'blonde-rock',
    name: 'Blonde Rock',
    region: 'Between Dead Chest and Salt Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.356,
    longitude: -64.569,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A submerged pinnacle between Dead Chest and Salt Island whose top sits a few meters below the surface, dropping over ledges and overhangs to about 20 meters. Lobster-filled crevices and fire coral give the rock its name and character.',
    highlights: ['submerged pinnacle', 'ledges and overhangs', 'lobster crevices'],
    tags: ['pinnacle', 'bvi', 'overhangs', 'boat-dive', 'reef'],
    maxDepthM: 20,
  },
  {
    id: 'blue-bead-hole',
    slug: 'blue-bead-hole',
    name: 'Blue Bead Hole',
    region: 'St. Eustatius',
    country: 'Caribbean Netherlands',
    latitude: 17.474,
    longitude: -62.992,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sandy patch dive off Oranjestad where lucky divers still find 17th-century Dutch trade beads, the island\'s famous blue beads. Garden eels, flying gurnards, and stingrays live across the gentle sand flat.',
    highlights: ['historic blue trade beads', 'garden eel colonies', 'relaxed sand-flat dive'],
    tags: ['sand-flat', 'historic', 'statia', 'macro', 'beginner'],
    maxDepthM: 20,
  },
  {
    id: 'blue-room-curacao',
    slug: 'blue-room-curacao',
    name: 'Blue Room',
    region: 'Santa Cruz, Curaçao',
    country: 'Curacao',
    latitude: 12.3465,
    longitude: -69.144,
    matchRadiusKm: 2,
    siteType: 'blue-hole',
    difficulty: 'Beginner',
    summary: 'Shallow sea cavern in the cliff near Santa Cruz whose entrance funnels sunlight into a glowing blue chamber. Accessible to snorkelers and divers, with copper sweepers schooling inside.',
    highlights: ['Glowing blue cavern light', 'Snorkel-accessible', 'Schooling copper sweepers'],
    tags: ['cavern', 'snorkeling', 'curacao', 'boat-dive', 'photography'],
    maxDepthM: 10,
  },
  {
    id: 'blue-spring-volusia',
    slug: 'blue-spring-volusia',
    name: 'Blue Spring State Park (Volusia)',
    region: 'Orange City, Florida',
    country: 'United States',
    latitude: 28.9472,
    longitude: -81.3397,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A first-magnitude spring on the St. Johns River famous as a winter manatee refuge. Certified divers may descend the narrowing fissure toward the boil outside manatee season, when the run reopens to swimmers.',
    highlights: ['Winter manatee refuge', 'Deep boil fissure', 'St. Johns River run'],
    tags: ['spring', 'manatees', 'state-park', 'st-johns', 'freshwater'],
    aliases: ['Volusia Blue Spring'],
    maxDepthM: 36,
    requiredCertification: 'AOW',
    requirementNote: 'Diving allowed with a buddy outside manatee season (roughly mid-Nov to Mar); no lights or cave entry',
  },
  {
    id: 'boca-grande-ledges',
    slug: 'boca-grande-ledges',
    name: 'Boca Grande Ledges',
    region: 'Boca Grande, Florida',
    country: 'United States',
    latitude: 26.65,
    longitude: -82.45,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Natural limestone ledges offshore of Boca Grande Pass where relief of one to two meters concentrates Gulf life across the flat shelf. Goliath grouper, hogfish, and loggerhead turtles frequent the undercuts.',
    highlights: ['Natural Gulf ledges', 'Goliath grouper', 'Hogfish and turtles'],
    tags: ['reef', 'ledge', 'offshore', 'spearfishing', 'boca grande'],
    maxDepthM: 20,
  },
  {
    id: 'bonnet-spring',
    slug: 'bonnet-spring',
    name: 'Bonnet Spring',
    region: 'Luraville, Florida',
    country: 'United States',
    latitude: 30.124,
    longitude: -83.132,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A sink entrance in Wes Skiles Peacock Springs State Park connected to the park\'s celebrated cave network. Cave divers use it as one of several access points for traverses.',
    highlights: ['Sink entrance to Peacock network', 'Traverse routes', 'Forest park setting'],
    tags: ['cave', 'sinkhole', 'state-park', 'luraville', 'overhead'],
    maxDepthM: 18,
    requiredCertification: 'FullCave',
    requirementNote: 'Cave-certified divers only',
  },
  {
    id: 'bonnies-arch-grand-cayman',
    slug: 'bonnies-arch-grand-cayman',
    name: 'Bonnie\'s Arch',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.381,
    longitude: -81.413,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A photogenic natural coral archway near Northwest Point, festooned with sponges and often sheltering tarpon. The arch spans a sandy channel at around 15-20 meters.',
    highlights: ['Natural coral archway', 'Tarpon under the arch', 'Photographer favorite'],
    tags: ['arch', 'west-bay', 'photography', 'tarpon', 'reef'],
    maxDepthM: 21,
  },
  {
    id: 'bookends-tobago',
    slug: 'bookends-tobago',
    name: 'Bookends',
    region: 'St. Giles Islands, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.344,
    longitude: -60.525,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Twin rock formations off the St. Giles Islands at Tobago\'s wild northern tip, where converging Atlantic and Caribbean water brings sharks, rays, and thick fish schools. Surge and current restrict it to calm days and experienced divers.',
    highlights: ['Twin rock pinnacles', 'Sharks and rays', 'Converging currents'],
    tags: ['pinnacle', 'boat-dive', 'tobago', 'current', 'advanced'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Exposed site with surge and current; dived only in favorable conditions.',
  },
  {
    id: 'boynton-ledge',
    slug: 'boynton-ledge',
    name: 'Boynton Ledge',
    region: 'Boynton Beach, Florida',
    country: 'United States',
    latitude: 26.53,
    longitude: -80.03,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A long natural reef ledge off Boynton Inlet dived almost exclusively as a Gulf Stream drift. Dense soft corals and sponges line the ledge, with frequent turtle and nurse shark encounters.',
    highlights: ['Gulf Stream drift', 'Soft coral growth', 'Frequent turtles'],
    tags: ['drift', 'ledge', 'reef', 'turtles', 'boynton'],
    maxDepthM: 18,
  },
  {
    id: 'bronco-billy',
    slug: 'bronco-billy',
    name: 'Bronco Billy',
    region: 'The Dogs, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.483,
    longitude: -64.458,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A playful site at George Dog in the Dog Islands where a coral archway leads into winding canyons and ridges. Calm conditions and shallow depths make it a staple stop for boats crossing to Virgin Gorda.',
    highlights: ['coral archway', 'winding canyons', 'calm conditions'],
    tags: ['reef', 'arch', 'bvi', 'dog-islands', 'beginner'],
    maxDepthM: 14,
  },
  {
    id: 'buddys-reef',
    slug: 'buddys-reef',
    name: 'Buddy\'s Reef',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.1695,
    longitude: -68.2885,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'House reef of Buddy Dive Resort with dock entry and a gentle slope busy with reef fish, tarpon, and resident green morays. Dived around the clock and a favorite for night dives.',
    highlights: ['Convenient dock entry', 'Resident tarpon', '24-hour house reef'],
    tags: ['shore-dive', 'house-reef', 'beginner-friendly', 'bonaire', 'night-dive'],
    maxDepthM: 30,
  },
  {
    id: 'c-53-felipe-xicotencatl',
    slug: 'c-53-felipe-xicotencatl',
    name: 'C-53 Felipe Xicoténcatl Wreck',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.443,
    longitude: -87.014,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 56 m former minesweeper sunk in 2000 as an artificial reef near Chankanaab, sitting upright on sand at about 24 m. The wreck was prepared with cut access points, and guided penetration of the engine room and corridors is common.',
    highlights: ['Upright intact wreck', 'Prepared penetration routes', 'Resident groupers'],
    tags: ['wreck', 'artificial-reef', 'penetration', 'cozumel', 'caribbean'],
    aliases: ['C-53 Wreck', 'Felipe Xicotencatl'],
    maxDepthM: 24,
    requiredCertification: 'AOW',
    requirementNote: 'Interior penetration should only be done with a guide or wreck training; the exterior suits any certified diver.',
  },
  {
    id: 'c-56-juan-escutia',
    slug: 'c-56-juan-escutia',
    name: 'C-56 Juan Escutia Wreck',
    region: 'Puerto Morelos, Mexico',
    country: 'Mexico',
    latitude: 20.84,
    longitude: -86.84,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A former US minesweeper sunk off Puerto Morelos in 2000 as an artificial reef, now lying in about 30 m and heavily colonized by sponges and corals. Large groupers, rays, and schools of grunts patrol the hull.',
    highlights: ['Intact minesweeper hull', 'Resident groupers', 'Artificial reef growth'],
    tags: ['wreck', 'artificial-reef', 'deep', 'puerto-morelos', 'riviera-maya'],
    aliases: ['C-56 Wreck'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'c-58-general-anaya',
    slug: 'c-58-general-anaya',
    name: 'C-58 General Anaya Wreck',
    region: 'Cancún, Mexico',
    country: 'Mexico',
    latitude: 21.17,
    longitude: -86.74,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A WWII-era minesweeper sunk between Cancún and Isla Mujeres, broken into sections at around 25-27 m by hurricanes. Strong currents sweep the wreck, which shelters huge schools of grunts, rays, and frequent eagle ray fly-bys.',
    highlights: ['Broken wreck sections', 'Eagle rays in current', 'Dense fish schools'],
    tags: ['wreck', 'drift', 'deep', 'cancun', 'isla-mujeres'],
    aliases: ['C-58 Wreck'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
  },
  {
    id: 'cabo-pearce-socorro',
    slug: 'cabo-pearce-socorro',
    name: 'Cabo Pearce (Socorro)',
    region: 'Revillagigedo Islands, Mexico',
    country: 'Mexico',
    latitude: 18.755,
    longitude: -110.9,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A lava-flow finger jutting from Socorro Island\'s east coast, forming a current-swept ridge that acts as a manta and dolphin magnet. Hammerheads, tiger sharks, and seasonal humpbacks pass through the blue.',
    highlights: ['Manta cleaning stations', 'Bottlenose dolphin visits', 'Current-swept lava ridge'],
    tags: ['ridge', 'mantas', 'sharks', 'revillagigedo', 'liveaboard'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Liveaboard-only marine park; advanced certification and experience required.',
  },
  {
    id: 'cades-reef',
    slug: 'cades-reef',
    name: 'Cades Reef',
    region: 'Southwest coast, Antigua',
    country: 'Antigua and Barbuda',
    latitude: 17.03,
    longitude: -61.845,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A two-mile barrier reef along Antigua\'s calm leeward coast, partly within a designated marine park. Elkhorn stands, gorgonians, and dense small fish life spread across multiple mooring sites.',
    highlights: ['two-mile barrier reef', 'elkhorn and gorgonians', 'multiple dive moorings'],
    tags: ['reef', 'barrier-reef', 'antigua', 'marine-park', 'beginner'],
    maxDepthM: 15,
  },
  {
    id: 'candyland-desecheo',
    slug: 'candyland-desecheo',
    name: 'Candyland',
    region: 'Desecheo Island, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.383,
    longitude: -67.487,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Desecheo Island site named for its candy-colored carpet of encrusting sponges and corals across boulder ridges. Clear oceanic water brings turtles, rays and schooling fish over the reef.',
    highlights: ['Vividly colored sponges', 'Boulder ridge terrain', 'Turtles and rays'],
    tags: ['reef', 'desecheo', 'sponges', 'clear-water', 'boat-dive'],
    maxDepthM: 25,
  },
  {
    id: 'cane-bay-wall',
    slug: 'cane-bay-wall',
    name: 'Cane Bay Wall',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.773,
    longitude: -64.812,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'St. Croix\'s famous north shore drop-off begins a short swim from the beach at Cane Bay, plunging from about 12 meters into thousands of feet of blue. Sheer coral-covered faces, sand chutes, and occasional reef sharks define the dive.',
    highlights: ['shore-accessible wall', 'dramatic drop-off', 'reef shark sightings'],
    tags: ['wall', 'shore-dive', 'drop-off', 'usvi', 'deep'],
    maxDepthM: 40,
  },
  {
    id: 'cannon-beach',
    slug: 'cannon-beach',
    name: 'Cannon Beach',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1253,
    longitude: -80.4076,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-entry snorkel site inside John Pennekamp Coral Reef State Park featuring replica Spanish cannons and an anchor placed just off the beach. Ideal for families and first-time snorkelers.',
    highlights: ['Shore entry', 'Replica Spanish cannons', 'Family friendly'],
    tags: ['florida', 'keys', 'snorkel', 'shore-dive', 'pennekamp', 'shallow'],
    maxDepthM: 3,
  },
  {
    id: 'cap-salomon',
    slug: 'cap-salomon',
    name: 'Cap Salomon',
    region: 'Anses d\'Arlet, Martinique',
    country: 'Martinique',
    latitude: 14.522,
    longitude: -61.093,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A rocky cape on Martinique\'s southwest coast where boulder fields and a sponge-covered wall drop toward 40 meters. Turtles graze the shallows while the deeper face hosts barrel sponges and sea fans.',
    highlights: ['boulder fields', 'sponge-covered wall', 'turtle shallows'],
    tags: ['wall', 'reef', 'martinique', 'turtles', 'boat-dive'],
    maxDepthM: 40,
  },
  {
    id: 'captain-dan',
    slug: 'captain-dan',
    name: 'Captain Dan',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.24,
    longitude: -80.07,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 175-foot former Coast Guard buoy tender sunk in 1990 off Pompano Beach. The intact wreck offers open holds and superstructure to explore, with frequent goliath grouper sightings.',
    highlights: ['Ex-buoy tender', 'Open holds', 'Goliath grouper'],
    tags: ['wreck', 'coast guard', 'deep', 'artificial reef', 'pompano'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
  },
  {
    id: 'car-pile-curacao',
    slug: 'car-pile-curacao',
    name: 'Car Pile',
    region: 'Willemstad, Curaçao',
    country: 'Curacao',
    latitude: 12.094,
    longitude: -68.909,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'Artificial reef of wrecked cars, trucks, and construction debris dumped down the slope off Willemstad decades ago, now heavily encrusted and swarming with fish. The pile starts around 18 meters and tumbles well past recreational limits.',
    highlights: ['Encrusted car wrecks', 'Artificial reef fish life', 'Deep debris slope'],
    tags: ['wreck', 'artificial-reef', 'curacao', 'deep', 'boat-dive'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Main structure lies below 18 m and slopes deep; watch depth and sharp metal.',
  },
  {
    id: 'carib-cargo',
    slug: 'carib-cargo',
    name: 'Carib Cargo',
    region: 'Simpson Bay, St. Maarten',
    country: 'Sint Maarten',
    latitude: 18.005,
    longitude: -63.108,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A cargo ship sunk as an artificial reef off St. Maarten\'s south coast, sitting upright in about 21 meters. Southern stingrays gather on the surrounding sand and the wheelhouse remains easily navigable.',
    highlights: ['upright cargo ship', 'stingray gatherings', 'easy wheelhouse pass'],
    tags: ['wreck', 'artificial-reef', 'st-maarten', 'stingrays', 'boat-dive'],
    maxDepthM: 21,
  },
  {
    id: 'carls-hill',
    slug: 'carls-hill',
    name: 'Carl\'s Hill',
    region: 'Klein Bonaire, Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.165,
    longitude: -68.313,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Boat dive on the northwest point of Klein Bonaire beneath the islet\'s only small cliff, with a short vertical wall covered in sponges and fire coral. Named for underwater photographer Captain Don-era resident Carl.',
    highlights: ['Mini-wall on Klein Bonaire', 'Colorful sponge growth', 'Seahorse sightings'],
    tags: ['boat-dive', 'wall', 'klein-bonaire', 'coral', 'photography'],
    maxDepthM: 30,
  },
  {
    id: 'carlisle-bay-wrecks',
    slug: 'carlisle-bay-wrecks',
    name: 'Carlisle Bay Wrecks',
    region: 'Carlisle Bay, Barbados',
    country: 'Barbados',
    latitude: 13.077,
    longitude: -59.615,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A cluster of six shallow shipwrecks — including the WWI-era Berwyn, party boat Bajan Queen, and freighters Eilon and Cornwallis — inside Carlisle Bay Marine Park off Bridgetown. All lie between 3 and 17 meters, divable in a single tank.',
    highlights: ['six wrecks one dive', 'historic Berwyn tug', 'calm sandy marine park'],
    tags: ['wreck', 'multi-wreck', 'barbados', 'marine-park', 'shallow', 'beginner'],
    aliases: ['Berwyn', 'Bajan Queen', 'Eilon', 'Cornwallis'],
    maxDepthM: 17,
  },
  {
    id: 'carlos-rosario-culebra',
    slug: 'carlos-rosario-culebra',
    name: 'Carlos Rosario',
    region: 'Culebra, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.323,
    longitude: -65.331,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A vibrant fringing reef off Carlos Rosario beach on Culebra\'s west side, part of the island\'s protected marine reserve. Dense soft and hard corals in shallow clear water suit divers and snorkelers alike.',
    highlights: ['Protected reserve reef', 'Dense coral coverage', 'Snorkel and dive friendly'],
    tags: ['reef', 'culebra', 'shallow', 'marine-reserve', 'snorkel-friendly'],
    maxDepthM: 14,
  },
  {
    id: 'cartanser-senior',
    slug: 'cartanser-senior',
    name: 'Cartanser Senior',
    region: 'St. Thomas, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.278,
    longitude: -64.897,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A WWII-era steel freighter relocated to the sheltered west side of Buck Island off St. Thomas, resting in shallow water. The broken-open hull is easy to explore and swarms with sergeant majors and grunts.',
    highlights: ['shallow historic freighter', 'easy hull swim-throughs', 'abundant reef fish'],
    tags: ['wreck', 'shallow', 'beginner', 'usvi', 'buck-island'],
    aliases: ['Cartanza Senora', 'Cartanser Sr.'],
    maxDepthM: 12,
  },
  {
    id: 'carval-rock',
    slug: 'carval-rock',
    name: 'Carval Rock',
    region: 'St. John, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.368,
    longitude: -64.795,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An exposed pinnacle east of Congo Cay swept by current that funnels dense schools of silversides, jacks, and barracuda around its walls. Surge and current make it a site for experienced divers when conditions allow.',
    highlights: ['current-swept pinnacle', 'dense baitfish schools', 'pelagic action'],
    tags: ['pinnacle', 'current', 'advanced', 'usvi', 'schooling-fish'],
    maxDepthM: 24,
  },
  {
    id: 'carysfort-reef',
    slug: 'carysfort-reef',
    name: 'Carysfort Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.2217,
    longitude: -80.2117,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The northernmost major reef in the Florida Keys, marked by the historic 1852 Carysfort lighthouse. Extensive spur-and-groove formations and elkhorn restoration areas span from snorkel depths down the fore reef.',
    highlights: ['Historic iron lighthouse', 'Elkhorn coral restoration', 'Extensive spur-and-groove'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'lighthouse', 'spa'],
    aliases: ['Carysfort Lighthouse Reef'],
    maxDepthM: 21,
  },
  {
    id: 'cas-abao',
    slug: 'cas-abao',
    name: 'Cas Abao',
    region: 'Sint Willibrordus, Curaçao',
    country: 'Curacao',
    latitude: 12.2785,
    longitude: -69.089,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'One of Curaçao\'s prettiest beaches with an easy sand entry onto a well-preserved fringing reef. The gentle slope and calm conditions make it a favorite for training and relaxed reef dives.',
    highlights: ['Picture-postcard beach', 'Healthy fringing reef', 'Calm conditions'],
    tags: ['shore-dive', 'beach', 'curacao', 'beginner-friendly', 'coral'],
    maxDepthM: 30,
  },
  {
    id: 'casa-cenote',
    slug: 'casa-cenote',
    name: 'Casa Cenote (Cenote Manatí)',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.2748,
    longitude: -87.3665,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'An open, river-like cenote beside the beach at Tankah where fresh water flows toward the sea through mangrove channels. Its open profile, tarpon, and occasional juvenile crocodile make it a unique easy dive with no overhead.',
    highlights: ['Open mangrove channel', 'Freshwater-saltwater mixing', 'Resident tarpon'],
    tags: ['cenote', 'open-water', 'mangrove', 'tulum', 'beginner'],
    aliases: ['Cenote Manati'],
    maxDepthM: 8,
  },
  {
    id: 'castor-wreck',
    slug: 'castor-wreck',
    name: 'Castor',
    region: 'Boynton Beach, Florida',
    country: 'United States',
    latitude: 26.53,
    longitude: -80.02,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 258-foot freighter scuttled in 2001 off Boynton Beach that has become one of Florida\'s most reliable goliath grouper aggregation sites. In late summer dozens of goliaths stack up around the wreck.',
    highlights: ['Goliath grouper aggregation', 'Large intact freighter', 'Late-summer spectacle'],
    tags: ['wreck', 'goliath grouper', 'deep', 'drift', 'boynton'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
    requirementNote: 'Dived as a drift; current can be strong',
  },
  {
    id: 'catalina-aquarium-dominican-republic',
    slug: 'catalina-aquarium-dominican-republic',
    name: 'Catalina Aquarium',
    region: 'Isla Catalina, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.36,
    longitude: -69.035,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow sand-and-coral plateau off Isla Catalina so rich in fish it is nicknamed the Aquarium. Gentle conditions and 10-12 meter depths make it the standard second dive after the Wall.',
    highlights: ['Fish-packed shallow plateau', 'Gentle easy conditions', 'Ideal training dive'],
    tags: ['reef', 'shallow', 'isla-catalina', 'fish-life', 'beginner-friendly'],
    aliases: ['The Aquarium'],
    maxDepthM: 12,
  },
  {
    id: 'catalina-wall-dominican-republic',
    slug: 'catalina-wall-dominican-republic',
    name: 'Catalina Island Wall',
    region: 'Isla Catalina, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.365,
    longitude: -69.02,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The steep coral wall on the north side of Isla Catalina near La Romana, dropping from a shallow lip past sponges and gorgonians into deep blue water. One of the Dominican Republic\'s most popular boat dives.',
    highlights: ['Steep sponge-covered wall', 'Shallow lip for all levels', 'Clear Caribbean visibility'],
    tags: ['wall', 'isla-catalina', 'la-romana', 'sponges', 'boat-dive'],
    aliases: ['The Wall, Catalina'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Wall continues well below recreational depths.',
  },
  {
    id: 'catalinita-dominican-republic',
    slug: 'catalinita-dominican-republic',
    name: 'Catalinita',
    region: 'Saona/Catalinita, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.155,
    longitude: -68.57,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A small cay off the eastern tip of Saona Island inside Cotubanamá National Park, dived as a current-swept reef known for nurse sharks and passing eagle rays. Usually visited as a full-day trip from Bayahibe.',
    highlights: ['Nurse sharks on the reef', 'Drift along the channel', 'Remote national park setting'],
    tags: ['drift', 'sharks', 'saona', 'national-park', 'day-trip'],
    aliases: ['Isla Catalinita'],
    maxDepthM: 25,
  },
  {
    id: 'cayman-salvage-master',
    slug: 'cayman-salvage-master',
    name: 'Cayman Salvage Master',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4567,
    longitude: -81.7567,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 187-foot steel-hulled buoy tender turned Mariel boatlift vessel, sunk off Key West in 1985 and later righted by hurricane surge. It sits upright in about 28 meters and is a reliable goliath grouper haunt.',
    highlights: ['Upright 187-foot hull', 'Goliath grouper residents', 'Mariel boatlift history'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'deep', 'key-west'],
    aliases: ['Cayman Salvager'],
    maxDepthM: 28,
    requiredCertification: 'AOW',
    requirementNote: 'Main deck near 21 m, sand at 28 m.',
  },
  {
    id: 'cayo-coco-cuba',
    slug: 'cayo-coco-cuba',
    name: 'Cayo Coco',
    region: 'Jardines del Rey, Cuba',
    country: 'Cuba',
    latitude: 22.52,
    longitude: -78.4,
    matchRadiusKm: 10,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'The main resort cay of the Jardines del Rey archipelago on Cuba\'s north coast, with dive sites strung along the second-longest barrier reef in the world. Sites range from shallow coral heads to shark-frequented ledges.',
    highlights: ['North-coast barrier reef', 'Easy resort diving', 'Shark ledges on outer reef'],
    tags: ['destination', 'resort', 'barrier-reef', 'jardines-del-rey', 'sharks'],
  },
  {
    id: 'cayo-diablo-fajardo',
    slug: 'cayo-diablo-fajardo',
    name: 'Cayo Diablo',
    region: 'Fajardo, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.36,
    longitude: -65.55,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A small cay east of Fajardo inside the Cordillera Reefs Natural Reserve, ringed by coral gardens in clear shallow water. Green turtles feed in the surrounding seagrass and coral heads.',
    highlights: ['Nature reserve coral gardens', 'Frequent green turtles', 'Clear shallow water'],
    tags: ['reef', 'fajardo', 'cordillera', 'turtles', 'marine-reserve'],
    maxDepthM: 15,
  },
  {
    id: 'cayo-largo-cuba',
    slug: 'cayo-largo-cuba',
    name: 'Cayo Largo',
    region: 'Canarreos Archipelago, Cuba',
    country: 'Cuba',
    latitude: 21.62,
    longitude: -81.48,
    matchRadiusKm: 10,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A resort island in Cuba\'s Canarreos Archipelago with dozens of dive sites across its barrier reef, from shallow coral gardens to wall dives. Healthy corals, turtles and reef sharks are common on its outer sites.',
    highlights: ['Barrier reef diving', 'Shallow gardens to walls', 'Turtles and reef sharks'],
    tags: ['destination', 'resort', 'barrier-reef', 'turtles', 'canarreos'],
  },
  {
    id: 'cayo-levisa-cuba',
    slug: 'cayo-levisa-cuba',
    name: 'Cayo Levisa',
    region: 'Pinar del Río, Cuba',
    country: 'Cuba',
    latitude: 22.88,
    longitude: -83.55,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A small mangrove-fringed cay off Cuba\'s northwest coast with a single eco-resort and quiet coral sites along the Colorados Archipelago reef. Known for black coral, big sponges and very light dive traffic.',
    highlights: ['Quiet uncrowded reefs', 'Black coral stands', 'Small-island eco resort'],
    tags: ['destination', 'reef', 'remote', 'pinar-del-rio', 'eco-resort'],
  },
  {
    id: 'cedral-wall',
    slug: 'cedral-wall',
    name: 'Cedral Wall',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.36,
    longitude: -87.03,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A brisk drift dive along a sloping wall off El Cedral, known for some of the strongest reliable currents on Cozumel\'s mid reefs. Nurse sharks, grouper, and schooling snapper are common along the ledges.',
    highlights: ['Fast drift', 'Nurse sharks under ledges', 'Schooling snapper'],
    tags: ['drift', 'wall', 'current', 'cozumel', 'caribbean'],
    maxDepthM: 30,
  },
  {
    id: 'cenote-angelita',
    slug: 'cenote-angelita',
    name: 'Cenote Angelita',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.135,
    longitude: -87.578,
    matchRadiusKm: 3,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A deep circular sinkhole south of Tulum where a dense hydrogen sulfide layer at about 30 m creates the illusion of an underwater river with tree branches emerging from the mist. It is a deep, guided dive to around 30-40 m.',
    highlights: ['Underwater river illusion', 'Hydrogen sulfide cloud', 'Sunken tree island'],
    tags: ['cenote', 'deep', 'sinkhole', 'tulum', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deep guided cenote dive below the sulfide layer; Advanced Open Water required.',
  },
  {
    id: 'cenote-calavera',
    slug: 'cenote-calavera',
    name: 'Cenote Calavera',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.228,
    longitude: -87.451,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A skull-shaped sinkhole near Tulum entered by a jump through one of three openings, with a pronounced halocline swirling around 10-15 m. The single chamber and shifting light beams make it a moody, memorable cavern dive.',
    highlights: ['Jump entry', 'Dramatic halocline', 'Skull-shaped openings'],
    tags: ['cenote', 'cavern', 'halocline', 'tulum', 'freshwater'],
    aliases: ['Temple of Doom'],
    maxDepthM: 16,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-carwash',
    slug: 'cenote-carwash',
    name: 'Cenote Carwash (Aktun Ha)',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.273,
    longitude: -87.489,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'An open pond-like cenote on the Tulum-Cobá road, named for the taxis once washed here, with lily pads and seasonal algae blooms creating a garden-like entrance. The cavern zone beyond holds fossils and decorated passages.',
    highlights: ['Lily pad gardens', 'Seasonal light effects', 'Decorated cavern zone'],
    tags: ['cenote', 'cavern', 'freshwater', 'tulum', 'photography'],
    aliases: ['Aktun Ha'],
    maxDepthM: 15,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-chac-mool',
    slug: 'cenote-chac-mool',
    name: 'Cenote Chac Mool',
    region: 'Puerto Aventuras, Mexico',
    country: 'Mexico',
    latitude: 20.508,
    longitude: -87.253,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A popular cavern dive near Puerto Aventuras known for a strong halocline, a large air dome, and afternoon laser-like light beams. Its guided line passes fossilized shells and impressive stalactite curtains.',
    highlights: ['Air dome surface', 'Laser light beams', 'Strong halocline'],
    tags: ['cenote', 'cavern', 'halocline', 'riviera-maya', 'formations'],
    maxDepthM: 14,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-chikin-ha',
    slug: 'cenote-chikin-ha',
    name: 'Cenote Chikin Ha',
    region: 'Puerto Aventuras, Mexico',
    country: 'Mexico',
    latitude: 20.478,
    longitude: -87.276,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A cavern traverse between two cenotes in the Chikin Ha park, following a shallow line through blue passages and a well-defined halocline toward the \'Rainbow\' cenote. Clear water and easy depths suit newer cenote divers.',
    highlights: ['Two-cenote traverse', 'Rainbow light effects', 'Defined halocline'],
    tags: ['cenote', 'cavern', 'halocline', 'riviera-maya', 'freshwater'],
    maxDepthM: 14,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-cristalino',
    slug: 'cenote-cristalino',
    name: 'Cenote Cristalino',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.556,
    longitude: -87.188,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A bright, open cenote south of Playa del Carmen with a short overhang and exceptionally clear shallow water. It is used for cavern intros, training, and relaxed photography dives.',
    highlights: ['Crystal-clear shallows', 'Easy cavern intro', 'Photography-friendly light'],
    tags: ['cenote', 'shallow', 'freshwater', 'playa-del-carmen', 'beginner'],
    maxDepthM: 8,
    requirementNote: 'Open-water friendly; any cavern-zone penetration is guided along the line.',
  },
  {
    id: 'cenote-dos-ojos',
    slug: 'cenote-dos-ojos',
    name: 'Cenote Dos Ojos',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.3244,
    longitude: -87.3908,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'One of the world\'s most famous cavern dives, with two sinkhole \'eyes\' connected by decorated passages in the Sac Actun system. Guided divers follow the Barbie Line or the darker Bat Cave line through crystal-clear water and dense formations.',
    highlights: ['Barbie Line and Bat Cave routes', 'Spectacular stalactites', 'Gin-clear water'],
    tags: ['cenote', 'cavern', 'freshwater', 'tulum', 'formations'],
    aliases: ['Two Eyes Cenote'],
    maxDepthM: 10,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-dreamgate',
    slug: 'cenote-dreamgate',
    name: 'Cenote Dreamgate',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.313,
    longitude: -87.4,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'One of the most delicately decorated cavern dives in the Riviera Maya, with dense curtains of fragile stalactites in near-still water. Excellent buoyancy control is mandatory, and groups are kept small.',
    highlights: ['Extremely dense formations', 'Low-light atmosphere', 'Small guided groups'],
    tags: ['cenote', 'cavern', 'formations', 'tulum', 'advanced'],
    maxDepthM: 10,
    requirementNote: 'Guided cavern dive for experienced divers with proven buoyancy control; full cave certification required beyond the cavern line.',
  },
  {
    id: 'cenote-kin-ha',
    slug: 'cenote-kin-ha',
    name: 'Cenote Kin Ha',
    region: 'Puerto Morelos, Mexico',
    country: 'Mexico',
    latitude: 20.78,
    longitude: -87,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A deep collapsed sinkhole on the Ruta de los Cenotes reached via a long stair descent, dropping well past recreational depths in a single dark chamber. Guided dives explore the shaft and boulder piles in exceptionally still water.',
    highlights: ['Deep dark chamber', 'Dramatic entry stairs', 'Still clear water'],
    tags: ['cenote', 'deep', 'sinkhole', 'puerto-morelos', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deep guided cenote dive; Advanced Open Water required.',
  },
  {
    id: 'cenote-nicte-ha',
    slug: 'cenote-nicte-ha',
    name: 'Cenote Nicte-Ha',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.32,
    longitude: -87.39,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A small, sunlit cenote in the Dos Ojos park covered in water lilies, offering a very shallow dive among light beams and aquatic plants. It is a gentle option often paired with deeper cenotes nearby.',
    highlights: ['Water lily gardens', 'Sunbeam-filled shallows', 'Relaxed easy dive'],
    tags: ['cenote', 'shallow', 'freshwater', 'tulum', 'photography'],
    maxDepthM: 8,
    requirementNote: 'Mostly open water; short cavern sections are guided along the line.',
  },
  {
    id: 'cenote-ponderosa',
    slug: 'cenote-ponderosa',
    name: 'Cenote Ponderosa (Jardín del Edén)',
    region: 'Puerto Aventuras, Mexico',
    country: 'Mexico',
    latitude: 20.497,
    longitude: -87.263,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A wide, open cenote also known as Jardín del Edén, offering a bright cavern traverse toward neighboring Cenote Coral with a shimmering halocline en route. Its open-water pool makes it one of the easiest cenote introductions.',
    highlights: ['Bright open pool', 'Traverse toward Cenote Coral', 'Shimmering halocline'],
    tags: ['cenote', 'cavern', 'halocline', 'riviera-maya', 'beginner-friendly'],
    aliases: ['Jardin del Eden', 'El Eden'],
    maxDepthM: 15,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-taak-bi-ha',
    slug: 'cenote-taak-bi-ha',
    name: 'Cenote Taak Bi Ha',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.33,
    longitude: -87.395,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A hidden, fully covered cenote within the Dos Ojos park, entered down a stairway into a dome filled with turquoise water and white stalactites. The guided cavern line winds through intensely decorated shallow passages.',
    highlights: ['Hidden cave-dome entrance', 'White stalactite forests', 'Turquoise still water'],
    tags: ['cenote', 'cavern', 'formations', 'tulum', 'freshwater'],
    maxDepthM: 12,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-tajma-ha',
    slug: 'cenote-tajma-ha',
    name: 'Cenote Tajma Ha',
    region: 'Puerto Aventuras, Mexico',
    country: 'Mexico',
    latitude: 20.464,
    longitude: -87.288,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A varied cavern dive connecting several sinkholes, including the light-filled Sugar Bowl room where beams pierce the darkness on sunny days. Haloclines, fossils, and dramatic rock architecture pack the guided circuit.',
    highlights: ['Sugar Bowl light beams', 'Multiple connected rooms', 'Fossil-rich walls'],
    tags: ['cenote', 'cavern', 'halocline', 'riviera-maya', 'photography'],
    aliases: ['Taj Mahal Cenote'],
    maxDepthM: 15,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'cenote-zapote',
    slug: 'cenote-zapote',
    name: 'Cenote Zapote (Hell\'s Bells)',
    region: 'Puerto Morelos, Mexico',
    country: 'Mexico',
    latitude: 20.756,
    longitude: -87.036,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A deep, narrow cenote on the Ruta de los Cenotes famous for its unique bell-shaped speleothems, the \'Hell\'s Bells,\' hanging below 28 m. The dive descends a dark shaft past a sulfide layer to view the bells.',
    highlights: ['Unique bell formations', 'Dark deep shaft', 'Sulfide layer'],
    tags: ['cenote', 'deep', 'formations', 'puerto-morelos', 'advanced'],
    aliases: ['Hell\'s Bells'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Deep guided cenote dive; Advanced Open Water and good buoyancy control required near the fragile bells.',
  },
  {
    id: 'champagne-reef',
    slug: 'champagne-reef',
    name: 'Champagne Reef',
    region: 'Soufriere-Scotts Head Marine Reserve, Dominica',
    country: 'Dominica',
    latitude: 15.2465,
    longitude: -61.3745,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Volcanic vents release streams of warm bubbles through the shallow reef here, letting divers swim through natural champagne. The geothermal shallows and adjacent reef slope host seahorses, squid, and juvenile fish.',
    highlights: ['volcanic bubble streams', 'geothermal shallows', 'seahorse sightings'],
    tags: ['reef', 'volcanic', 'dominica', 'beginner', 'snorkel', 'unique'],
    maxDepthM: 15,
  },
  {
    id: 'chankanaab-reef',
    slug: 'chankanaab-reef',
    name: 'Chankanaab Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.437,
    longitude: -87.018,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A gentle shallow reef off Chankanaab park, used for training dives, night dives, and easy drifts. Sandy patches between coral heads shelter octopus, toadfish, and juvenile fish.',
    highlights: ['Easy training conditions', 'Night diving', 'Octopus and toadfish'],
    tags: ['reef', 'shallow', 'night-dive', 'cozumel', 'beginner'],
    maxDepthM: 14,
  },
  {
    id: 'charles-l-brown',
    slug: 'charles-l-brown',
    name: 'Charles L. Brown',
    region: 'St. Eustatius',
    country: 'Caribbean Netherlands',
    latitude: 17.457,
    longitude: -62.988,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 320-foot cable-laying ship scuttled off Statia in 2003, lying on its port side in about 30 meters. The immense hull, open cable decks, and visiting pelagics make it the island\'s premier wreck dive.',
    highlights: ['320-foot cable ship', 'massive open decks', 'pelagic visitors'],
    tags: ['wreck', 'deep', 'statia', 'artificial-reef', 'advanced'],
    aliases: ['Charlie Brown'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'charles-spring',
    slug: 'charles-spring',
    name: 'Charles Spring',
    region: 'Live Oak, Florida',
    country: 'United States',
    latitude: 30.169,
    longitude: -83.23,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A modest spring on the Suwannee River at a county park west of Live Oak, with a small cave behind twin basins. Locals swim the basin while trained divers explore the short overhead section.',
    highlights: ['County park access', 'Twin basins', 'Short cave section'],
    tags: ['spring', 'cave', 'suwannee', 'swimming', 'north-florida'],
    maxDepthM: 9,
    requiredCertification: 'Cavern',
    requirementNote: 'Overhead training required beyond the basin',
  },
  {
    id: 'chassahowitzka-springs',
    slug: 'chassahowitzka-springs',
    name: 'Chassahowitzka Springs',
    region: 'Chassahowitzka, Florida',
    country: 'United States',
    latitude: 28.7147,
    longitude: -82.5754,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'The headsprings of the Chassahowitzka River, including the famed Seven Sisters vents and a narrow crevice known as The Crack. Snorkelers and paddlers explore the clear, shallow boils.',
    highlights: ['Seven Sisters vents', 'The Crack crevice', 'Wild river paddling'],
    tags: ['spring', 'river', 'snorkel', 'kayak', 'nature-coast'],
    aliases: ['Seven Sisters Springs'],
    maxDepthM: 5,
  },
  {
    id: 'cheeca-rocks',
    slug: 'cheeca-rocks',
    name: 'Cheeca Rocks',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.9036,
    longitude: -80.6153,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow inshore patch reef and Sanctuary Preservation Area off Upper Matecumbe Key with some of the healthiest boulder coral cover in the Keys. A long-term NOAA coral monitoring site.',
    highlights: ['Exceptional boulder coral', 'NOAA monitoring site', 'Snorkel-depth patch reef'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'spa', 'snorkel'],
    maxDepthM: 6,
  },
  {
    id: 'cheeseburger-reef-grand-cayman',
    slug: 'cheeseburger-reef-grand-cayman',
    name: 'Cheeseburger Reef',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.298,
    longitude: -81.387,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow George Town harbour reef nicknamed for the burger restaurant that once stood onshore. Coral heads riddled with swim-throughs attract tarpon and make an easy shore-accessible dive.',
    highlights: ['Shore-accessible reef', 'Resident tarpon', 'Shallow swim-throughs'],
    tags: ['shore-dive', 'shallow', 'george-town', 'swim-throughs', 'snorkel-friendly'],
    aliases: ['Soto\'s Central'],
    maxDepthM: 12,
  },
  {
    id: 'cherokee-sink',
    slug: 'cherokee-sink',
    name: 'Cherokee Sink',
    region: 'Wakulla Springs State Park, Florida',
    country: 'United States',
    latitude: 30.2286,
    longitude: -84.3238,
    matchRadiusKm: 3,
    siteType: 'blue-hole',
    difficulty: 'Intermediate',
    summary: 'A large open sinkhole lake within Wakulla Springs State Park, ringed by limestone bluffs. Swimming access is managed by the park, and the open-water basin has been a longtime local dive spot.',
    highlights: ['Open sinkhole lake', 'Limestone bluff walls', 'State park setting'],
    tags: ['sinkhole', 'freshwater', 'wakulla', 'state-park', 'open-water'],
    maxDepthM: 18,
    requiredCertification: 'AOW',
    requirementNote: 'Check current park rules; access and diving permissions vary',
  },
  {
    id: 'chien-tong',
    slug: 'chien-tong',
    name: 'Chien Tong',
    region: 'St. Eustatius',
    country: 'Caribbean Netherlands',
    latitude: 17.47,
    longitude: -62.99,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 170-foot Taiwanese fishing vessel sunk upright in Statia\'s marine park, famous as a nighttime turtle dormitory. By day the intact deck and holds host schools of grunts and resident morays.',
    highlights: ['upright fishing vessel', 'sleeping turtles at night', 'intact deck structures'],
    tags: ['wreck', 'statia', 'turtles', 'night-dive', 'marine-park'],
    maxDepthM: 24,
  },
  {
    id: 'chikuzen',
    slug: 'chikuzen',
    name: 'Chikuzen',
    region: 'North of Tortola, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.598,
    longitude: -64.523,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 246-foot Japanese refrigeration vessel that sank in 1981 miles north of the Virgin Islands, now an isolated oasis on a featureless sand plain at 24 meters. Its remoteness draws big animals, from schooling jacks and rays to occasional sharks.',
    highlights: ['remote open-ocean wreck', 'big pelagic encounters', 'huge fish schools'],
    tags: ['wreck', 'offshore', 'pelagics', 'bvi', 'advanced'],
    maxDepthM: 24,
    requiredCertification: 'AOW',
    requirementNote: 'Open-ocean site with potential current; long boat ride and conditions-dependent.',
  },
  {
    id: 'chileno-bay',
    slug: 'chileno-bay',
    name: 'Chileno Bay',
    region: 'Cabo San Lucas Corridor, Mexico',
    country: 'Mexico',
    latitude: 22.946,
    longitude: -109.803,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A gently sloping boulder reef in a protected corridor bay, popular for training and easy shore-style diving. Sea turtles, rays, and dense reef fish gather over the rock fingers.',
    highlights: ['Gentle boulder reef', 'Sea turtles', 'Protected conditions'],
    tags: ['reef', 'bay', 'beginner', 'los-cabos', 'sea-of-cortez'],
    maxDepthM: 18,
  },
  {
    id: 'chippewa',
    slug: 'chippewa',
    name: 'Chippewa',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.08,
    longitude: -85.73,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A steel tugboat scuttled off Panama City as part of the local artificial reef system. Sitting in deeper water, the compact wreck attracts amberjack, barracuda, and the occasional goliath grouper.',
    highlights: ['Deep tug wreck', 'Amberjack schools', 'Compact and intact'],
    tags: ['wreck', 'tugboat', 'deep', 'panama city', 'advanced'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'cienfuegos-wreck',
    slug: 'cienfuegos-wreck',
    name: 'Cienfuegos Wreck',
    region: 'Eleuthera, Bahamas',
    country: 'Bahamas',
    latitude: 25.573,
    longitude: -76.758,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered remains of an American passenger steamer that struck the Devil\'s Backbone in 1895, now spread across shallow reef off North Eleuthera. Boilers, plates, and machinery lie among coral heads in roughly ten meters.',
    highlights: ['1895 steamer wreckage', 'Boilers and machinery', 'Combined wreck-and-reef dive'],
    tags: ['wreck', 'history', 'eleuthera', 'shallow', 'reef'],
    maxDepthM: 11,
  },
  {
    id: 'city-of-washington',
    slug: 'city-of-washington',
    name: 'City of Washington',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.146,
    longitude: -80.256,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered remains of an 1877 passenger-freight steamer that wrecked on Elbow Reef in 1917. The flattened hull plates and keel sections sit in shallow water and are part of the Shipwreck Trail.',
    highlights: ['Shipwreck Trail site', 'Shallow historic wreckage', 'Resident nurse sharks'],
    tags: ['florida', 'keys', 'wreck', 'shipwreck-trail', 'historic', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'cliff-bonaire',
    slug: 'cliff-bonaire',
    name: 'Cliff',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.1725,
    longitude: -68.29,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Small wall dive in front of Hamlet Oasis, one of the few mini-walls on Bonaire\'s leeward coast, dropping from about 6 to 25 meters. Tarpon, frogfish, and seahorses are regularly spotted.',
    highlights: ['Mini-wall close to shore', 'Frogfish and seahorses', 'Easy access'],
    tags: ['shore-dive', 'wall', 'macro', 'bonaire', 'night-dive'],
    maxDepthM: 30,
  },
  {
    id: 'coffins-patch',
    slug: 'coffins-patch',
    name: 'Coffins Patch',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.683,
    longitude: -80.962,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A cluster of six shallow patch reefs east of Marathon protected as a Sanctuary Preservation Area. Pillar coral stands and elkhorn remnants shelter abundant tropicals across the spurs.',
    highlights: ['Pillar coral colonies', 'Six distinct patches', 'Sanctuary Preservation Area'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'spa', 'shallow'],
    aliases: ['Coffin\'s Patch'],
    maxDepthM: 8,
  },
  {
    id: 'columbia-shallows',
    slug: 'columbia-shallows',
    name: 'Columbia Shallows',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.3,
    longitude: -87.025,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow coral garden inshore of Columbia Wall, popular for long, relaxed dives and as a second-tank site. Healthy star and brain corals host turtles, nurse sharks, and dense schools of grunts.',
    highlights: ['Shallow coral gardens', 'Long bottom times', 'Frequent turtles'],
    tags: ['reef', 'shallow', 'coral', 'cozumel', 'turtles'],
    aliases: ['Colombia Shallows'],
    maxDepthM: 12,
  },
  {
    id: 'columbia-wall',
    slug: 'columbia-wall',
    name: 'Columbia Wall',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.31,
    longitude: -87.03,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A deep wall dive on Cozumel\'s southern end where enormous coral pillars rise from the drop-off into blue water. Turtles, eagle rays, and occasional sharks cruise the wall in the steady current.',
    highlights: ['Towering coral pillars', 'Turtles and eagle rays', 'Dramatic drop-off'],
    tags: ['wall', 'drift', 'coral', 'cozumel', 'pelagics'],
    aliases: ['Colombia Wall', 'Columbia Deep'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
  },
  {
    id: 'columbus-point-cat-island',
    slug: 'columbus-point-cat-island',
    name: 'Columbus Point',
    region: 'Cat Island, Bahamas',
    country: 'Bahamas',
    latitude: 24.135,
    longitude: -75.4,
    matchRadiusKm: 7,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Wall diving off the southeastern tip of Cat Island where the drop-off swings close to shore near Port Howe. Strong oceanic exposure brings sharks, jacks, and dense sponge growth to the ledges.',
    highlights: ['Close-to-shore wall', 'Oceanic fish traffic', 'Sponge-heavy ledges'],
    tags: ['wall', 'cat-island', 'drop-off', 'sharks', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'conception-island-wall',
    slug: 'conception-island-wall',
    name: 'Conception Island Wall',
    region: 'Long Island, Bahamas',
    country: 'Bahamas',
    latitude: 23.84,
    longitude: -75.14,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A pristine wall off uninhabited Conception Island, a protected national park between Long Island and Cat Island reached by liveaboard or long day trip. Untouched corals, sharks, and superb visibility reward the remote crossing.',
    highlights: ['Untouched protected wall', 'Remote national park', 'Sharks and pelagics'],
    tags: ['wall', 'marine-park', 'remote', 'long-island', 'liveaboard'],
    maxDepthM: 40,
  },
  {
    id: 'conch-reef',
    slug: 'conch-reef',
    name: 'Conch Reef',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.95,
    longitude: -80.4567,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Sanctuary Preservation Area on the Key Largo-Islamorada line where the reef shelf steps down toward a deeper wall. Adjacent waters host the Aquarius undersea research habitat in a restricted zone.',
    highlights: ['Terraced reef to deeper wall', 'Near Aquarius habitat zone', 'Barrel sponges'],
    tags: ['florida', 'keys', 'reef', 'spa', 'wall'],
    maxDepthM: 20,
  },
  {
    id: 'congo-cay',
    slug: 'congo-cay',
    name: 'Congo Cay',
    region: 'St. John, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.366,
    longitude: -64.812,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A narrow rocky cay between St. John and Jost Van Dyke whose boulder-strewn ledges are patrolled by turtles, rays, and passing pelagics. The site is usually dived along its north or east ends where the rock face drops onto sand.',
    highlights: ['boulder ledges', 'green turtles', 'eagle ray flybys'],
    tags: ['reef', 'boulders', 'turtles', 'usvi', 'boat-dive'],
    maxDepthM: 20,
  },
  {
    id: 'content-keys',
    slug: 'content-keys',
    name: 'Content Keys',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.79,
    longitude: -81.49,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A group of mangrove islets and shallow hardbottom on the Gulf side of the Lower Keys, dived and snorkeled when ocean-side conditions blow out. Sponge flats and ledges shelter lobster and juvenile fish.',
    highlights: ['Gulf-side shelter', 'Sponge and ledge habitat', 'Windy-day alternative'],
    tags: ['florida', 'keys', 'reef', 'gulf-side', 'snorkel', 'shallow'],
    maxDepthM: 5,
  },
  {
    id: 'convict-spring',
    slug: 'convict-spring',
    name: 'Convict Spring',
    region: 'Mayo, Florida',
    country: 'United States',
    latitude: 30.064,
    longitude: -83.153,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A small, clear spring on the Suwannee River at the River Rendezvous resort near Mayo. Its shallow open basin makes it a relaxed open-water and training dive with on-site facilities.',
    highlights: ['Resort-based spring dive', 'Shallow protected basin', 'Good for training'],
    tags: ['spring', 'open-water', 'suwannee', 'training', 'freshwater'],
    maxDepthM: 9,
  },
  {
    id: 'coral-gardens-grand-turk',
    slug: 'coral-gardens-grand-turk',
    name: 'Coral Gardens (Grand Turk)',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.47,
    longitude: -71.15,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A gently sloping coral terrace on Grand Turk\'s leeward wall line where dense hard and soft corals shelter abundant reef fish. In winter, humpback whale song is often audible as the whales migrate through the Turks Island Passage.',
    highlights: ['Lush coral terrace', 'Winter whale song', 'Relaxed conditions'],
    tags: ['reef', 'grand-turk', 'coral', 'whales', 'beginner-friendly'],
    maxDepthM: 25,
  },
  {
    id: 'cosgrove-shoal',
    slug: 'cosgrove-shoal',
    name: 'Cosgrove Shoal',
    region: 'Marquesas Keys, Florida',
    country: 'United States',
    latitude: 24.4577,
    longitude: -82.1852,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A remote lit shoal on the reef edge south of the Marquesas Keys, marking miles of wild ledge and hardbottom. Sharks, big grouper, and pelagics patrol its drop toward deep water.',
    highlights: ['Remote frontier diving', 'Shark and pelagic action', 'Historic iron light tower'],
    tags: ['florida', 'keys', 'reef', 'remote', 'ledge', 'marquesas'],
    maxDepthM: 15,
  },
  {
    id: 'cottrell-key',
    slug: 'cottrell-key',
    name: 'Cottrell Key',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.59,
    longitude: -81.906,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A Gulf-side mangrove key northwest of Key West whose shallow ledges and sponge flats offer sheltered diving when the Atlantic side is rough. A former WWII seaplane base area rich in small critters.',
    highlights: ['Gulf-side shelter', 'Sponge and ledge macro life', 'Calm shallow water'],
    tags: ['florida', 'keys', 'reef', 'gulf-side', 'snorkel', 'key-west'],
    maxDepthM: 6,
  },
  {
    id: 'cow-and-calf-rocks',
    slug: 'cow-and-calf-rocks',
    name: 'Cow and Calf Rocks',
    region: 'St. Thomas, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.295,
    longitude: -64.833,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Two rocks barely breaking the surface southeast of St. Thomas hide a maze of swim-throughs, arches, and ledges known as the Champagne Cork and Cathedral. Shallow depths and abundant sponge growth make it one of the island\'s most popular boat dives.',
    highlights: ['swim-throughs and arches', 'cathedral-like caverns', 'colorful sponges'],
    tags: ['reef', 'swim-through', 'boat-dive', 'usvi', 'shallow'],
    aliases: ['Cow & Calf'],
    maxDepthM: 14,
  },
  {
    id: 'cow-spring',
    slug: 'cow-spring',
    name: 'Cow Spring',
    region: 'Luraville, Florida',
    country: 'United States',
    latitude: 30.121,
    longitude: -83.181,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'An NSS-CDS-managed spring near Luraville with a deceptively small basin over a significant cave system. Access is restricted to qualifying cave divers under the conservancy\'s rules.',
    highlights: ['NSS-CDS managed preserve', 'Pristine cave passage', 'Small basin, big system'],
    tags: ['cave', 'spring', 'suwannee', 'restricted-access', 'overhead'],
    maxDepthM: 30,
    requiredCertification: 'FullCave',
    requirementNote: 'NSS-CDS access rules apply; full cave certification and permit required',
  },
  {
    id: 'crash-boat-aguadilla',
    slug: 'crash-boat-aguadilla',
    name: 'Crash Boat',
    region: 'Aguadilla, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.458,
    longitude: -67.163,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Puerto Rico\'s most popular shore dive, centered on the coral-encrusted pilings of an old rescue-boat pier at Playa Crash Boat in Aguadilla. The pillars swarm with schooling fish, frogfish and seahorses in just a few meters of water.',
    highlights: ['Coral-covered pier pilings', 'Frogfish and seahorses', 'Easy beach entry'],
    tags: ['shore-dive', 'pier', 'aguadilla', 'macro', 'shallow'],
    aliases: ['Playa Crash Boat', 'Crashboat Pier'],
    maxDepthM: 10,
  },
  {
    id: 'creole-rock',
    slug: 'creole-rock',
    name: 'Creole Rock',
    region: 'Grand Case, St. Martin',
    country: 'Saint Martin',
    latitude: 18.118,
    longitude: -63.062,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected rocky islet at the mouth of Grand Case Bay on the French side of the island, ringed by boulders and small coral heads in under 12 meters. It is the go-to training and snorkeling site of St. Martin\'s marine reserve.',
    highlights: ['marine reserve islet', 'easy boulder reef', 'training-friendly depths'],
    tags: ['reef', 'marine-reserve', 'st-martin', 'beginner', 'snorkel'],
    maxDepthM: 12,
  },
  {
    id: 'croaker-hole',
    slug: 'croaker-hole',
    name: 'Croaker Hole',
    region: 'Welaka, Florida',
    country: 'United States',
    latitude: 29.425,
    longitude: -81.641,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A submerged first-magnitude spring vent on the bottom of Little Lake George in the St. Johns River near Welaka. Dark tannic water, boat traffic, and current make this boat-access dive an advanced undertaking.',
    highlights: ['Underwater river spring', 'Boat-access dive', 'Big flow from a hidden vent'],
    tags: ['spring', 'river', 'st-johns', 'low-visibility', 'boat-access'],
    maxDepthM: 18,
    requiredCertification: 'AOW',
    requirementNote: 'Experienced divers with a dive flag and boat support; near-zero ambient light',
  },
  {
    id: 'crocker-reef',
    slug: 'crocker-reef',
    name: 'Crocker Reef',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.9083,
    longitude: -80.5267,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A bank reef off Islamorada whose outer edge drops along Crocker Wall toward 27 meters. Sponge-covered slopes and passing current make it a favorite deeper reef and drift dive.',
    highlights: ['Crocker Wall drop-off', 'Sponge-covered slope', 'Drift diving in current'],
    tags: ['florida', 'keys', 'reef', 'wall', 'drift'],
    aliases: ['Crocker Wall'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
    requirementNote: 'Outer wall section exceeds 18 m; AOW recommended for the deep side.',
  },
  {
    id: 'cueva-de-los-peces-cuba',
    slug: 'cueva-de-los-peces-cuba',
    name: 'Cueva de los Peces',
    region: 'Bay of Pigs, Cuba',
    country: 'Cuba',
    latitude: 22.166,
    longitude: -81.152,
    matchRadiusKm: 4,
    siteType: 'blue-hole',
    difficulty: 'Intermediate',
    summary: 'A flooded tectonic cenote beside the Bay of Pigs coastal road, dropping roughly 70 meters deep just meters from the sea. Divers can explore the sheer-sided freshwater pool and then cross the road to dive the ocean reef.',
    highlights: ['70-meter deep cenote', 'Freshwater and reef in one stop', 'Dramatic sheer rock walls'],
    tags: ['cenote', 'sinkhole', 'bay-of-pigs', 'freshwater', 'deep'],
    aliases: ['Fish Cave'],
    maxDepthM: 70,
    requirementNote: 'Recreational divers should stay within training depth limits; the sinkhole far exceeds them.',
  },
  {
    id: 'cumbers-caves-little-cayman',
    slug: 'cumbers-caves-little-cayman',
    name: 'Cumber\'s Caves',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.698,
    longitude: -80.09,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Bloody Bay Wall site where a series of chutes and cave-like passages drop from the shallow reef shelf out onto the sheer face. Turtles and groupers are regulars along the wall.',
    highlights: ['Chutes through the wall lip', 'Friendly Nassau groupers', 'Turtles on the wall'],
    tags: ['wall', 'bloody-bay', 'swim-throughs', 'turtles', 'marine-park'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Passages exit onto the deep wall.',
  },
  {
    id: 'current-cut',
    slug: 'current-cut',
    name: 'Current Cut',
    region: 'Eleuthera, Bahamas',
    country: 'Bahamas',
    latitude: 25.407,
    longitude: -76.79,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A narrow channel between North Eleuthera and Current Island where tidal flow rockets divers along at several knots past rays, sharks, and schooling jacks. Regularly ranked among the world\'s great drift dives despite its modest depth.',
    highlights: ['High-speed tidal drift', 'Eagle rays and sharks in the flow', 'Short thrilling runs'],
    tags: ['drift', 'current', 'eleuthera', 'channel', 'adrenaline'],
    maxDepthM: 10,
    requirementNote: 'Timed to the tide; boat pickup at the far end is essential.',
  },
  {
    id: 'cypress-springs',
    slug: 'cypress-springs',
    name: 'Cypress Spring',
    region: 'Vernon, Florida',
    country: 'United States',
    latitude: 30.6585,
    longitude: -85.6842,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A first-magnitude spring feeding Holmes Creek, reached by kayak or paddleboard. The clear, shallow basin makes it a favorite swim and snorkel stop with a small vent divers occasionally explore.',
    highlights: ['Paddle-in access via Holmes Creek', 'Brilliant blue boil', 'Shallow sandy basin'],
    tags: ['spring', 'snorkel', 'panhandle', 'kayak', 'freshwater'],
    maxDepthM: 8,
  },
  {
    id: 'daaibooi',
    slug: 'daaibooi',
    name: 'Daaibooi Bay',
    region: 'Sint Willibrordus, Curaçao',
    country: 'Curacao',
    latitude: 12.208,
    longitude: -69.083,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Quiet local beach south of Porto Mari with a sheltered sandy entry and reef slopes along both arms of the bay. A relaxed, uncrowded alternative to the busier west coast beaches.',
    highlights: ['Sheltered bay', 'Uncrowded', 'Reef on both sides'],
    tags: ['shore-dive', 'beach', 'curacao', 'beginner-friendly', 'coral'],
    maxDepthM: 30,
  },
  {
    id: 'dalila-reef',
    slug: 'dalila-reef',
    name: 'Dalila Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.375,
    longitude: -87.02,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A mid-depth strip reef between San Francisco and Paso del Cedral with scattered coral heads over sand. Turtles, nurse sharks, and splendid toadfish are frequently spotted here.',
    highlights: ['Splendid toadfish', 'Turtles on the reef', 'Relaxed drift'],
    tags: ['drift', 'reef', 'coral', 'cozumel', 'turtles'],
    aliases: ['Delilah Reef'],
    maxDepthM: 20,
  },
  {
    id: 'danglebens-pinnacles',
    slug: 'danglebens-pinnacles',
    name: 'Dangleben\'s Pinnacles',
    region: 'Soufriere Bay, Dominica',
    country: 'Dominica',
    latitude: 15.22,
    longitude: -61.378,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A cluster of five coral-covered pinnacles on the western edge of Soufriere Bay, swept by gentle current that feeds thick soft coral and sponge growth. Schools of Creole wrasse and boga stream between the peaks.',
    highlights: ['five-pinnacle cluster', 'creole wrasse streams', 'lush sponge cover'],
    tags: ['pinnacle', 'dominica', 'marine-reserve', 'current', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'danny-mccauley-memorial-reef',
    slug: 'danny-mccauley-memorial-reef',
    name: 'Danny McCauley Memorial Reef',
    region: 'Riviera Beach, Florida',
    country: 'United States',
    latitude: 26.74,
    longitude: -80,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A freighter scuttled in 2008 as a memorial artificial reef in the Palm Beach County wreck corridor. The upright hull is dived as a drift and has developed thick encrusting growth.',
    highlights: ['Memorial wreck', 'Upright hull', 'Drift dive'],
    tags: ['wreck', 'memorial', 'artificial reef', 'drift', 'palm beach'],
    maxDepthM: 26,
  },
  {
    id: 'davis-reef',
    slug: 'davis-reef',
    name: 'Davis Reef',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.9258,
    longitude: -80.5044,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A ledge-lined Sanctuary Preservation Area off Islamorada known for its resident green morays and a small brass Buddha statue tucked on the ledge. Gentle profiles suit all certification levels.',
    highlights: ['Buddha statue on the ledge', 'Resident green morays', 'Long low ledge line'],
    tags: ['florida', 'keys', 'reef', 'spa', 'ledge'],
    aliases: ['Davis Ledge'],
    maxDepthM: 10,
  },
  {
    id: 'de-leon-springs',
    slug: 'de-leon-springs',
    name: 'De Leon Springs State Park',
    region: 'De Leon Springs, Florida',
    country: 'United States',
    latitude: 29.1341,
    longitude: -81.3627,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A historic spring near DeLand where a walled swimming basin surrounds the boil beside the old sugar mill restaurant. Today it is a swim and snorkel park; scuba diving is not permitted.',
    highlights: ['Historic sugar mill', 'Walled spring pool', 'Warm 72 F water'],
    tags: ['spring', 'snorkel', 'state-park', 'swimming', 'historic'],
    maxDepthM: 9,
    requirementNote: 'Swimming and snorkeling only; no scuba',
  },
  {
    id: 'deep-freeze',
    slug: 'deep-freeze',
    name: 'Deep Freeze',
    region: 'Miami, Florida',
    country: 'United States',
    latitude: 25.85,
    longitude: -80.076,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 210-foot freighter scuttled in 1976 on Miami\'s deep wreck line. One of the area\'s oldest artificial reefs, heavily encrusted and frequented by big amberjack and barracuda.',
    highlights: ['Deep freighter wreck', 'Heavy encrustation', 'Big pelagics'],
    tags: ['wreck', 'deep', 'freighter', 'artificial reef', 'miami'],
    maxDepthM: 41,
    requiredCertification: 'AOW',
    requirementNote: 'Sits near the recreational depth limit',
  },
  {
    id: 'delray-ledge',
    slug: 'delray-ledge',
    name: 'Delray Ledge',
    region: 'Delray Beach, Florida',
    country: 'United States',
    latitude: 26.46,
    longitude: -80.04,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A natural limestone ledge running parallel to shore off Delray Beach, dived as a north-flowing drift in the Gulf Stream. Undercuts hide nurse sharks, lobster, and green turtles.',
    highlights: ['Classic drift dive', 'Undercut ledge', 'Turtles and nurse sharks'],
    tags: ['drift', 'ledge', 'reef', 'turtles', 'delray'],
    maxDepthM: 20,
  },
  {
    id: 'delta-shoal',
    slug: 'delta-shoal',
    name: 'Delta Shoal',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.6317,
    longitude: -81.0917,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow shoal just east of Sombrero Key with coral fingers and sand channels holding several old wreck sites. Less crowded than neighboring Sombrero with similar easy conditions.',
    highlights: ['Coral fingers and channels', 'Historic wreck scatter', 'Quiet alternative to Sombrero'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'wreck'],
    maxDepthM: 7,
  },
  {
    id: 'destin-jetties',
    slug: 'destin-jetties',
    name: 'Destin Jetties',
    region: 'Destin, Florida',
    country: 'United States',
    latitude: 30.383,
    longitude: -86.513,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The rock jetties of Destin\'s East Pass, a classic Panhandle shore dive best done at slack tide in the clear incoming Gulf water. The boulders shelter octopus, seahorses, and thick schools of spadefish.',
    highlights: ['Classic shore dive', 'Seahorses and octopus', 'Clear incoming tide'],
    tags: ['shore dive', 'jetty', 'reef', 'destin', 'snorkel'],
    maxDepthM: 12,
    requirementNote: 'Time for slack or incoming tide; boat traffic in the pass',
  },
  {
    id: 'devils-backbone',
    slug: 'devils-backbone',
    name: 'Devil\'s Backbone',
    region: 'Eleuthera, Bahamas',
    country: 'Bahamas',
    latitude: 25.575,
    longitude: -76.755,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow, ship-killing barrier reef off North Eleuthera that has claimed vessels for centuries, leaving a trail of historic wrecks among the coral heads. Dives combine bright elkhorn-strewn reef with scattered wreckage in under ten meters.',
    highlights: ['Historic ship graveyard', 'Shallow coral gardens', 'Multiple wrecks on one reef'],
    tags: ['reef', 'wrecks', 'eleuthera', 'shallow', 'history'],
    maxDepthM: 8,
  },
  {
    id: 'devils-reef-ocho-rios-jamaica',
    slug: 'devils-reef-ocho-rios-jamaica',
    name: 'Devil\'s Reef',
    region: 'Ocho Rios, Jamaica',
    country: 'Jamaica',
    latitude: 18.421,
    longitude: -77.108,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An underwater ridge off Ocho Rios that starts around 20 meters and slides steeply into deep water, swept by nutrient-rich currents. Stingrays, turtles and nurse sharks are regular sightings along the drop.',
    highlights: ['Steep offshore ridge', 'Nurse sharks and rays', 'Deep blue drop-off'],
    tags: ['deep', 'ocho-rios', 'ridge', 'sharks', 'current'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Ridge top near 20 m with deeper walls.',
  },
  {
    id: 'diamond-rock-saba',
    slug: 'diamond-rock-saba',
    name: 'Diamond Rock',
    region: 'Saba',
    country: 'Caribbean Netherlands',
    latitude: 17.65,
    longitude: -63.255,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A striking white guano-capped rock off Saba\'s north coast whose submerged flanks drop to sand at 24 meters. The circumnavigable pinnacle attracts turtles, rays, and the occasional passing shark.',
    highlights: ['circumnavigable pinnacle', 'turtles and rays', 'dramatic topside scenery'],
    tags: ['pinnacle', 'saba', 'volcanic', 'marine-park', 'boat-dive'],
    maxDepthM: 24,
  },
  {
    id: 'diepolder-cave',
    slug: 'diepolder-cave',
    name: 'Diepolder Cave',
    region: 'Brooksville, Florida',
    country: 'United States',
    latitude: 28.53,
    longitude: -82.52,
    matchRadiusKm: 7,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A sinkhole system on the Sand Hill Scout Reservation containing some of the deepest known cave passage in the United States, exceeding 300 feet. Diving is limited to full-cave divers accompanied by approved guides.',
    highlights: ['Among the deepest US caves', 'Massive deep rooms', 'Guide-escorted access'],
    tags: ['cave', 'sinkhole', 'deep', 'trimix', 'restricted-access'],
    aliases: ['Diepolder II', 'Diepolder III'],
    maxDepthM: 110,
    requiredCertification: 'FullCave',
    requirementNote: 'Full cave plus trimix experience; access only with Sand Hill-approved guides',
  },
  {
    id: 'directors-bay',
    slug: 'directors-bay',
    name: 'Director\'s Bay',
    region: 'Caracas Bay, Curaçao',
    country: 'Curacao',
    latitude: 12.0655,
    longitude: -68.8605,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Former private swimming bay of Shell\'s directors near Caracas Bay, now a shore dive with a steep reef slope and a shark net fence from its swimming-bay days. Turtles and good macro life are common.',
    highlights: ['Historic swimming bay', 'Steep reef slope', 'Old shark net structure'],
    tags: ['shore-dive', 'coral', 'curacao', 'historic', 'turtles'],
    maxDepthM: 35,
  },
  {
    id: 'divers-dream',
    slug: 'divers-dream',
    name: 'Diver\'s Dream',
    region: 'Columbus Passage, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.115,
    longitude: -60.845,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'High-voltage drift over an offshore bank in the Columbus Passage southwest of Tobago, swept by strong currents that draw nurse sharks, big stingrays, and turtles. Conditions demand solid drift experience.',
    highlights: ['Strong offshore drift', 'Nurse sharks', 'Big stingrays'],
    tags: ['drift', 'boat-dive', 'tobago', 'current', 'advanced'],
    maxDepthM: 22,
    requiredCertification: 'AOW',
    requirementNote: 'Strong, sometimes unpredictable currents over an offshore bank.',
  },
  {
    id: 'doc-poulson-wreck-grand-cayman',
    slug: 'doc-poulson-wreck-grand-cayman',
    name: 'Doc Poulson Wreck',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.36,
    longitude: -81.401,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A small Japanese cable-laying vessel scuttled in 1981 as an artificial reef off Seven Mile Beach. The intact little wreck sits upright on sand at about 16 meters surrounded by garden eels.',
    highlights: ['Intact upright wreck', 'Garden eel colonies', 'Easy first wreck dive'],
    tags: ['wreck', 'artificial-reef', 'seven-mile-beach', 'shallow', 'photography'],
    maxDepthM: 16,
  },
  {
    id: 'dominicus-reef-bayahibe',
    slug: 'dominicus-reef-bayahibe',
    name: 'Dominicus Reef',
    region: 'Bayahibe, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.348,
    longitude: -68.805,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The long fringing reef off Playa Dominicus near Bayahibe, a staple checkout and training dive for the area\'s resorts. Gentle coral slopes hold trumpetfish, snappers and the occasional stingray.',
    highlights: ['Gentle coral slope', 'Reliable easy conditions', 'Rich small fish life'],
    tags: ['reef', 'bayahibe', 'shallow', 'training', 'resort'],
    maxDepthM: 14,
  },
  {
    id: 'dottins-reef',
    slug: 'dottins-reef',
    name: 'Dottins Reef',
    region: 'Holetown, Barbados',
    country: 'Barbados',
    latitude: 13.19,
    longitude: -59.645,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A classic west coast bank reef off Holetown with coral heads, sea fans, and frequent hawksbill turtle encounters along a gentle slope. It is a staple second dive after the Stavronikita.',
    highlights: ['hawksbill turtles', 'sea fan gardens', 'gentle bank reef'],
    tags: ['reef', 'barbados', 'turtles', 'beginner', 'boat-dive'],
    maxDepthM: 20,
  },
  {
    id: 'double-caves-san-salvador',
    slug: 'double-caves-san-salvador',
    name: 'Double Caves',
    region: 'San Salvador, Bahamas',
    country: 'Bahamas',
    latitude: 24.01,
    longitude: -74.54,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Twin parallel tunnels cutting through the reef lip on San Salvador\'s wall, exiting side by side onto the vertical face. Divers descend through one cave, cruise the wall, and can return through its twin.',
    highlights: ['Twin wall exit tunnels', 'Dramatic vertical face', 'Black coral in the blue'],
    tags: ['wall', 'swim-through', 'san-salvador', 'drop-off', 'photography'],
    maxDepthM: 33,
  },
  {
    id: 'double-d-french-cay',
    slug: 'double-d-french-cay',
    name: 'Double D',
    region: 'French Cay, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.49,
    longitude: -72.22,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A liveaboard favorite in the French Cay and West Sand Spit area, named for two dome-shaped coral mounds rising off the wall lip. Sharks circle the twin humps and stingrays forage the surrounding sand.',
    highlights: ['Twin coral mounds', 'Circling reef sharks', 'Southern bank wilderness'],
    tags: ['wall', 'french-cay', 'sharks', 'remote', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'double-wreck-statia',
    slug: 'double-wreck-statia',
    name: 'Double Wreck',
    region: 'St. Eustatius',
    country: 'Caribbean Netherlands',
    latitude: 17.478,
    longitude: -62.995,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'Two 18th-century shipwreck sites marked by coral-encrusted ballast mounds and anchors on Statia\'s sandy shelf. The historic mounds now function as mini-reefs crowded with fish, rays, and octopus.',
    highlights: ['18th-century ballast mounds', 'historic anchors', 'dense fish aggregations'],
    tags: ['wreck', 'historic', 'statia', 'marine-park', 'shallow'],
    maxDepthM: 18,
  },
  {
    id: 'eagle-wreck',
    slug: 'eagle-wreck',
    name: 'Eagle',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.8697,
    longitude: -80.5703,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 287-foot freighter scuttled off Islamorada in 1985 and later broken in two by Hurricane Georges. The hull lies on its starboard side in about 34 meters, wrapped in schooling grunts and jacks.',
    highlights: ['287-foot freighter', 'Split hull sections', 'Dense baitfish clouds'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'deep', 'shipwreck-trail'],
    aliases: ['Eagle Tugboat Wreck', 'Aaron K'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
    requirementNote: 'Deck at 21-27 m, sand at 34 m; deep experience advised.',
  },
  {
    id: 'eagle-ray-pass-grand-cayman',
    slug: 'eagle-ray-pass-grand-cayman',
    name: 'Eagle Ray Pass',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.41,
    longitude: -81.332,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A sand-floored channel through Grand Cayman\'s North Wall that acts as a highway for spotted eagle rays cruising the drop-off. The pass opens onto a sheer wall plunging into the Cayman Trench.',
    highlights: ['Eagle rays on the wall', 'Sand channel through the reef', 'Sheer North Wall drop-off'],
    tags: ['wall', 'north-wall', 'eagle-rays', 'channel', 'deep'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Wall dive with structure below 18 m.',
  },
  {
    id: 'east-chute-cayman-brac',
    slug: 'east-chute-cayman-brac',
    name: 'East Chute',
    region: 'Cayman Brac, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.725,
    longitude: -79.79,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A north-shore Cayman Brac site combining a sand chute through the wall with the small wreck of the Cayman Mariner sitting on the sand nearby. Divers can work the wall and finish over the tugboat-style wreck.',
    highlights: ['Wall chute plus wreck combo', 'Cayman Mariner wreck', 'Sponge-lined drop-off'],
    tags: ['wreck', 'wall', 'cayman-brac', 'sand-chute', 'combo-dive'],
    aliases: ['Cayman Mariner Wreck'],
    maxDepthM: 24,
  },
  {
    id: 'eastern-dry-rocks',
    slug: 'eastern-dry-rocks',
    name: 'Eastern Dry Rocks',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4608,
    longitude: -81.8425,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A Sanctuary Preservation Area east of Sand Key and a flagship site of NOAA\'s Mission: Iconic Reefs restoration program. Spur-and-groove canyons hide ballast stones and rigging from old wrecks.',
    highlights: ['Iconic Reefs restoration site', 'Old wreck ballast in the grooves', 'Shallow coral canyons'],
    tags: ['florida', 'keys', 'reef', 'spa', 'restoration', 'key-west'],
    maxDepthM: 8,
  },
  {
    id: 'eastern-sambo',
    slug: 'eastern-sambo',
    name: 'Eastern Sambo',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.488,
    longitude: -81.663,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The easternmost of the three Sambo reefs off Boca Chica, with well-formed spur-and-groove coral in shallow water. A portion is set aside for research, keeping fish populations robust.',
    highlights: ['Healthy spur-and-groove', 'Robust fish stocks', 'Part of the Sambo complex'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'key-west'],
    maxDepthM: 8,
  },
  {
    id: 'eden-rock-grand-cayman',
    slug: 'eden-rock-grand-cayman',
    name: 'Eden Rock',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.292,
    longitude: -81.388,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-dive labyrinth of coral tunnels and caverns just off downtown George Town, adjacent to Devil\'s Grotto. Shafts of sunlight pierce the swim-throughs where tarpon and silversides gather.',
    highlights: ['Sunlit coral tunnels', 'Shore entry from George Town', 'Tarpon and silversides'],
    tags: ['shore-dive', 'swim-throughs', 'caverns', 'george-town', 'shallow'],
    maxDepthM: 12,
  },
  {
    id: 'edison-reef',
    slug: 'edison-reef',
    name: 'Edison Reef',
    region: 'Sanibel, Florida',
    country: 'United States',
    latitude: 26.32,
    longitude: -82.1,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An artificial reef off Sanibel Island built largely from rubble of the old Edison Bridge that once spanned the Caloosahatchee River. The concrete piles attract goliath grouper, sheepshead, and schooling baitfish.',
    highlights: ['Bridge rubble reef', 'Goliath grouper', 'Easy Gulf depth'],
    tags: ['artificial reef', 'rubble', 'sanibel', 'beginner', 'gulf'],
    maxDepthM: 13,
  },
  {
    id: 'egmont-key',
    slug: 'egmont-key',
    name: 'Egmont Key',
    region: 'St. Petersburg, Florida',
    country: 'United States',
    latitude: 27.6,
    longitude: -82.76,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A state park island at the mouth of Tampa Bay where the submerged ruins of Fort Dade slip beneath the surface. Snorkelers and divers explore collapsed gun batteries and rubble alive with sheepshead and snook.',
    highlights: ['Submerged fort ruins', 'State park island', 'Snorkel friendly'],
    tags: ['reef', 'ruins', 'snorkel', 'state park', 'tampa'],
    maxDepthM: 6,
  },
  {
    id: 'el-bajo-cabo-pulmo',
    slug: 'el-bajo-cabo-pulmo',
    name: 'El Bajo (Cabo Pulmo)',
    region: 'Cabo Pulmo, Mexico',
    country: 'Mexico',
    latitude: 23.44,
    longitude: -109.41,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A hard-coral reef ridge inside Cabo Pulmo National Park, part of the oldest coral reef on North America\'s west coast. Park protection since 1995 has produced spectacular fish biomass, including huge snapper and jack schools.',
    highlights: ['Protected coral reef', 'Massive fish biomass', 'National park diving'],
    tags: ['reef', 'marine-park', 'coral', 'cabo-pulmo', 'sea-of-cortez'],
    maxDepthM: 18,
  },
  {
    id: 'el-bajo-seamount-la-paz',
    slug: 'el-bajo-seamount-la-paz',
    name: 'El Bajo Seamount',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.7,
    longitude: -110.32,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A legendary trio of seamount peaks northeast of Los Islotes, historically famous for schooling hammerheads and still delivering big jacks, tuna, and seasonal mobulas. Blue-water descents and current demand experience.',
    highlights: ['Historic hammerhead site', 'Blue-water seamount', 'Seasonal mobula schools'],
    tags: ['seamount', 'pelagics', 'advanced', 'la-paz', 'sea-of-cortez'],
    aliases: ['El Bajo Espiritu Santo'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'el-canon-san-benedicto',
    slug: 'el-canon-san-benedicto',
    name: 'El Cañón (San Benedicto)',
    region: 'Revillagigedo Islands, Mexico',
    country: 'Mexico',
    latitude: 19.295,
    longitude: -110.807,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A ridge and cleaning-station complex at San Benedicto\'s southeast corner where hammerheads, silvertips, and Galapagos sharks patrol the drop-off. Divers hook into the rubble edge and watch the shark parade in blue water.',
    highlights: ['Hammerhead schools', 'Shark cleaning stations', 'Blue-water ridge'],
    tags: ['sharks', 'ridge', 'liveaboard', 'revillagigedo', 'pacific'],
    aliases: ['The Canyon'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Liveaboard-only marine park; advanced certification and experience required.',
  },
  {
    id: 'el-cantil-cabo-pulmo',
    slug: 'el-cantil-cabo-pulmo',
    name: 'El Cantil',
    region: 'Cabo Pulmo, Mexico',
    country: 'Mexico',
    latitude: 23.435,
    longitude: -109.42,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A long reef ledge in Cabo Pulmo National Park where coral-covered rock steps down into deeper sand. Turtles, big grouper, and the park\'s signature giant fish schools are regulars along the drop.',
    highlights: ['Coral-covered ledge', 'Giant fish schools', 'Turtles and grouper'],
    tags: ['reef', 'marine-park', 'ledge', 'cabo-pulmo', 'sea-of-cortez'],
    maxDepthM: 20,
  },
  {
    id: 'el-infante',
    slug: 'el-infante',
    name: 'El Infante',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.9417,
    longitude: -80.475,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The ballast pile of a Spanish galleon from the 1733 treasure fleet, wrecked on Little Conch Reef during a hurricane. Rounded ballast stones in shallow water mark one of the Keys\' oldest dive-able wrecks.',
    highlights: ['1733 Spanish treasure fleet', 'Historic ballast pile', 'Shallow snorkel-friendly depth'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'spanish-galleon', 'shallow'],
    aliases: ['Infante'],
    maxDepthM: 6,
  },
  {
    id: 'el-morro-puerto-vallarta',
    slug: 'el-morro-puerto-vallarta',
    name: 'El Morro',
    region: 'Puerto Vallarta, Mexico',
    country: 'Mexico',
    latitude: 20.74,
    longitude: -105.65,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A cluster of offshore rock pinnacles beyond the Marietas with tunnels, caves, and deep walls exposed to open Pacific conditions. Giant mantas, schooling fish, and occasional shark sightings reward the longer boat ride.',
    highlights: ['Pinnacle tunnels and caves', 'Giant manta encounters', 'Open-ocean walls'],
    tags: ['pinnacle', 'caves', 'advanced', 'puerto-vallarta', 'pacific'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
  },
  {
    id: 'el-salon-de-maria-cuba',
    slug: 'el-salon-de-maria-cuba',
    name: 'El Salón de María',
    region: 'María la Gorda, Cuba',
    country: 'Cuba',
    latitude: 21.81,
    longitude: -84.503,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'One of María la Gorda\'s signature dives, an amphitheater-like hollow in the reef wall decorated with black coral and gorgonians. The sheltered bay of Guanahacabibes gives it typically calm, clear conditions.',
    highlights: ['Amphitheater in the wall', 'Black coral bushes', 'Calm clear water'],
    tags: ['wall', 'maria-la-gorda', 'black-coral', 'national-park', 'reef'],
    maxDepthM: 25,
  },
  {
    id: 'el-vencedor-wreck',
    slug: 'el-vencedor-wreck',
    name: 'El Vencedor Wreck',
    region: 'Cabo Pulmo, Mexico',
    country: 'Mexico',
    latitude: 23.4,
    longitude: -109.41,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'The scattered remains of a tuna boat sunk in Cabo Pulmo National Park, now a magnet for the park\'s famous bull sharks and swirling schools of jacks and snapper. The wreckage lies on sand at a comfortable mid-depth.',
    highlights: ['Bull shark encounters', 'Swirling jack schools', 'Easy wreck profile'],
    tags: ['wreck', 'sharks', 'marine-park', 'cabo-pulmo', 'sea-of-cortez'],
    maxDepthM: 15,
  },
  {
    id: 'el-zacaton',
    slug: 'el-zacaton',
    name: 'El Zacatón',
    region: 'Tamaulipas, Mexico',
    country: 'Mexico',
    latitude: 22.9942,
    longitude: -98.1661,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'The deepest known water-filled sinkhole on Earth at over 330 m, a geothermal cenote in Tamaulipas famous for floating grass islands and record-setting deep dives. Diving here is the domain of technical teams with expedition-level planning.',
    highlights: ['World\'s deepest sinkhole', 'Floating grass islands', 'Geothermal warm water'],
    tags: ['sinkhole', 'technical', 'deep', 'tamaulipas', 'expedition'],
    aliases: ['Zacaton'],
    maxDepthM: 339,
    requiredCertification: 'TecTrimix',
    requirementNote: 'Technical/expedition site only; access is restricted and dives require trimix-level technical training.',
  },
  {
    id: 'elephant-ear-canyon',
    slug: 'elephant-ear-canyon',
    name: 'Elephant Ear Canyon',
    region: 'West Caicos, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.64,
    longitude: -72.48,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A sand canyon cutting through the West Caicos wall, named for an enormous orange elephant ear sponge on its flank. The canyon funnels divers onto a sheer face known for eagle rays and passing sharks.',
    highlights: ['Giant elephant ear sponge', 'Sand canyon to the wall', 'Eagle ray fly-bys'],
    tags: ['wall', 'west-caicos', 'sponges', 'drop-off', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'emerald-reef',
    slug: 'emerald-reef',
    name: 'Emerald Reef',
    region: 'Key Biscayne, Florida',
    country: 'United States',
    latitude: 25.673,
    longitude: -80.093,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow patch reef southeast of Key Biscayne popular for training dives and snorkeling. Elkhorn and star corals shelter grunts, sergeant majors, and the occasional nurse shark.',
    highlights: ['Shallow patch reef', 'Great for training', 'Healthy hard corals'],
    tags: ['reef', 'shallow', 'snorkel', 'beginner', 'miami'],
  },
  {
    id: 'emerald-sink',
    slug: 'emerald-sink',
    name: 'Emerald Sink',
    region: 'Woodville, Florida',
    country: 'United States',
    latitude: 30.355,
    longitude: -84.295,
    matchRadiusKm: 6,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A deep karst window south of Tallahassee connected to the sprawling Leon Sinks cave system. Its green-tinted shaft drops steeply into major tunnel passage dived only by trained cave divers.',
    highlights: ['Karst window to Leon Sinks system', 'Steep deep shaft', 'Big tunnel passage'],
    tags: ['sinkhole', 'cave', 'tallahassee', 'deep', 'overhead'],
    maxDepthM: 50,
    requiredCertification: 'FullCave',
    requirementNote: 'Full cave certification required; depth calls for staged decompression planning',
  },
  {
    id: 'empire-mica',
    slug: 'empire-mica',
    name: 'Empire Mica',
    region: 'Port St. Joe, Florida',
    country: 'United States',
    latitude: 29.5,
    longitude: -85.45,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 465-foot British tanker torpedoed by a German U-boat in 1942 off Cape San Blas. The broken wartime wreck lies in about 33 meters and is a long-run trip prized by Panhandle wreck divers.',
    highlights: ['U-boat casualty', '465-foot tanker', 'WWII history'],
    tags: ['wreck', 'wwii', 'tanker', 'deep', 'gulf'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
  },
  {
    id: 'escambron-san-juan',
    slug: 'escambron-san-juan',
    name: 'Escambrón',
    region: 'San Juan, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.4675,
    longitude: -66.088,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected city beach in San Juan whose rocky breakwaters and seagrass flats form the capital\'s go-to training and shore-dive site. Turtles, rays and octopus are common despite the urban setting.',
    highlights: ['Urban shore dive', 'Resident green turtles', 'Protected easy entry'],
    tags: ['shore-dive', 'san-juan', 'shallow', 'turtles', 'training'],
    aliases: ['Playa Escambrón'],
    maxDepthM: 8,
  },
  {
    id: 'esso-bonaire',
    slug: 'esso-bonaire',
    name: 'Esso Bonaire III',
    region: 'Jupiter, Florida',
    country: 'United States',
    latitude: 26.948,
    longitude: -80.03,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 147-foot tanker scuttled in 1989 off Jupiter, now part of the same drift line as the Zion Train. The aging hull is heavily colonized and regularly patrolled by goliath grouper and bull sharks.',
    highlights: ['Vintage tanker', 'Goliath grouper', 'Shark sightings'],
    tags: ['wreck', 'tanker', 'drift', 'goliath grouper', 'jupiter'],
    aliases: ['Esso Bonaire'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
    requirementNote: 'Drift wreck diving in current',
  },
  {
    id: 'fallen-rock-la-parguera',
    slug: 'fallen-rock-la-parguera',
    name: 'Fallen Rock',
    region: 'La Parguera, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 17.9,
    longitude: -67.01,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A La Parguera wall site marked by a huge boulder that broke from the shelf edge and lodged partway down the drop. Divers circle the rock amid deep gorgonians, snappers and passing pelagics.',
    highlights: ['House-sized fallen boulder', 'Deep wall scenery', 'Snapper and pelagics'],
    tags: ['wall', 'la-parguera', 'boulder', 'deep', 'boat-dive'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Feature sits below 20 m on the wall.',
  },
  {
    id: 'falmouth-spring',
    slug: 'falmouth-spring',
    name: 'Falmouth Spring',
    region: 'Live Oak, Florida',
    country: 'United States',
    latitude: 30.3594,
    longitude: -83.1346,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A first-magnitude spring west of Live Oak whose short run disappears back underground, forming part of the Falmouth-Cathedral cave system. The big, high-flow tunnels are a renowned advanced cave dive.',
    highlights: ['Huge high-flow tunnels', 'Falmouth-Cathedral system', 'First-magnitude spring'],
    tags: ['cave', 'spring', 'suwannee', 'deep', 'overhead'],
    maxDepthM: 30,
    requiredCertification: 'FullCave',
    requirementNote: 'Full cave certification required; strong flow and depth demand experience',
  },
  {
    id: 'fami-tugs',
    slug: 'fami-tugs',
    name: 'FAMI Tugs',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.09,
    longitude: -85.76,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'Two steel tugboats scuttled side by side off Panama City Beach, allowing divers to explore both hulls on a single dive. The pair sits at recreational depth and swarms with baitfish.',
    highlights: ['Two tugs, one dive', 'Recreational depth', 'Baitfish swarms'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'panama city', 'intermediate'],
    maxDepthM: 22,
  },
  {
    id: 'fang-ming-wreck',
    slug: 'fang-ming-wreck',
    name: 'Fang Ming Wreck',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.47,
    longitude: -110.39,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A Chinese vessel confiscated for people smuggling and sunk in 1999 as Latin America\'s first artificial reef created for diving, resting upright near Espíritu Santo. Cut openings allow easy swim-throughs past turtles and schooling fish.',
    highlights: ['Upright artificial reef', 'Prepared swim-throughs', 'Resident turtles'],
    tags: ['wreck', 'artificial-reef', 'la-paz', 'sea-of-cortez', 'penetration'],
    maxDepthM: 21,
    requiredCertification: 'AOW',
    requirementNote: 'Prepared openings allow guided swim-throughs without full wreck certification.',
  },
  {
    id: 'fanning-springs',
    slug: 'fanning-springs',
    name: 'Fanning Springs',
    region: 'Fanning Springs, Florida',
    country: 'United States',
    latitude: 29.5875,
    longitude: -82.9337,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A large spring basin on the Suwannee River protected as a state park, popular for swimming and snorkeling. Manatees shelter in the run during cooler months.',
    highlights: ['State park spring basin', 'Winter manatee visits', 'Suwannee riverfront'],
    tags: ['spring', 'snorkel', 'state-park', 'manatees', 'swimming'],
    maxDepthM: 6,
    requirementNote: 'Swimming and snorkeling site; scuba is not permitted',
  },
  {
    id: 'flaglers-barge',
    slug: 'flaglers-barge',
    name: 'Flagler\'s Barge',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.707,
    longitude: -80.996,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A steel barge associated with the construction era of Henry Flagler\'s Overseas Railroad, resting in shallow water off Marathon. Its low structure is packed with glassy sweepers, morays, and juvenile reef fish.',
    highlights: ['Railroad-era barge', 'Shallow and calm', 'Great for new divers and snorkelers'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shallow', 'snorkel'],
    aliases: ['Flagler Barge'],
    maxDepthM: 7,
  },
  {
    id: 'flamingo-bay-grenada',
    slug: 'flamingo-bay-grenada',
    name: 'Flamingo Bay',
    region: 'West coast, Grenada',
    country: 'Grenada',
    latitude: 12.09,
    longitude: -61.758,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A gentle sloping reef within Grenada\'s marine protected area just north of the sculpture park, thick with soft corals, sea fans, and juvenile fish. Seahorses and frogfish turn up for sharp-eyed divers.',
    highlights: ['soft coral slope', 'seahorse sightings', 'marine protected area'],
    tags: ['reef', 'grenada', 'marine-park', 'macro', 'beginner'],
    maxDepthM: 18,
  },
  {
    id: 'flying-reef',
    slug: 'flying-reef',
    name: 'Flying Reef',
    region: 'Crown Point, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.143,
    longitude: -60.828,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'Fast drift dive along a shallow reef shelf off Tobago\'s southwest coast, where divers fly past sea fans, nurse sharks, and stingrays in the Guyana Current. A classic introduction to Tobago drift diving.',
    highlights: ['Fast fun drift', 'Nurse sharks and rays', 'Sea fan fields'],
    tags: ['drift', 'boat-dive', 'tobago', 'current', 'sharks'],
    maxDepthM: 18,
  },
  {
    id: 'forest-klein-bonaire',
    slug: 'forest-klein-bonaire',
    name: 'Forest',
    region: 'Klein Bonaire, Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.15,
    longitude: -68.312,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Named for its forest of black coral trees on a steep slope at Klein Bonaire\'s southwest corner. One of the most dramatic boat dives in the Bonaire marine park, with overhangs and frequent turtles.',
    highlights: ['Black coral forest', 'Steep slope and overhangs', 'Turtles'],
    tags: ['boat-dive', 'black-coral', 'klein-bonaire', 'wall', 'marine-park'],
    maxDepthM: 40,
  },
  {
    id: 'fort-jefferson-moat-wall',
    slug: 'fort-jefferson-moat-wall',
    name: 'Fort Jefferson Moat Wall',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.6275,
    longitude: -82.8723,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-entry snorkel along the outside of Fort Jefferson\'s brick moat wall on Garden Key. Corals, tropical fish, and the occasional tarpon cruise the wall in waist-to-chest-deep water.',
    highlights: ['Snorkel from the beach', 'Historic fort backdrop', 'Fish along the moat wall'],
    tags: ['florida', 'dry-tortugas', 'snorkel', 'shore-dive', 'national-park', 'shallow'],
    aliases: ['Garden Key Moat Wall'],
    maxDepthM: 3,
  },
  {
    id: 'fort-pickens-jetties',
    slug: 'fort-pickens-jetties',
    name: 'Fort Pickens Jetties',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.328,
    longitude: -87.29,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A rocky jetty shore dive inside Pensacola Pass at Fort Pickens, within Gulf Islands National Seashore. The rocks hold octopus, sheepshead, and flounder, but tidal current demands slack-tide timing.',
    highlights: ['Shore dive', 'Octopus and flounder', 'National seashore'],
    tags: ['shore dive', 'jetty', 'reef', 'pensacola', 'current'],
    maxDepthM: 15,
    requirementNote: 'Dive at slack tide; strong tidal flow through the pass',
  },
  {
    id: 'fowey-rocks',
    slug: 'fowey-rocks',
    name: 'Fowey Rocks Lighthouse',
    region: 'Key Biscayne, Florida',
    country: 'United States',
    latitude: 25.59,
    longitude: -80.097,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef surrounding the 1878 iron-skeleton Fowey Rocks Lighthouse at the northern edge of Biscayne National Park. Spur-and-groove coral formations hold abundant reef fish in clear, easy conditions.',
    highlights: ['Historic 1878 lighthouse', 'Biscayne National Park', 'Spur-and-groove reef'],
    tags: ['reef', 'lighthouse', 'national park', 'shallow', 'snorkel'],
    aliases: ['Fowey Light'],
    maxDepthM: 8,
  },
  {
    id: 'fowl-cays-reef',
    slug: 'fowl-cays-reef',
    name: 'Fowl Cays Reef',
    region: 'Abacos, Bahamas',
    country: 'Bahamas',
    latitude: 26.63,
    longitude: -77.01,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected reef area in Fowl Cays National Park off central Abaco, with coral canyons, tunnels, and abundant fish sheltered by no-take rules. Shallow spur-and-groove structure makes for relaxed multi-level dives.',
    highlights: ['National park fish life', 'Coral canyons and tunnels', 'Relaxed shallow profile'],
    tags: ['reef', 'marine-park', 'abacos', 'shallow', 'snorkel'],
    maxDepthM: 12,
  },
  {
    id: 'franjack-wreck',
    slug: 'franjack-wreck',
    name: 'Franjack',
    region: 'Malendure, Guadeloupe',
    country: 'Guadeloupe',
    latitude: 16.174,
    longitude: -61.784,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 50-meter sand-carrier scuttled in 1996 near the Cousteau Reserve, sitting upright on sand at about 22 meters. Its holds and deck are simple to navigate and thoroughly colonized by sponges and schooling fish.',
    highlights: ['upright sand carrier', 'easy hold access', 'thick sponge growth'],
    tags: ['wreck', 'guadeloupe', 'artificial-reef', 'boat-dive', 'cousteau'],
    maxDepthM: 22,
  },
  {
    id: 'frederiksted-pier',
    slug: 'frederiksted-pier',
    name: 'Frederiksted Pier',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.7125,
    longitude: -64.8845,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The pilings of St. Croix\'s cruise ship pier form a world-class muck and macro dive, famous for seahorses, frogfish, octopus, and batfish. Easy shore entry and shallow depth make it a favorite night dive.',
    highlights: ['seahorses and frogfish', 'encrusted pilings', 'legendary night diving'],
    tags: ['pier', 'macro', 'night-dive', 'shore-dive', 'usvi'],
    aliases: ['Fredericksted Pier', 'The Pier'],
    maxDepthM: 12,
  },
  {
    id: 'french-cap-cay',
    slug: 'french-cap-cay',
    name: 'French Cap Cay',
    region: 'St. Thomas, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.253,
    longitude: -64.856,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A remote cay several miles south of St. Thomas offering some of the island\'s clearest water, with pinnacles, a swim-through known as the Pinnacle arch, and frequent pelagic sightings. Its distance from shore keeps visibility routinely above 30 meters.',
    highlights: ['exceptional visibility', 'offshore pinnacles', 'pelagic encounters'],
    tags: ['pinnacle', 'offshore', 'visibility', 'usvi', 'boat-dive'],
    maxDepthM: 27,
  },
  {
    id: 'french-reef',
    slug: 'french-reef',
    name: 'French Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.0342,
    longitude: -80.3494,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Key Largo\'s premier swim-through reef, honeycombed with ledges, arches, and caves such as Christmas Tree Cave and Hourglass Cave. A Sanctuary Preservation Area with dense fish life.',
    highlights: ['Swim-throughs and arches', 'Christmas Tree Cave', 'Copper sweeper ledges'],
    tags: ['florida', 'keys', 'reef', 'swim-through', 'spa', 'spur-and-groove'],
    maxDepthM: 12,
  },
  {
    id: 'friars-craig',
    slug: 'friars-craig',
    name: 'Friars Craig',
    region: 'South coast, Barbados',
    country: 'Barbados',
    latitude: 13.065,
    longitude: -59.59,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 170-foot former island trader sunk in 1985 off Barbados\' south coast, now broken open on sand near 17 meters. The collapsed hull sections shelter schooling grunts and are often combined with nearby reef.',
    highlights: ['broken-open trader', 'schooling grunts', 'combined wreck-and-reef dive'],
    tags: ['wreck', 'barbados', 'artificial-reef', 'shallow', 'boat-dive'],
    maxDepthM: 17,
  },
  {
    id: 'g-spot-french-cay',
    slug: 'g-spot-french-cay',
    name: 'G-Spot',
    region: 'French Cay, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.5,
    longitude: -72.21,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A wall dive at remote French Cay on the southern edge of the Caicos Bank, where a groove in the reef lip concentrates fish and shark traffic. The isolated bank location means reliable reef sharks and frequent big animal encounters.',
    highlights: ['Remote bank-edge wall', 'Consistent reef sharks', 'Big animal potential'],
    tags: ['wall', 'french-cay', 'sharks', 'remote', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'gainer-springs',
    slug: 'gainer-springs',
    name: 'Gainer Springs',
    region: 'Econfina Creek, Youngstown, Florida',
    country: 'United States',
    latitude: 30.4198,
    longitude: -85.548,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A first-magnitude group of spring vents on lower Econfina Creek, reachable only by paddle craft. The vivid blue boils, including the pool nicknamed Emerald Spring, are a highlight of the creek run.',
    highlights: ['First-magnitude spring group', 'Paddle-only access', 'Striking emerald boils'],
    tags: ['spring', 'snorkel', 'econfina', 'kayak', 'panhandle'],
    aliases: ['Gainer Spring Group', 'Emerald Spring'],
    maxDepthM: 6,
  },
  {
    id: 'ganja-plane-wreck-jamaica',
    slug: 'ganja-plane-wreck-jamaica',
    name: 'Ganja Plane Wreck',
    region: 'Runaway Bay, Jamaica',
    country: 'Jamaica',
    latitude: 18.472,
    longitude: -77.335,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'The remains of a small smuggler\'s aircraft that crashed off Runaway Bay in the 1980s, now scattered on the reef and sand. The fuselage and wings make a quirky photo stop on an easy reef dive.',
    highlights: ['Sunken smuggler\'s plane', 'Quirky photo subject', 'Surrounding coral reef'],
    tags: ['wreck', 'plane', 'runaway-bay', 'photography', 'reef'],
    maxDepthM: 18,
  },
  {
    id: 'garden-cove',
    slug: 'garden-cove',
    name: 'Garden Cove',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1713,
    longitude: -80.363,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sheltered shore-entry cove at the north end of Key Largo used for snorkeling, training, and kayak-diving. Seagrass and scattered rocky patches hold juvenile fish and rays.',
    highlights: ['Easy shore access', 'Seagrass nursery habitat', 'Calm protected water'],
    tags: ['florida', 'keys', 'shore-dive', 'snorkel', 'shallow'],
    maxDepthM: 4,
  },
  {
    id: 'gator-hole',
    slug: 'gator-hole',
    name: 'Gator Hole',
    region: 'Merritt\'s Mill Pond, Marianna, Florida',
    country: 'United States',
    latitude: 30.774,
    longitude: -85.184,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A karst depression near the lower end of Merritt\'s Mill Pond with a cavern area and short cave section. Divers reach it by boat as part of the Marianna spring circuit.',
    highlights: ['Lower Mill Pond site', 'Cavern with short cave', 'Boat-access dive'],
    tags: ['cavern', 'mill-pond', 'marianna', 'panhandle', 'overhead'],
    maxDepthM: 15,
    requiredCertification: 'Cavern',
    requirementNote: 'Cave certification required beyond the cavern zone',
  },
  {
    id: 'georges-valentine',
    slug: 'georges-valentine',
    name: 'Georges Valentine',
    region: 'Stuart, Florida',
    country: 'United States',
    latitude: 27.198,
    longitude: -80.163,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'An Italian barkentine that wrecked in a 1904 storm just off the Gilbert\'s Bar House of Refuge on Hutchinson Island, now a Florida Underwater Archaeological Preserve. The shallow wreckage is accessible from shore in calm conditions.',
    highlights: ['1904 shipwreck', 'Shore accessible', 'Archaeological preserve'],
    tags: ['wreck', 'historic', 'preserve', 'shore dive', 'stuart'],
    maxDepthM: 8,
  },
  {
    id: 'ghost-mountain-grand-cayman',
    slug: 'ghost-mountain-grand-cayman',
    name: 'Ghost Mountain',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.399,
    longitude: -81.393,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A lone coral pinnacle rising off the wall at the western end of Grand Cayman\'s north side, its summit near 24 meters. The seamount seems to appear out of the blue, draped in sponges and gorgonians.',
    highlights: ['Isolated deep pinnacle', 'Dramatic blue-water approach', 'Sponge-draped summit'],
    tags: ['pinnacle', 'deep', 'wall', 'north-side', 'advanced'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Pinnacle top sits near 24 m.',
  },
  {
    id: 'gladden-spit',
    slug: 'gladden-spit',
    name: 'Gladden Spit',
    region: 'Placencia, Belize',
    country: 'Belize',
    latitude: 16.58,
    longitude: -87.99,
    matchRadiusKm: 6,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'Reef promontory in a marine reserve off Placencia where snapper spawning aggregations around the full moons of spring draw whale sharks to feed. Blue-water drift diving in season is tightly regulated by guide rotation.',
    highlights: ['Seasonal whale sharks', 'Snapper spawning aggregations', 'Blue-water drift'],
    tags: ['drift', 'whale-sharks', 'belize', 'marine-reserve', 'seasonal'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Blue-water drift with no reference; whale shark encounters are seasonal (Mar-Jun full moons).',
  },
  {
    id: 'gordo-banks',
    slug: 'gordo-banks',
    name: 'Gordo Banks',
    region: 'San José del Cabo, Mexico',
    country: 'Mexico',
    latitude: 23.03,
    longitude: -109.53,
    matchRadiusKm: 10,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An offshore seamount rising to about 34-40 m off San José del Cabo, famous for schooling scalloped hammerheads and other big pelagics. Depth, blue-water descents, and current make it a serious advanced dive.',
    highlights: ['Schooling hammerheads', 'Offshore seamount', 'Big pelagic action'],
    tags: ['seamount', 'deep', 'sharks', 'advanced', 'sea-of-cortez'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deep blue-water seamount; operators require advanced certification and significant logged experience.',
  },
  {
    id: 'governors-riverwalk-reef',
    slug: 'governors-riverwalk-reef',
    name: 'Governor\'s Riverwalk Reef',
    region: 'West Palm Beach, Florida',
    country: 'United States',
    latitude: 26.77,
    longitude: -80.01,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A cluster of retired freighters scuttled in 2002 off the Palm Beach Inlet, dived as a drift over the connected hulls. The wrecks have matured into fish-covered reefs with regular goliath grouper sightings.',
    highlights: ['Multiple freighters', 'Drift wreck diving', 'Mature fish life'],
    tags: ['wreck', 'drift', 'artificial reef', 'palm beach', 'intermediate'],
    maxDepthM: 27,
  },
  {
    id: 'gran-cenote',
    slug: 'gran-cenote',
    name: 'Gran Cenote',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.246,
    longitude: -87.464,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A shallow, heavily decorated cavern dive on the Sac Actun system just outside Tulum, famous for white limestone formations and resident freshwater turtles. The guided cavern circuit stays shallow with abundant natural light.',
    highlights: ['White limestone formations', 'Freshwater turtles', 'Shallow cavern circuit'],
    tags: ['cenote', 'cavern', 'freshwater', 'tulum', 'formations'],
    maxDepthM: 10,
    requirementNote: 'Guided cenote tours follow the cavern line; full cave certification required beyond.',
  },
  {
    id: 'great-wall-west-little-cayman',
    slug: 'great-wall-west-little-cayman',
    name: 'Great Wall West',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.698,
    longitude: -80.098,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The signature stretch of Bloody Bay Wall where the reef top at six meters tips over into a perfectly vertical, even undercut, mile-deep wall. Sponges and sea fans jut into gin-clear blue water.',
    highlights: ['Vertical mile-deep wall', 'Wall top at six meters', 'Exceptional visibility'],
    tags: ['wall', 'bloody-bay', 'drop-off', 'sponges', 'marine-park'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Sheer wall diving; watch depth over the abyss.',
  },
  {
    id: 'grecian-rocks',
    slug: 'grecian-rocks',
    name: 'Grecian Rocks',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1103,
    longitude: -80.3055,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A crescent-shaped shallow reef and Sanctuary Preservation Area beloved by snorkelers, with a lee side calm enough for first-timers. Elkhorn stands and a Spanish cannon replica dot the flat.',
    highlights: ['Calm snorkel lee', 'Elkhorn coral stands', 'Sanctuary Preservation Area'],
    tags: ['florida', 'keys', 'reef', 'snorkel', 'spa', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'grey-ghost',
    slug: 'grey-ghost',
    name: 'Grey Ghost',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.11,
    longitude: -85.8,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 105-foot steel tugboat scuttled in 1978 off Panama City Beach. The aging tug sits in deeper water and has become a dense fish haven with resident grouper and passing rays.',
    highlights: ['Veteran tug wreck', 'Deeper profile', 'Resident grouper'],
    tags: ['wreck', 'tugboat', 'deep', 'panama city', 'advanced'],
    maxDepthM: 31,
    requiredCertification: 'AOW',
  },
  {
    id: 'grouper-hole-grace-bay',
    slug: 'grouper-hole-grace-bay',
    name: 'Grouper Hole',
    region: 'Providenciales, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.83,
    longitude: -72.19,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A large sand depression in the Grace Bay reef off Providenciales where Nassau groupers, stingrays, and nurse sharks congregate. The easy depth and calm barrier-reef setting suit all levels.',
    highlights: ['Nassau grouper gathering spot', 'Nurse sharks and rays', 'Calm barrier-reef setting'],
    tags: ['reef', 'grace-bay', 'providenciales', 'groupers', 'beginner-friendly'],
    maxDepthM: 15,
  },
  {
    id: 'guardalavaca-cuba',
    slug: 'guardalavaca-cuba',
    name: 'Guardalavaca',
    region: 'Holguín, Cuba',
    country: 'Cuba',
    latitude: 21.123,
    longitude: -75.833,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'A resort area on Cuba\'s northeastern coast where the fringing reef drops close to shore, giving short boat rides to walls, canyons and a small wreck. A relaxed, uncrowded alternative to Varadero diving.',
    highlights: ['Close-in fringing reef', 'Walls and canyons', 'Uncrowded sites'],
    tags: ['destination', 'resort', 'reef', 'holguin', 'wall'],
  },
  {
    id: 'gunsmoke',
    slug: 'gunsmoke',
    name: 'Gunsmoke',
    region: 'Tampa Bay, Florida',
    country: 'United States',
    latitude: 27.75,
    longitude: -83.15,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A smuggling vessel scuttled by its own crew in 1977 while fleeing authorities, now resting on the Gulf floor west of Tampa Bay. The intact little ship is a favorite offshore wreck with a colorful outlaw story.',
    highlights: ['Smuggler\'s scuttling', 'Intact hull', 'Colorful history'],
    tags: ['wreck', 'historic', 'offshore', 'tampa', 'intermediate'],
    maxDepthM: 24,
  },
  {
    id: 'half-moon-caye-wall',
    slug: 'half-moon-caye-wall',
    name: 'Half Moon Caye Wall',
    region: 'Lighthouse Reef, Belize',
    country: 'Belize',
    latitude: 17.202,
    longitude: -87.535,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Sheer wall dive beside the Half Moon Caye natural monument on Lighthouse Reef, with sand chutes cutting through a coral lip that plunges into deep blue. Garden eels, spotted eagle rays, and visiting reef sharks are signature sightings.',
    highlights: ['Sheer coral wall', 'Eagle rays', 'Sand chute swim-throughs'],
    tags: ['wall', 'boat-dive', 'belize', 'lighthouse-reef', 'atoll'],
    maxDepthM: 40,
  },
  {
    id: 'hammerhead-gulch',
    slug: 'hammerhead-gulch',
    name: 'Hammerhead Gulch',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.7,
    longitude: -79.3,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A shallow sand channel off South Bimini where great hammerheads gather in winter, made famous by baited encounters run from Bimini. Divers kneel on the sand at under ten meters as the sharks make close passes.',
    highlights: ['Great hammerheads in winter', 'Close baited encounters', 'Shallow sand bottom'],
    tags: ['sharks', 'hammerheads', 'bimini', 'shallow', 'seasonal', 'photography'],
    maxDepthM: 8,
    requirementNote: 'Seasonal (roughly December-April); operators brief divers on shark-feed protocol.',
  },
  {
    id: 'hannah-m-bell',
    slug: 'hannah-m-bell',
    name: 'Hannah M. Bell',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.143,
    longitude: -80.2557,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A British steamer that grounded on Elbow Reef in 1911, long known locally as Mike\'s Wreck until formally identified by NOAA in 2012. Intact hull ribs rise from very shallow coral bottom.',
    highlights: ['Identified in 2012', 'Shallow steel ribs', 'Great snorkel-dive combo'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shallow', 'steamer'],
    maxDepthM: 6,
  },
  {
    id: 'hart-springs',
    slug: 'hart-springs',
    name: 'Hart Springs',
    region: 'Bell, Florida',
    country: 'United States',
    latitude: 29.6756,
    longitude: -82.952,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A county park spring complex on the Suwannee River with a broad, shallow swimming basin and boardwalk. It is a family swim and snorkel destination rather than a scuba site.',
    highlights: ['Large shallow basin', 'Boardwalk over the run', 'Family-friendly park'],
    tags: ['spring', 'snorkel', 'county-park', 'swimming', 'freshwater'],
    maxDepthM: 4,
    requirementNote: 'Swimming and snorkeling only',
  },
  {
    id: 'hathaway-bridge-spans',
    slug: 'hathaway-bridge-spans',
    name: 'Hathaway Bridge Spans',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.1,
    longitude: -85.85,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Concrete spans from the demolished old Hathaway Bridge deployed offshore as artificial reef material. The stacked rubble creates caves and overhangs favored by grouper and spearfishers.',
    highlights: ['Bridge rubble reef', 'Caves and overhangs', 'Grouper habitat'],
    tags: ['artificial reef', 'rubble', 'panama city', 'spearfishing', 'intermediate'],
    maxDepthM: 20,
  },
  {
    id: 'hen-and-chickens',
    slug: 'hen-and-chickens',
    name: 'Hen and Chickens',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.9317,
    longitude: -80.5483,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An inshore patch reef and Sanctuary Preservation Area named for its cluster of large coral heads around a central marker. Massive brain and star corals rise nearly to the surface.',
    highlights: ['Giant coral heads', 'Sanctuary Preservation Area', 'Sheltered inshore location'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'spa', 'snorkel'],
    aliases: ['Hens and Chickens'],
    maxDepthM: 7,
  },
  {
    id: 'hickory-wreck-la-caleta',
    slug: 'hickory-wreck-la-caleta',
    name: 'Hickory Wreck (La Caleta)',
    region: 'La Caleta Underwater Park, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.442,
    longitude: -69.686,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A treasure-salvage vessel scuttled in 1984 inside La Caleta Underwater National Park near Santo Domingo, resting at about 18 meters. It anchors the Caribbean\'s first underwater park and is thickly overgrown with corals and sponges.',
    highlights: ['Historic salvage ship', 'First DR underwater park', 'Heavy coral encrustation'],
    tags: ['wreck', 'la-caleta', 'marine-park', 'santo-domingo', 'artificial-reef'],
    maxDepthM: 18,
  },
  {
    id: 'highway-to-heaven',
    slug: 'highway-to-heaven',
    name: 'Highway to Heaven',
    region: 'West Caicos, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.65,
    longitude: -72.48,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A West Caicos signature dive where a white sand highway runs through the reef and spills over the wall into deep blue. The contrast of bright sand against the sheer face draws photographers, sharks, and eagle rays alike.',
    highlights: ['White sand highway', 'Dramatic wall drop', 'Photogenic contrast'],
    tags: ['wall', 'west-caicos', 'sand-chute', 'photography', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'hms-endymion-wreck',
    slug: 'hms-endymion-wreck',
    name: 'HMS Endymion Wreck',
    region: 'Salt Cay, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.08,
    longitude: -71.33,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'The remains of a British Royal Navy warship lost on a reef south of Salt Cay in 1790, with anchors, cannons, and ballast scattered in shallow clear water. The open-ocean reef site is dived on calm days from Salt Cay or Grand Turk.',
    highlights: ['1790 Royal Navy wreck', 'Cannons and giant anchors', 'Remote clear-water reef'],
    tags: ['wreck', 'history', 'salt-cay', 'shallow', 'cannons'],
    maxDepthM: 12,
    requirementNote: 'Exposed open-ocean site; dived only in settled conditions.',
  },
  {
    id: 'hole-in-the-rock',
    slug: 'hole-in-the-rock',
    name: 'Hole in the Rock',
    region: 'Merritt\'s Mill Pond, Marianna, Florida',
    country: 'United States',
    latitude: 30.7822,
    longitude: -85.162,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A shallow rock overhang and short cavern in Merritt\'s Mill Pond often used as a checkout and cavern-training stop. It is the easiest of the pond\'s overhead features.',
    highlights: ['Shallow cavern overhang', 'Training-friendly depth', 'Clear pond visibility'],
    tags: ['cavern', 'mill-pond', 'marianna', 'panhandle', 'training'],
    maxDepthM: 12,
    requiredCertification: 'Cavern',
    requirementNote: 'Overhead training required to pass beneath the ledge',
  },
  {
    id: 'horseshoe-reef-key-largo',
    slug: 'horseshoe-reef-key-largo',
    name: 'Horseshoe Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.138,
    longitude: -80.288,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A horseshoe-shaped coral formation between the Elbow and North Dry Rocks with dense boulder corals. Its curved ridge creates a natural amphitheater teeming with juvenile fish.',
    highlights: ['Horseshoe coral ridge', 'Boulder star corals', 'Juvenile fish nursery'],
    tags: ['florida', 'keys', 'reef', 'coral', 'shallow'],
    maxDepthM: 9,
  },
  {
    id: 'hospital-hole',
    slug: 'hospital-hole',
    name: 'Hospital Hole',
    region: 'Spring Hill, Florida',
    country: 'United States',
    latitude: 28.533,
    longitude: -82.593,
    matchRadiusKm: 4,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A 140-foot sinkhole in the bed of the Weeki Wachee River, named for the injured fish that gather there. Divers descend by boat access through a hydrogen sulfide layer into the dark lower basin.',
    highlights: ['Sinkhole in a river', 'Hydrogen sulfide cloud layer', 'Boat-access technical-style dive'],
    tags: ['sinkhole', 'river', 'deep', 'boat-access', 'advanced'],
    maxDepthM: 43,
    requiredCertification: 'AOW',
    requirementNote: 'Experienced deep divers only; poor visibility below the sulfide layer',
  },
  {
    id: 'hunter-spring',
    slug: 'hunter-spring',
    name: 'Hunter Spring',
    region: 'Crystal River, Florida',
    country: 'United States',
    latitude: 28.8961,
    longitude: -82.5901,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A clear spring at a city park on the northeast side of Kings Bay, popular with swimmers, snorkelers, and paddlers. It offers easy shore access to Crystal River\'s manatee waters.',
    highlights: ['City park shore entry', 'Kings Bay access', 'Kayak launch'],
    tags: ['spring', 'snorkel', 'crystal-river', 'swimming', 'shore-access'],
    maxDepthM: 4,
  },
  {
    id: 'hydro-atlantic',
    slug: 'hydro-atlantic',
    name: 'Hydro Atlantic',
    region: 'Boca Raton, Florida',
    country: 'United States',
    latitude: 26.34,
    longitude: -80.04,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 320-foot dredge that sank in a 1987 storm while under tow, leaving an intact, machinery-laden wreck in about 52 meters. Widely regarded as one of Florida\'s best wreck dives, its superstructure starts near 33 meters.',
    highlights: ['Genuine sinking, not scuttled', 'Intact machinery', 'World-class wreck'],
    tags: ['wreck', 'deep', 'dredge', 'advanced', 'boca raton'],
    maxDepthM: 52,
    requiredCertification: 'AOW',
    requirementNote: 'Bottom exceeds recreational limits; technical training recommended below the superstructure',
  },
  {
    id: 'indian-springs-wakulla',
    slug: 'indian-springs-wakulla',
    name: 'Indian Springs',
    region: 'Wakulla County, Florida',
    country: 'United States',
    latitude: 30.21,
    longitude: -84.34,
    matchRadiusKm: 7,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A privately managed spring near Wakulla Springs with an enormous cavern room, the Wakulla Room, and extensive cave passage beyond. Access is arranged through local dive operators and club agreements.',
    highlights: ['Massive cavern room', 'Deep clear basin', 'Extensive cave system'],
    tags: ['cave', 'cavern', 'wakulla', 'panhandle', 'restricted-access'],
    maxDepthM: 30,
    requiredCertification: 'Cavern',
    requirementNote: 'Access by arrangement only; cave certification required beyond the cavern zone',
  },
  {
    id: 'indian-washtub',
    slug: 'indian-washtub',
    name: 'Indian Washtub',
    region: 'Merritt\'s Mill Pond, Marianna, Florida',
    country: 'United States',
    latitude: 30.7788,
    longitude: -85.1727,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A lesser-traveled cave entrance in Merritt\'s Mill Pond reached by boat from Edd\'s Fish Camp area. It offers a short, silty overhead dive for trained cave divers touring the pond\'s sites.',
    highlights: ['Quiet Mill Pond cave', 'Boat access', 'Part of Marianna cave circuit'],
    tags: ['cave', 'mill-pond', 'marianna', 'panhandle', 'overhead'],
    maxDepthM: 15,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave-certified divers only',
  },
  {
    id: 'invisibles',
    slug: 'invisibles',
    name: 'Invisibles',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.072,
    longitude: -68.288,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Southern Bonaire double-reef site named for the way its two coral ridges hide from surface view. Garden eels carpet the sand flats and southern stingrays are common between the ridges.',
    highlights: ['Hidden double reef', 'Garden eel flats', 'Southern stingrays'],
    tags: ['shore-dive', 'double-reef', 'bonaire', 'sand-flats', 'rays'],
    maxDepthM: 33,
  },
  {
    id: 'isla-coronado-loreto',
    slug: 'isla-coronado-loreto',
    name: 'Isla Coronado',
    region: 'Loreto, Mexico',
    country: 'Mexico',
    latitude: 26.1,
    longitude: -111.28,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A volcanic island in Loreto Bay National Park with sea lion colonies, boulder slopes, and white-sand channels in clear water. Multiple moorings offer easy to moderate dives rich in Cortez reef fish.',
    highlights: ['Sea lion colony', 'Volcanic boulder slopes', 'National park waters'],
    tags: ['reef', 'sea-lions', 'marine-park', 'loreto', 'sea-of-cortez'],
    aliases: ['Coronado Island'],
    maxDepthM: 24,
  },
  {
    id: 'isla-danzante',
    slug: 'isla-danzante',
    name: 'Isla Danzante',
    region: 'Loreto, Mexico',
    country: 'Mexico',
    latitude: 25.783,
    longitude: -111.257,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A rugged island south of Loreto in the national marine park, with rocky ridges, sea fans, and reef fish concentrated along its points. Sites like Piedra Submarina offer pinnacle diving with frequent ray sightings.',
    highlights: ['Rocky ridge diving', 'Sea fan gardens', 'Marine park biodiversity'],
    tags: ['reef', 'pinnacle', 'marine-park', 'loreto', 'sea-of-cortez'],
    maxDepthM: 26,
  },
  {
    id: 'islas-marietas',
    slug: 'islas-marietas',
    name: 'Islas Marietas',
    region: 'Puerto Vallarta, Mexico',
    country: 'Mexico',
    latitude: 20.695,
    longitude: -105.568,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected island group at the mouth of Banderas Bay, a UNESCO biosphere reserve with caves, archways, and coral-dusted volcanic reef. Winter dives often feature humpback whale song and seasonal manta sightings.',
    highlights: ['Caves and archways', 'Whale song in winter', 'Biosphere reserve'],
    tags: ['reef', 'marine-park', 'caves', 'puerto-vallarta', 'pacific'],
    aliases: ['Marietas Islands'],
    maxDepthM: 20,
  },
  {
    id: 'jacksons-bight-little-cayman',
    slug: 'jacksons-bight-little-cayman',
    name: 'Jackson\'s Bight',
    region: 'Little Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.702,
    longitude: -80.055,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The wall system east of Bloody Bay, cut by sand chutes, tunnels and caverns that wind from the shallow shelf to the drop-off. Generally gentler topside conditions make it a staple of Little Cayman diving.',
    highlights: ['Sand chutes and tunnels', 'Wall honeycombed with caverns', 'Calm protected conditions'],
    tags: ['wall', 'jackson-bight', 'tunnels', 'caverns', 'marine-park'],
    maxDepthM: 30,
  },
  {
    id: 'jane-sea-wreck',
    slug: 'jane-sea-wreck',
    name: 'Jane Sea Wreck',
    region: 'Barcadera, Aruba',
    country: 'Aruba',
    latitude: 12.4735,
    longitude: -69.976,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 76-meter cement freighter scuttled upright near Barcadera reef, sitting on sand at about 27 meters with its propeller and deck heavily overgrown with orange cup coral. One of Aruba\'s most photogenic wrecks.',
    highlights: ['Upright intact freighter', 'Orange cup coral growth', 'Impressive propeller'],
    tags: ['wreck', 'boat-dive', 'aruba', 'coral', 'photography'],
    aliases: ['Jane C'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
    requirementNote: 'Deck and hull lie between 15 and 27 m; depth warrants advanced certification.',
  },
  {
    id: 'japanese-gardens-tobago',
    slug: 'japanese-gardens-tobago',
    name: 'Japanese Gardens',
    region: 'Speyside, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.298,
    longitude: -60.518,
    matchRadiusKm: 2,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'Speyside\'s most popular dive off Goat Island, a gentle drift over soft coral gardens whose sea whips and sponges evoke a manicured Japanese landscape. The dive often finishes through a rocky channel called Kamikaze Cut.',
    highlights: ['Soft coral gardens', 'Kamikaze Cut channel', 'Gentle drift'],
    tags: ['drift', 'boat-dive', 'tobago', 'soft-coral', 'speyside'],
    maxDepthM: 25,
  },
  {
    id: 'jardin-de-corail',
    slug: 'jardin-de-corail',
    name: 'Jardin de Corail',
    region: 'Pigeon Islands (Cousteau Reserve), Guadeloupe',
    country: 'Guadeloupe',
    latitude: 16.1685,
    longitude: -61.786,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The coral garden on the flanks of the Pigeon Islands inside the Cousteau Reserve, where hard and soft corals carpet the slope in a fully protected no-take zone. Tame fish life and easy depths make it Guadeloupe\'s most visited dive.',
    highlights: ['Cousteau Reserve protection', 'carpeted coral slope', 'very tame fish'],
    tags: ['reef', 'marine-reserve', 'guadeloupe', 'beginner', 'cousteau'],
    aliases: ['Coral Garden', 'Ilets Pigeon'],
    maxDepthM: 20,
  },
  {
    id: 'jardines-playa-del-carmen',
    slug: 'jardines-playa-del-carmen',
    name: 'Jardines Reef',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.61,
    longitude: -87.08,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow garden-like reef just off Playa del Carmen used heavily for training and easy fun dives. Low coral ridges over sand host turtles, rays, and plentiful reef fish.',
    highlights: ['Shallow coral gardens', 'Training-friendly', 'Turtles and rays'],
    tags: ['reef', 'shallow', 'beginner', 'playa-del-carmen', 'riviera-maya'],
    aliases: ['The Gardens'],
    maxDepthM: 12,
  },
  {
    id: 'jay-scutti',
    slug: 'jay-scutti',
    name: 'Jay Scutti',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.11,
    longitude: -80.089,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 96-foot tugboat scuttled in 1986 off Fort Lauderdale. The upright tug is small enough to explore fully in one dive and attracts schooling grunts and porkfish.',
    highlights: ['Upright tugboat', 'One-dive wreck', 'Schooling fish'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'fort lauderdale', 'intermediate'],
    maxDepthM: 21,
  },
  {
    id: 'jeep-reef-exuma',
    slug: 'jeep-reef-exuma',
    name: 'Jeep Reef',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 24.3,
    longitude: -76.55,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A brilliant, current-swept coral garden in the Exuma Cays Land and Sea Park named for the coral-encrusted jeep chassis at its center. Constant tidal flow keeps the shallow corals unusually vivid and the water clear.',
    highlights: ['Coral-encrusted jeep', 'Vivid current-fed corals', 'Bright shallow garden'],
    tags: ['reef', 'marine-park', 'exumas', 'shallow', 'photography'],
    maxDepthM: 9,
    requirementNote: 'Best at slack tide; current can be brisk mid-tide.',
  },
  {
    id: 'jim-atria',
    slug: 'jim-atria',
    name: 'Jim Atria',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.2,
    longitude: -80.075,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 240-foot Dutch coastal freighter sunk in 1987 and later shifted into deeper water by hurricane surge. The largely intact hull sits upright and is one of the most photogenic deep wrecks in Broward County.',
    highlights: ['Intact Dutch freighter', 'Upright profile', 'Photogenic deep wreck'],
    tags: ['wreck', 'freighter', 'deep', 'artificial reef', 'pompano'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
  },
  {
    id: 'joes-cave',
    slug: 'joes-cave',
    name: 'Joe\'s Cave',
    region: 'West Dog Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.481,
    longitude: -64.47,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A cathedral-like cavern at West Dog Island where shafts of light pierce schools of glassy sweepers inside the main chamber. Outside, boulders and ledges hold angelfish, jacks, and the occasional nurse shark.',
    highlights: ['light-shafted cavern', 'glassy sweeper schools', 'boulder terrain'],
    tags: ['cavern', 'bvi', 'dog-islands', 'photography', 'reef'],
    maxDepthM: 18,
  },
  {
    id: 'joes-tug',
    slug: 'joes-tug',
    name: 'Joe\'s Tug',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4524,
    longitude: -81.7369,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 75-foot steel shrimper-tug that sank off Key West in 1989 en route to an intended reef site, now sitting in about 20 meters. The broken bow and wheelhouse frame swarm with morays and barracuda.',
    highlights: ['Compact photogenic tug', 'Resident morays', 'Easy wreck orientation'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'key-west'],
    maxDepthM: 20,
  },
  {
    id: 'john-pennekamp-coral-reef-state-park',
    slug: 'john-pennekamp-coral-reef-state-park',
    name: 'John Pennekamp Coral Reef State Park',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1257,
    longitude: -80.4083,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'America\'s first undersea park, established in 1963, protecting a large swath of the Key Largo reef tract. Park concessions run daily snorkel and dive trips to its famous shallow reefs.',
    highlights: ['First US undersea park', 'Daily reef trips', 'Glass-bottom boat tours'],
    tags: ['florida', 'keys', 'destination', 'marine-park', 'snorkel'],
    aliases: ['Pennekamp'],
  },
  {
    id: 'jules-undersea-lodge',
    slug: 'jules-undersea-lodge',
    name: 'Jules\' Undersea Lodge',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1249,
    longitude: -80.399,
    matchRadiusKm: 2,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'The world\'s only underwater hotel, a converted research habitat sitting in the protected Emerald Lagoon in Key Largo. The lagoon itself is used for training dives and habitat visits.',
    highlights: ['Underwater hotel', 'Protected training lagoon', 'Former research habitat'],
    tags: ['florida', 'keys', 'lagoon', 'habitat', 'training'],
    aliases: ['Emerald Lagoon', 'Key Largo Undersea Park'],
    maxDepthM: 9,
  },
  {
    id: 'juniper-springs',
    slug: 'juniper-springs',
    name: 'Juniper Springs',
    region: 'Ocala National Forest, Florida',
    country: 'United States',
    latitude: 29.1834,
    longitude: -81.7124,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A historic CCC-era spring recreation area in the Ocala National Forest with a stone millhouse beside the swimming basin. Visitors swim and snorkel the clear pool; no scuba diving is offered.',
    highlights: ['Historic millhouse', 'Clear swimming basin', 'Famous canoe run'],
    tags: ['spring', 'snorkel', 'ocala-forest', 'swimming', 'historic'],
    maxDepthM: 5,
    requirementNote: 'Swimming and snorkeling only',
  },
  {
    id: 'juno-ledge',
    slug: 'juno-ledge',
    name: 'Juno Ledge',
    region: 'Juno Beach, Florida',
    country: 'United States',
    latitude: 26.88,
    longitude: -80.02,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A prominent natural ledge off Juno Beach dived as a fast Gulf Stream drift. The undercut wall is known for goliath grouper, loggerhead turtles, and seasonal lemon sharks.',
    highlights: ['Undercut wall', 'Lemon sharks in winter', 'Loggerhead turtles'],
    tags: ['drift', 'ledge', 'sharks', 'turtles', 'juno'],
    maxDepthM: 27,
  },
  {
    id: 'karpata',
    slug: 'karpata',
    name: 'Karpata',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.2194,
    longitude: -68.3514,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Classic northern Bonaire shore dive at a historic plantation site, with a steep coral slope and large elkhorn and star coral formations. Frequently rated among the island\'s best reefs, with an old ship anchor embedded in the reef.',
    highlights: ['Pristine hard coral slope', 'Historic anchor in the reef', 'Excellent visibility'],
    tags: ['shore-dive', 'coral', 'wall', 'bonaire', 'marine-park'],
    maxDepthM: 40,
  },
  {
    id: 'kathryn-wreck-jamaica',
    slug: 'kathryn-wreck-jamaica',
    name: 'Kathryn Wreck',
    region: 'Ocho Rios, Jamaica',
    country: 'Jamaica',
    latitude: 18.418,
    longitude: -77.118,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A former minesweeper scuttled off Ocho Rios in 1991 as an artificial reef, resting on sand at roughly 15 meters. The compact wreck is easy to circle in one dive and is well colonized by corals and reef fish.',
    highlights: ['Compact ex-minesweeper', 'Easy circumnavigation', 'Well-colonized hull'],
    tags: ['wreck', 'ocho-rios', 'artificial-reef', 'shallow', 'fish-life'],
    aliases: ['SS Kathryn'],
    maxDepthM: 15,
  },
  {
    id: 'kedge-ledge',
    slug: 'kedge-ledge',
    name: 'Kedge Ledge',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.458,
    longitude: -81.868,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow coral ledge in the Sand Key-Rock Key corridor named for the old kedge anchors wedged into its reef. Easy depths and historical hardware make it a favorite Key West second dive.',
    highlights: ['Antique anchors in the coral', 'Shallow ledge terrain', 'Close to Sand Key'],
    tags: ['florida', 'keys', 'reef', 'ledge', 'historic', 'key-west'],
    maxDepthM: 9,
  },
  {
    id: 'kelleston-drain',
    slug: 'kelleston-drain',
    name: 'Kelleston Drain',
    region: 'Speyside, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.293,
    longitude: -60.507,
    matchRadiusKm: 2,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'Drift dive south of Little Tobago that is home to one of the largest known brain corals in the world, roughly five meters across. Nutrient-rich currents draw tarpon, rays, and occasional hammerheads.',
    highlights: ['Giant brain coral', 'Tarpon and rays', 'Nutrient-rich drift'],
    tags: ['drift', 'boat-dive', 'tobago', 'brain-coral', 'speyside'],
    maxDepthM: 25,
  },
  {
    id: 'kings-spring',
    slug: 'kings-spring',
    name: 'King\'s Spring',
    region: 'Crystal River, Florida',
    country: 'United States',
    latitude: 28.889,
    longitude: -82.594,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'The largest spring in Kings Bay, off Banana Island at Crystal River, and a historic hub of Florida manatee diving. Divers circle the wide vent and ledges while manatees winter in the bay.',
    highlights: ['Largest Kings Bay spring', 'Winter manatee encounters', 'Boat-access boil'],
    tags: ['spring', 'manatees', 'crystal-river', 'boat-access', 'open-water'],
    aliases: ['Kings Spring'],
    maxDepthM: 9,
  },
  {
    id: 'klein-curacao',
    slug: 'klein-curacao',
    name: 'Klein Curaçao',
    region: 'Klein Curaçao, Curaçao',
    country: 'Curacao',
    latitude: 11.9865,
    longitude: -68.644,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Uninhabited island two hours by boat southeast of Curaçao, ringed by pristine reef walls, white sand, and a photogenic abandoned lighthouse. Drift dives along its leeward side feature turtles and excellent visibility.',
    highlights: ['Uninhabited island reefs', 'Excellent visibility', 'Turtles and drift dives'],
    tags: ['boat-dive', 'drift', 'curacao', 'island', 'wall'],
    maxDepthM: 35,
  },
  {
    id: 'kodiak-queen',
    slug: 'kodiak-queen',
    name: 'Kodiak Queen',
    region: 'Virgin Gorda, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.478,
    longitude: -64.428,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A WWII fuel barge that survived Pearl Harbor, sunk off Virgin Gorda in 2017 as an art reef crowned by a giant mesh kraken sculpture. The project doubles as a habitat restoration effort, and fish life has colonized the hull quickly.',
    highlights: ['Pearl Harbor survivor', 'kraken art installation', 'young artificial reef'],
    tags: ['wreck', 'art-reef', 'bvi', 'conservation', 'photography'],
    aliases: ['The Kraken Wreck'],
    maxDepthM: 17,
  },
  {
    id: 'labym',
    slug: 'labym',
    name: 'L\'Abym',
    region: 'Soufriere Bay, Dominica',
    country: 'Dominica',
    latitude: 15.222,
    longitude: -61.368,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A sheer wall along the drowned rim of Soufriere Bay\'s volcanic crater, dropping from near the surface into deep water. Its name — \'the abyss\' — fits the vertical face of barrel sponges, wire corals, and passing pelagics.',
    highlights: ['sheer crater wall', 'wire and black corals', 'bottomless blue'],
    tags: ['wall', 'deep', 'dominica', 'volcanic', 'advanced'],
    aliases: ['The Abyss'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'la-bocana-puerto-morelos',
    slug: 'la-bocana-puerto-morelos',
    name: 'La Bocana',
    region: 'Puerto Morelos, Mexico',
    country: 'Mexico',
    latitude: 20.86,
    longitude: -86.85,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A channel through the protected Puerto Morelos Reef National Park where nutrient flow supports dense coral and fish life. Shallow depths and mild current make it an easy, colorful park dive.',
    highlights: ['National park reef', 'Dense fish life', 'Easy shallow dive'],
    tags: ['reef', 'marine-park', 'shallow', 'puerto-morelos', 'riviera-maya'],
    maxDepthM: 12,
  },
  {
    id: 'la-corbetena',
    slug: 'la-corbetena',
    name: 'La Corbeteña',
    region: 'Puerto Vallarta, Mexico',
    country: 'Mexico',
    latitude: 20.74,
    longitude: -105.85,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An isolated rock far offshore from Banderas Bay where deep water on all sides brings tuna, wahoo, mantas, and sharks past volcanic ridges. Currents and exposure make it Puerto Vallarta\'s premier advanced trip.',
    highlights: ['Remote offshore rock', 'Big pelagic traffic', 'Volcanic ridges'],
    tags: ['pinnacle', 'pelagics', 'advanced', 'puerto-vallarta', 'pacific'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'la-danias-leap',
    slug: 'la-danias-leap',
    name: 'La Dania\'s Leap',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.2175,
    longitude: -68.348,
    matchRadiusKm: 2,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'One of Bonaire\'s few true wall dives, usually done as a one-way drift from a cliffside entry south toward Karpata. The vertical wall starts shallow and drops steeply, densely covered in sponges and corals.',
    highlights: ['Vertical wall', 'One-way drift to Karpata', 'Cliff jump entry'],
    tags: ['wall', 'drift', 'shore-dive', 'bonaire', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Cliff entry and deep wall; typically dived as a drift with pickup or exit at Karpata.',
  },
  {
    id: 'la-lobera-cabo-pulmo',
    slug: 'la-lobera-cabo-pulmo',
    name: 'La Lobera (Cabo Pulmo)',
    region: 'Cabo Pulmo, Mexico',
    country: 'Mexico',
    latitude: 23.415,
    longitude: -109.4,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A small sea lion colony on the rocks at the edge of Cabo Pulmo National Park, where juveniles buzz divers over a shallow boulder reef. It is usually dived as a playful shallow second tank.',
    highlights: ['Sea lion interactions', 'Shallow boulder reef', 'Relaxed second dive'],
    tags: ['reef', 'sea-lions', 'shallow', 'cabo-pulmo', 'sea-of-cortez'],
    maxDepthM: 12,
  },
  {
    id: 'la-piscine-guadeloupe',
    slug: 'la-piscine-guadeloupe',
    name: 'La Piscine',
    region: 'Pigeon Islands (Cousteau Reserve), Guadeloupe',
    country: 'Guadeloupe',
    latitude: 16.17,
    longitude: -61.787,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow sandy amphitheater between the Pigeon Islands nicknamed \'the swimming pool\' for its calm, clear water. It serves as the classic training and snorkeling spot of the Cousteau Reserve, alive with juvenile fish and a bronze Cousteau bust nearby.',
    highlights: ['calm sandy amphitheater', 'training-friendly', 'Cousteau bust nearby'],
    tags: ['reef', 'shallow', 'guadeloupe', 'cousteau', 'snorkel'],
    aliases: ['The Swimming Pool'],
    maxDepthM: 8,
  },
  {
    id: 'la-reina-cerralvo',
    slug: 'la-reina-cerralvo',
    name: 'La Reina',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.37,
    longitude: -109.9,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A lighthouse rock off the north tip of Isla Cerralvo with boulder reefs, a small sea lion colony, and summer visits from giant Pacific manta rays. The open-water location brings pelagics and occasional strong current.',
    highlights: ['Giant manta season', 'Sea lion colony', 'Boulder reef canyons'],
    tags: ['reef', 'mantas', 'sea-lions', 'la-paz', 'sea-of-cortez'],
    maxDepthM: 25,
  },
  {
    id: 'la-reinita',
    slug: 'la-reinita',
    name: 'La Reinita',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.36,
    longitude: -109.9,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A submerged pinnacle near La Reina off Isla Cerralvo, swept by nutrient-rich current that draws schooling jacks, snapper, and rays. It is typically paired with La Reina on Cerralvo day trips.',
    highlights: ['Submerged pinnacle', 'Schooling jacks', 'Current-swept rock'],
    tags: ['pinnacle', 'reef', 'current', 'la-paz', 'sea-of-cortez'],
    maxDepthM: 28,
    requiredCertification: 'AOW',
  },
  {
    id: 'ladder-labyrinth',
    slug: 'ladder-labyrinth',
    name: 'Ladder Labyrinth',
    region: 'Saba',
    country: 'Caribbean Netherlands',
    latitude: 17.63,
    longitude: -63.253,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A maze of volcanic ridges and sand channels below Saba\'s historic Ladder Bay, with hot springs venting through the sand in places. Groupers, jawfish, and flying gurnards inhabit the labyrinth\'s grooves.',
    highlights: ['volcanic ridge maze', 'underwater hot vents', 'flying gurnards'],
    tags: ['reef', 'volcanic', 'saba', 'marine-park', 'sand-channels'],
    maxDepthM: 24,
  },
  {
    id: 'lafayette-blue-springs',
    slug: 'lafayette-blue-springs',
    name: 'Lafayette Blue Springs',
    region: 'Mayo, Florida',
    country: 'United States',
    latitude: 30.1257,
    longitude: -83.226,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A first-magnitude spring and state park on the Suwannee River featuring a natural limestone bridge between its basins. Below lies an extensive cave system reserved for certified cave divers.',
    highlights: ['First-magnitude state park spring', 'Natural rock bridge', 'Extensive cave system'],
    tags: ['cave', 'spring', 'state-park', 'suwannee', 'overhead'],
    maxDepthM: 27,
    requiredCertification: 'FullCave',
    requirementNote: 'Cave-certified divers only in the system; open basin swimmable when river is low',
  },
  {
    id: 'lake-denton',
    slug: 'lake-denton',
    name: 'Lake Denton',
    region: 'Avon Park, Florida',
    country: 'United States',
    latitude: 27.576,
    longitude: -81.478,
    matchRadiusKm: 6,
    siteType: 'lake',
    difficulty: 'Beginner',
    summary: 'A small, unusually clear sand-bottom lake near Avon Park long used by central Florida dive shops for open-water training. Platforms and gentle slopes make it a dependable checkout site.',
    highlights: ['Clear training lake', 'Submerged platforms', 'Easy shore entry'],
    tags: ['lake', 'training', 'open-water', 'central-florida', 'freshwater'],
    maxDepthM: 12,
  },
  {
    id: 'lands-end-cabo',
    slug: 'lands-end-cabo',
    name: 'Land\'s End',
    region: 'Cabo San Lucas, Mexico',
    country: 'Mexico',
    latitude: 22.876,
    longitude: -109.893,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The rocky point beneath Cabo San Lucas\'s famous arch, where the Pacific meets the Sea of Cortez and a sea lion colony plays around boulder reefs. Currents and surge can pick up, but the marine life density is exceptional.',
    highlights: ['Playful sea lions', 'The Arch topside', 'Two-seas convergence'],
    tags: ['reef', 'sea-lions', 'boulders', 'cabo-san-lucas', 'pacific'],
    aliases: ['El Arco', 'Finisterra'],
    maxDepthM: 20,
  },
  {
    id: 'laughing-bird-caye',
    slug: 'laughing-bird-caye',
    name: 'Laughing Bird Caye',
    region: 'Placencia, Belize',
    country: 'Belize',
    latitude: 16.439,
    longitude: -88.198,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'National park islet off Placencia built on a rare faro, a ring-shaped reef atop the shelf lagoon, with coral gardens and channels in easy depths. A hub for reef restoration work and relaxed diving and snorkeling.',
    highlights: ['Rare faro reef structure', 'Coral restoration site', 'Easy depths'],
    tags: ['reef', 'national-park', 'belize', 'snorkeling', 'beginner-friendly'],
    maxDepthM: 20,
  },
  {
    id: 'lea-leas-lookout-little-cayman',
    slug: 'lea-leas-lookout-little-cayman',
    name: 'Lea Lea\'s Lookout',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.699,
    longitude: -80.084,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Bloody Bay Wall site with a wide chimney and dramatic overhangs where the wall bulges out over the abyss. Barrel sponges and black coral fans grow thick along the face.',
    highlights: ['Wide chimney descent', 'Overhanging wall formations', 'Black coral and barrel sponges'],
    tags: ['wall', 'bloody-bay', 'chimney', 'overhangs', 'marine-park'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Wall dive over very deep water.',
  },
  {
    id: 'leonoras-reef',
    slug: 'leonoras-reef',
    name: 'Leonora\'s Reef',
    region: 'Klein Bonaire, Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.164,
    longitude: -68.301,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Popular mooring on the north side of Klein Bonaire with a shallow terrace of staghorn and star coral leading to a lively slope. Known for good fish density and occasional frogfish.',
    highlights: ['Staghorn coral terrace', 'Dense reef fish', 'Frogfish sightings'],
    tags: ['boat-dive', 'coral', 'klein-bonaire', 'beginner-friendly', 'fish'],
    maxDepthM: 30,
  },
  {
    id: 'lesleen-m',
    slug: 'lesleen-m',
    name: 'Lesleen M',
    region: 'Anse Cochon, St. Lucia',
    country: 'Saint Lucia',
    latitude: 13.911,
    longitude: -61.054,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 165-foot freighter sunk in 1986 off Anse Cochon as an artificial reef, sitting upright in about 20 meters. Its accessible holds, engine room, and coral-fringed rails make it St. Lucia\'s most dived wreck.',
    highlights: ['upright 165-foot freighter', 'easy hold penetration', 'coral-fringed rails'],
    tags: ['wreck', 'artificial-reef', 'st-lucia', 'boat-dive', 'intermediate'],
    maxDepthM: 20,
  },
  {
    id: 'little-africa',
    slug: 'little-africa',
    name: 'Little Africa',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.638,
    longitude: -82.925,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow coral reef off the northwest side of Loggerhead Key shaped roughly like the African continent. Its calm, clear water and dense coral make it the park\'s premier snorkel reef.',
    highlights: ['Africa-shaped reef outline', 'Exceptional clarity', 'Dense shallow coral'],
    tags: ['florida', 'dry-tortugas', 'reef', 'snorkel', 'national-park', 'shallow'],
    maxDepthM: 4,
  },
  {
    id: 'little-conch-reef',
    slug: 'little-conch-reef',
    name: 'Little Conch Reef',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.945,
    longitude: -80.472,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef inshore of Conch Reef with scattered coral heads and the ballast remains of the 1733 galleon El Infante nearby. Easy depths make it a common second dive for Islamorada boats.',
    highlights: ['Shallow coral heads', 'Near 1733 galleon ballast', 'Easy conditions'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'historic'],
    maxDepthM: 7,
  },
  {
    id: 'lofthus-wreck',
    slug: 'lofthus-wreck',
    name: 'Lofthus',
    region: 'Manalapan, Florida',
    country: 'United States',
    latitude: 26.56,
    longitude: -80.03,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The remains of a Norwegian iron-hulled barque wrecked in 1898, now a Florida Underwater Archaeological Preserve off Manalapan. The scattered hull lies in shallow water reachable by kayak or short boat ride.',
    highlights: ['1898 sailing ship', 'Archaeological preserve', 'Shallow scatter site'],
    tags: ['wreck', 'historic', 'preserve', 'shallow', 'beginner'],
    maxDepthM: 6,
  },
  {
    id: 'loggerhead-key',
    slug: 'loggerhead-key',
    name: 'Loggerhead Key',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.6333,
    longitude: -82.9203,
    matchRadiusKm: 5,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'The largest island in the Dry Tortugas, crowned by an 1858 lighthouse and ringed by reefs including Little Africa and the Windjammer wreck. Accessible only by private or charter boat within the national park.',
    highlights: ['1858 Loggerhead lighthouse', 'Ringed by dive sites', 'Remote park island'],
    tags: ['florida', 'dry-tortugas', 'destination', 'lighthouse', 'national-park'],
  },
  {
    id: 'loggerhead-reef-jupiter',
    slug: 'loggerhead-reef-jupiter',
    name: 'Loggerhead Reef',
    region: 'Jupiter, Florida',
    country: 'United States',
    latitude: 26.93,
    longitude: -80.03,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A stretch of Jupiter\'s natural reef line named for the loggerhead turtles that rest under its ledges, especially during summer nesting season. Dived as a relaxed drift over soft-coral-covered bottom.',
    highlights: ['Loggerhead turtles', 'Summer nesting season', 'Soft coral bottom'],
    tags: ['drift', 'reef', 'turtles', 'jupiter', 'intermediate'],
    maxDepthM: 20,
  },
  {
    id: 'long-caye-aquarium',
    slug: 'long-caye-aquarium',
    name: 'Long Caye Aquarium',
    region: 'Lighthouse Reef, Belize',
    country: 'Belize',
    latitude: 17.223,
    longitude: -87.594,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Fittingly named wall-top site off Long Caye on Lighthouse Reef, where dense schools of tame reef fish swirl over a coral shelf before it drops into the wall. A common second dive after the Great Blue Hole.',
    highlights: ['Dense friendly fish schools', 'Coral shelf and wall', 'Popular Blue Hole trip stop'],
    tags: ['reef', 'wall', 'belize', 'lighthouse-reef', 'fish'],
    aliases: ['The Aquarium'],
    maxDepthM: 30,
  },
  {
    id: 'los-arcos-puerto-vallarta',
    slug: 'los-arcos-puerto-vallarta',
    name: 'Los Arcos (Puerto Vallarta)',
    region: 'Puerto Vallarta, Mexico',
    country: 'Mexico',
    latitude: 20.548,
    longitude: -105.297,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Granite arch islands in Banderas Bay protected as a marine park, with boulder reefs, a wall dropping toward the bay\'s deep canyon, and swim-through arches. Easy sites suit training while the Devil\'s Canyon wall entertains experienced divers.',
    highlights: ['Granite arches', 'Devil\'s Canyon wall', 'Marine park fish life'],
    tags: ['reef', 'wall', 'marine-park', 'puerto-vallarta', 'pacific'],
    maxDepthM: 25,
  },
  {
    id: 'los-islotes',
    slug: 'los-islotes',
    name: 'Los Islotes',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.594,
    longitude: -110.4,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Twin guano-capped islets north of Espíritu Santo hosting one of the most diver-friendly California sea lion colonies in the world. Shallow boulder reefs, an archway, and endlessly playful juveniles define the dive.',
    highlights: ['World-famous sea lion colony', 'Swim-through arch', 'Shallow playful diving'],
    tags: ['sea-lions', 'reef', 'espiritu-santo', 'la-paz', 'sea-of-cortez'],
    maxDepthM: 15,
    requirementNote: 'Colony access is restricted during the summer breeding closure (roughly June-August).',
  },
  {
    id: 'lost-blue-hole',
    slug: 'lost-blue-hole',
    name: 'Lost Blue Hole',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 25.03,
    longitude: -77.15,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Intermediate',
    summary: 'An oceanic blue hole roughly ten miles east of Nassau, with a rim at about 12 meters ringed by coral heads and a shaft dropping far deeper. Schools of snapper, stingrays, and reef sharks gather around the rim.',
    highlights: ['Circular blue hole rim', 'Reef sharks and stingrays', 'Coral heads around the edge'],
    tags: ['blue-hole', 'sharks', 'nassau', 'sand-flat', 'boat-dive'],
    aliases: ['Blue Hole Nassau'],
    maxDepthM: 60,
    requirementNote: 'Most dives stay on the rim at 12-14 m; the shaft descends beyond recreational limits.',
  },
  {
    id: 'man-o-war-shoals',
    slug: 'man-o-war-shoals',
    name: 'Man O\' War Shoals',
    region: 'Saba',
    country: 'Caribbean Netherlands',
    latitude: 17.645,
    longitude: -63.255,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Twin volcanic pinnacles off Saba\'s northwest corner rising from sand at about 21 meters, with a swimmable gap between them. The rocks are wrapped in sponges and swarmed by blackbar soldierfish and sergeant majors.',
    highlights: ['twin pinnacles', 'swim-through gap', 'dense fish clouds'],
    tags: ['pinnacle', 'saba', 'marine-park', 'volcanic', 'boat-dive'],
    maxDepthM: 21,
  },
  {
    id: 'mangel-halto',
    slug: 'mangel-halto',
    name: 'Mangel Halto',
    region: 'Pos Chiquito, Aruba',
    country: 'Aruba',
    latitude: 12.4515,
    longitude: -69.967,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Mangrove-fringed lagoon on Aruba\'s southeast coast where divers cross the shallows to a sloping outer reef that drops past 30 meters. Known for seahorses, juvenile fish in the mangroves, and good macro life.',
    highlights: ['Mangrove nursery shallows', 'Sloping outer reef', 'Seahorses'],
    tags: ['shore-dive', 'mangroves', 'aruba', 'macro', 'reef'],
    maxDepthM: 33,
  },
  {
    id: 'maracaibo-reef',
    slug: 'maracaibo-reef',
    name: 'Maracaibo Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.27,
    longitude: -87.02,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'The southernmost and deepest of Cozumel\'s regularly dived reefs, exposed to strong, unpredictable currents at the island\'s tip. The deep wall and blue-water exposure attract sharks, eagle rays, and other pelagics.',
    highlights: ['Deep exposed wall', 'Shark and ray encounters', 'Strong currents'],
    tags: ['wall', 'drift', 'deep', 'pelagics', 'cozumel', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'margate-bay',
    slug: 'margate-bay',
    name: 'Margate Bay',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.052,
    longitude: -68.281,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Quiet southern Bonaire shore dive named for the margate snapper often seen here, with a well-developed sloping reef and soft coral shallows. Currents can pick up this far south.',
    highlights: ['Uncrowded southern reef', 'Soft coral shallows', 'Schooling snappers'],
    tags: ['shore-dive', 'coral', 'bonaire', 'south-coast', 'fish'],
    maxDepthM: 35,
  },
  {
    id: 'marilyns-cut-little-cayman',
    slug: 'marilyns-cut-little-cayman',
    name: 'Marilyn\'s Cut',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.699,
    longitude: -80.078,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A crevice through the lip of Bloody Bay Wall that funnels divers onto a face carpeted in rope sponges and gorgonians. Long famous for friendly Nassau groupers that shadow divers along the wall.',
    highlights: ['Cut through the wall lip', 'Famously friendly groupers', 'Sponge-carpeted wall'],
    tags: ['wall', 'bloody-bay', 'groupers', 'sponges', 'marine-park'],
    aliases: ['Hole in the Wall'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Wall dive over very deep water.',
  },
  {
    id: 'marquesas-keys',
    slug: 'marquesas-keys',
    name: 'Marquesas Keys',
    region: 'Marquesas Keys, Florida',
    country: 'United States',
    latitude: 24.573,
    longitude: -82.135,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'An uninhabited ring of mangrove islands about 25 miles west of Key West within the national wildlife refuge, reachable only by boat. Surrounding flats, patch reefs, and the Atocha treasure grounds draw adventurous divers.',
    highlights: ['Uninhabited atoll-like ring', 'Pristine flats and patch reefs', 'Atocha treasure history'],
    tags: ['florida', 'keys', 'destination', 'remote', 'wildlife-refuge'],
    aliases: ['The Marquesas'],
  },
  {
    id: 'maryland-shoal',
    slug: 'maryland-shoal',
    name: 'Maryland Shoal',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.51,
    longitude: -81.578,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A charted patch-reef shoal between American Shoal and Pelican Shoal in the Lower Keys. Low-relief coral and ledge habitat hold snapper, grouper, and hogfish away from the crowds.',
    highlights: ['Quiet charted shoal', 'Snapper and hogfish', 'Low-relief coral ledges'],
    tags: ['florida', 'keys', 'reef', 'ledge', 'lower-keys'],
    maxDepthM: 8,
  },
  {
    id: 'mayreau-gardens',
    slug: 'mayreau-gardens',
    name: 'Mayreau Gardens',
    region: 'Mayreau, the Grenadines',
    country: 'Saint Vincent and the Grenadines',
    latitude: 12.645,
    longitude: -61.38,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A current-brushed coral garden in the channel between Mayreau and the Tobago Cays, drifted over ridges of soft coral and sea fans. Turtles, rays, and nurse sharks appear regularly in the flow.',
    highlights: ['soft coral ridges', 'regular turtle traffic', 'gentle channel drift'],
    tags: ['drift', 'reef', 'grenadines', 'tobago-cays', 'current'],
    maxDepthM: 20,
  },
  {
    id: 'mcdonalds-grand-turk',
    slug: 'mcdonalds-grand-turk',
    name: 'McDonald\'s',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.475,
    longitude: -71.155,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Grand Turk west wall dive named for a large coral archway at the reef lip that divers swim beneath onto the face. The wall here starts remarkably shallow, minutes from the beach, and drops into the 2,000-meter Turks Island Passage.',
    highlights: ['Golden coral arch', 'Wall minutes from shore', 'Turks Island Passage blue'],
    tags: ['wall', 'grand-turk', 'arch', 'drop-off', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'mearson-spring',
    slug: 'mearson-spring',
    name: 'Mearson Spring',
    region: 'Mayo, Florida',
    country: 'United States',
    latitude: 30.145,
    longitude: -83.245,
    matchRadiusKm: 6,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A Suwannee River bank spring near Mayo with a strong-flow cave entrance known among north Florida cave divers. River level dictates access and visibility.',
    highlights: ['High-flow cave entrance', 'Suwannee riverbank site', 'Low-traffic dive'],
    tags: ['cave', 'spring', 'suwannee', 'overhead', 'north-florida'],
    maxDepthM: 21,
    requiredCertification: 'FullCave',
    requirementNote: 'Cave-certified divers only; dive only at low river levels',
  },
  {
    id: 'mercedes-i',
    slug: 'mercedes-i',
    name: 'Mercedes I',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.13,
    longitude: -80.08,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 197-foot freighter that famously washed onto a Palm Beach seawall during a 1984 storm before being scuttled off Fort Lauderdale in 1985. The broken wreck lies in about 30 meters and is a signature Broward County dive.',
    highlights: ['Famous 1984 grounding story', 'Broken freighter sections', 'Signature Broward wreck'],
    tags: ['wreck', 'freighter', 'artificial reef', 'deep', 'fort lauderdale'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'middle-sambo',
    slug: 'middle-sambo',
    name: 'Middle Sambo',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.485,
    longitude: -81.692,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The central reef of the Sambo chain east of Key West, offering shallow coral ridges with grunts, snapper, and frequent turtle sightings. Usually calmer and less visited than Western Sambo.',
    highlights: ['Quiet shallow ridges', 'Turtles and rays', 'Easy conditions'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'key-west'],
    maxDepthM: 8,
  },
  {
    id: 'mikes-wreck',
    slug: 'mikes-wreck',
    name: 'Mike\'s Wreck',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.15,
    longitude: -80.2553,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'An unidentified early steamship wreck on the northern end of Elbow Reef, named for a local dive operator. Low-lying hull remains shelter grunts, snapper, and the occasional nurse shark.',
    highlights: ['Unidentified historic wreck', 'Fishy shallow site', 'Easy navigation'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'mill-creek-sink',
    slug: 'mill-creek-sink',
    name: 'Mill Creek Sink',
    region: 'Alachua, Florida',
    country: 'United States',
    latitude: 29.787,
    longitude: -82.468,
    matchRadiusKm: 5,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'A tannic sinkhole near the town of Alachua managed as an NSS-CDS dive preserve, dropping into a deep, extensive cave system. Access requires conservancy permission and full cave credentials.',
    highlights: ['NSS-CDS preserve', 'Deep cave system', 'Technical exploration site'],
    tags: ['sinkhole', 'cave', 'deep', 'restricted-access', 'overhead'],
    requiredCertification: 'FullCave',
    requirementNote: 'NSS-CDS access rules; full cave certification required, deep sections need trimix',
  },
  {
    id: 'miss-louise',
    slug: 'miss-louise',
    name: 'Miss Louise',
    region: 'Destin, Florida',
    country: 'United States',
    latitude: 30.36,
    longitude: -86.47,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A push tug scuttled in 1997 off Destin in modest depth, making it one of the area\'s most accessible wrecks. The compact hull is packed with baitfish and visited by turtles and rays.',
    highlights: ['Accessible tug wreck', 'Dense baitfish', 'Turtle visits'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'destin', 'beginner'],
    maxDepthM: 18,
  },
  {
    id: 'miss-opportunity',
    slug: 'miss-opportunity',
    name: 'Miss Opportunity',
    region: 'St. Thomas, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.315,
    longitude: -65,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A former hospital barge sunk as an artificial reef off the south coast of St. Thomas, lying on its side in about 28 meters. Its long corridors and room compartments attract schooling fish and the occasional turtle.',
    highlights: ['hospital barge on its side', 'fish-filled compartments', 'often paired with WIT Shoal'],
    tags: ['wreck', 'deep', 'artificial-reef', 'usvi', 'boat-dive'],
    maxDepthM: 28,
    requiredCertification: 'AOW',
  },
  {
    id: 'mixing-bowl-little-cayman',
    slug: 'mixing-bowl-little-cayman',
    name: 'Mixing Bowl',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.7,
    longitude: -80.068,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The junction where Bloody Bay Wall meets Jackson Bight, mixing sheer vertical wall with sloping spur-and-groove reef. The shallow sand shelf on top is superb for long safety-stop critter hunts.',
    highlights: ['Meeting of two wall systems', 'Shallow sandy reef top', 'Rich macro life'],
    tags: ['wall', 'bloody-bay', 'jackson-bight', 'macro', 'marine-park'],
    aliases: ['Three Fathom Wall'],
    maxDepthM: 30,
  },
  {
    id: 'mizpah-corridor',
    slug: 'mizpah-corridor',
    name: 'Mizpah Corridor',
    region: 'West Palm Beach, Florida',
    country: 'United States',
    latitude: 26.79,
    longitude: -80.02,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A drift-diveable string of wrecks off Singer Island including the Mizpah, a 185-foot former luxury yacht sunk in 1968, the patrol craft PC-1174, and a section of the Amaryllis. Goliath grouper aggregate here in late summer.',
    highlights: ['Multi-wreck drift', 'Historic Greek yacht', 'Goliath aggregation'],
    tags: ['wreck', 'drift', 'corridor', 'goliath grouper', 'palm beach'],
    aliases: ['Corridor Wrecks', 'Mizpah', 'PC-1174', 'Amaryllis'],
    maxDepthM: 27,
  },
  {
    id: 'moc-che-reef',
    slug: 'moc-che-reef',
    name: 'Moc-Che Reef',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.66,
    longitude: -87.05,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Beginner',
    summary: 'A pair of shallow and deep coral ridges north of Playa del Carmen with swim-throughs and dense soft coral growth. The gentle current suits newer divers while still offering turtles and moray eels.',
    highlights: ['Small swim-throughs', 'Soft coral ridges', 'Gentle drift'],
    tags: ['reef', 'drift', 'coral', 'playa-del-carmen', 'riviera-maya'],
    maxDepthM: 18,
  },
  {
    id: 'mona-island-puerto-rico',
    slug: 'mona-island-puerto-rico',
    name: 'Mona Island',
    region: 'Mona Passage, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.083,
    longitude: -67.893,
    matchRadiusKm: 10,
    siteType: 'destination',
    difficulty: 'Advanced',
    summary: 'A remote uninhabited nature reserve in the Mona Passage, ringed by pristine walls and reefs with visibility often exceeding 45 meters. Reached only by long charter crossings, it offers Puerto Rico\'s wildest diving with sharks and pelagics.',
    highlights: ['Pristine remote walls', 'Exceptional visibility', 'Shark and pelagic action'],
    tags: ['destination', 'remote', 'wall', 'sharks', 'nature-reserve'],
    aliases: ['Isla de Mona'],
    requiredCertification: 'AOW',
    requirementNote: 'Remote open-ocean location with current; experience required by most charters.',
  },
  {
    id: 'monkey-shoals',
    slug: 'monkey-shoals',
    name: 'Monkey Shoals',
    region: 'Between St. Kitts and Nevis',
    country: 'Saint Kitts and Nevis',
    latitude: 17.222,
    longitude: -62.698,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A broad offshore coral plateau in the channel southwest of St. Kitts, dived by operators from both St. Kitts and Nevis. Its flats, crevices, and drop-offs hold nurse sharks, turtles, angelfish, and occasional seasonal pelagics.',
    highlights: ['offshore coral plateau', 'nurse sharks', 'dived from both islands'],
    tags: ['reef', 'offshore', 'st-kitts', 'nevis', 'plateau'],
    maxDepthM: 30,
  },
  {
    id: 'morrison-springs',
    slug: 'morrison-springs',
    name: 'Morrison Springs',
    region: 'Ponce de Leon, Florida',
    country: 'United States',
    latitude: 30.6573,
    longitude: -85.9046,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A large, sandy-bottomed spring basin on the Choctawhatchee River floodplain with three cavities descending into a cave system. The county park offers easy access, a boardwalk, and a popular cavern entrance in the main vent.',
    highlights: ['250-ft-wide spring basin', 'Three vents and cavern zone', 'Free county park access'],
    tags: ['spring', 'cavern', 'panhandle', 'freshwater', 'training'],
    maxDepthM: 27,
    requiredCertification: 'Cavern',
    requirementNote: 'Open water divers stay in the basin; cavern and cave zones require overhead training',
  },
  {
    id: 'mortera-wreck-cuba',
    slug: 'mortera-wreck-cuba',
    name: 'Mortera Wreck',
    region: 'Santa Lucía, Cuba',
    country: 'Cuba',
    latitude: 21.6,
    longitude: -77.1,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A Spanish steamship sunk in 1898 at the mouth of the Nuevitas channel near Santa Lucía, now a fish-covered wreck famous for its resident bull sharks. Local divemasters have long run shark encounters here in season.',
    highlights: ['19th-century steamship', 'Bull shark encounters', 'Channel-mouth fish life'],
    tags: ['wreck', 'sharks', 'santa-lucia', 'historic', 'channel'],
    aliases: ['Nuestra Señora de la Mortera'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
    requirementNote: 'Depth and channel current; shark dives are guided.',
  },
  {
    id: 'mosquito-bank',
    slug: 'mosquito-bank',
    name: 'Mosquito Bank',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.0712,
    longitude: -80.3938,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A marked patch-reef bank in Hawk Channel off Key Largo, popular for shallow second dives and snorkel trips. Big coral heads rise from grass and sand with plentiful juvenile fish.',
    highlights: ['Large patch coral heads', 'Calm inshore water', 'Juvenile fish habitat'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'snorkel', 'shallow'],
    maxDepthM: 6,
  },
  {
    id: 'mount-irvine-wall',
    slug: 'mount-irvine-wall',
    name: 'Mount Irvine Wall',
    region: 'Mount Irvine, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.191,
    longitude: -60.793,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Rocky wall and boulder slope off Mount Irvine Bay known for its dense macro life, including seahorses, octopus, and moray eels in the crevices. A relaxed site often dived at night.',
    highlights: ['Seahorses and octopus', 'Boulder crevices', 'Good night dive'],
    tags: ['reef', 'wall', 'tobago', 'macro', 'night-dive'],
    maxDepthM: 20,
  },
  {
    id: 'musa-manchones',
    slug: 'musa-manchones',
    name: 'MUSA Underwater Museum (Manchones)',
    region: 'Isla Mujeres, Mexico',
    country: 'Mexico',
    latitude: 21.2,
    longitude: -86.73,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The main gallery of the Museo Subacuático de Arte, with hundreds of life-size sculptures by Jason deCaires Taylor placed at about 8-10 m near Manchones Reef. The statues now function as artificial reefs colonized by coral and fish.',
    highlights: ['Hundreds of sculptures', 'Artificial reef art', 'Shallow easy diving'],
    tags: ['artificial-reef', 'sculptures', 'shallow', 'isla-mujeres', 'cancun'],
    aliases: ['MUSA', 'Underwater Museum of Art'],
    maxDepthM: 10,
  },
  {
    id: 'mushroom-forest',
    slug: 'mushroom-forest',
    name: 'Mushroom Forest',
    region: 'Santa Cruz, Curaçao',
    country: 'Curacao',
    latitude: 12.344,
    longitude: -69.143,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Curaçao\'s signature dive, a plateau of large star coral heads eroded at their bases into mushroom shapes spread across a sandy bottom around 15 meters. Usually reached by boat and often combined with the nearby Blue Room cavern.',
    highlights: ['Mushroom-shaped coral heads', 'Signature Curaçao dive', 'Combined with Blue Room'],
    tags: ['boat-dive', 'coral', 'curacao', 'unique-topography', 'photography'],
    maxDepthM: 18,
  },
  {
    id: 'captain-keith-tibbetts-cayman-brac',
    slug: 'captain-keith-tibbetts-cayman-brac',
    name: 'MV Captain Keith Tibbetts',
    region: 'Cayman Brac, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.71,
    longitude: -79.876,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 100-meter Russian-built Koni-class frigate scuttled off Cayman Brac in 1996, the only diveable Soviet warship in the Western Hemisphere. The bow section with its twin gun turrets lies deeper, while the stern sits in the sand around 14-18 meters.',
    highlights: ['Soviet frigate with gun turrets', 'Bow and stern at different depths', 'Resident groupers and jacks'],
    tags: ['wreck', 'warship', 'artificial-reef', 'cayman-brac', 'photography'],
    aliases: ['Russian Destroyer 356', 'Tibbetts Wreck'],
    maxDepthM: 26,
    requiredCertification: 'AOW',
    requirementNote: 'Bow section lies near 26 m; penetration for trained wreck divers only.',
  },
  {
    id: 'comberbach-wreck',
    slug: 'comberbach-wreck',
    name: 'MV Comberbach Wreck',
    region: 'Long Island, Bahamas',
    country: 'Bahamas',
    latitude: 23.66,
    longitude: -75.34,
    matchRadiusKm: 7,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 31-meter British-built freighter scuttled by Stella Maris in 1986 off Cape Santa Maria, sitting upright on sand at about 30 meters. The intact hull and holds attract groupers, jacks, and the occasional shark.',
    highlights: ['Upright intact freighter', 'Open holds to explore', 'Deep clear water'],
    tags: ['wreck', 'deep', 'long-island', 'artificial-reef', 'boat-dive'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'mv-maverick',
    slug: 'mv-maverick',
    name: 'MV Maverick',
    region: 'Mount Irvine, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.187,
    longitude: -60.795,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'Former Trinidad-Tobago car ferry scuttled in 1997 off Rocky Point, sitting upright on sand at about 30 meters. The open car deck and wheelhouse are heavily colonized and patrolled by jacks and barracuda.',
    highlights: ['Upright intact ferry', 'Swim-through car deck', 'Jacks and barracuda'],
    tags: ['wreck', 'boat-dive', 'tobago', 'deep', 'advanced'],
    aliases: ['Scarlet Ibis'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Deck at ~21 m, sand at ~30 m; currents can be present.',
  },
  {
    id: 'mv-sarah-anguilla',
    slug: 'mv-sarah-anguilla',
    name: 'MV Sarah',
    region: 'Road Bay, Anguilla',
    country: 'Anguilla',
    latitude: 18.207,
    longitude: -63.108,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'The largest of Anguilla\'s fleet of intentionally sunk freighters, the 230-foot MV Sarah was scuttled in 1990 off the island\'s northwest coast. The upright hull hosts barracuda, snapper, and thick sponge growth.',
    highlights: ['230-foot freighter', 'upright and intact', 'resident barracuda'],
    tags: ['wreck', 'artificial-reef', 'anguilla', 'boat-dive', 'sponges'],
    maxDepthM: 24,
  },
  {
    id: 'mv-talata',
    slug: 'mv-talata',
    name: 'MV Talata',
    region: 'St. Kitts',
    country: 'Saint Kitts and Nevis',
    latitude: 17.268,
    longitude: -62.69,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A freighter resting on sand off St. Kitts\' southern coast in about 21 meters, its holds sheltering schools of squirrelfish and grunts. Rays and turtles frequent the surrounding seagrass and sand.',
    highlights: ['intact freighter holds', 'schooling squirrelfish', 'rays on the sand'],
    tags: ['wreck', 'st-kitts', 'boat-dive', 'artificial-reef', 'sand'],
    maxDepthM: 21,
  },
  {
    id: 'nags-head',
    slug: 'nags-head',
    name: 'Nags Head',
    region: 'St. Kitts',
    country: 'Saint Kitts and Nevis',
    latitude: 17.23,
    longitude: -62.658,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'At the southern tip of St. Kitts where Caribbean and Atlantic waters meet, currents sweep divers along boulders and coral heads in the strait known as The Narrows. The moving water draws rays, jacks, and larger reef predators.',
    highlights: ['current-swept point', 'Atlantic-Caribbean convergence', 'big fish traffic'],
    tags: ['drift', 'current', 'st-kitts', 'advanced', 'boulders'],
    maxDepthM: 24,
  },
  {
    id: 'nahoon-wreck',
    slug: 'nahoon-wreck',
    name: 'Nahoon',
    region: 'Anses d\'Arlet, Martinique',
    country: 'Martinique',
    latitude: 14.492,
    longitude: -61.095,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A steel-hulled three-masted schooner scuttled off Martinique\'s southwest coast in 1993, resting on sand around 34 meters. Its masts and rigging silhouette beautifully in the clear water, drawing wreck photographers.',
    highlights: ['three-masted schooner', 'photogenic masts and rigging', 'clear-water silhouettes'],
    tags: ['wreck', 'deep', 'martinique', 'photography', 'advanced'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
  },
  {
    id: 'nancys-cup-of-tea-little-cayman',
    slug: 'nancys-cup-of-tea-little-cayman',
    name: 'Nancy\'s Cup of Tea',
    region: 'Little Cayman (Jackson Bight), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.701,
    longitude: -80.062,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Jackson Bight wall site on Little Cayman\'s north shore where a coral chimney drops through the reef onto a face lush with sponges. Eagle rays and turtles cruise the blue alongside the wall.',
    highlights: ['Coral chimney', 'Lush sponge growth', 'Eagle rays in the blue'],
    tags: ['wall', 'jackson-bight', 'chimney', 'eagle-rays', 'marine-park'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Wall dive over very deep water.',
  },
  {
    id: 'navarre-beach-marine-sanctuary',
    slug: 'navarre-beach-marine-sanctuary',
    name: 'Navarre Beach Marine Sanctuary',
    region: 'Navarre Beach, Florida',
    country: 'United States',
    latitude: 30.377,
    longitude: -86.86,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A set of artificial reef modules placed in shallow water just off Navarre Beach, reachable by an easy swim from shore. The structures attract sea turtles, octopus, and schooling baitfish.',
    highlights: ['Swim-from-shore reef', 'Sea turtles', 'Snorkel friendly'],
    tags: ['artificial reef', 'shore dive', 'snorkel', 'shallow', 'navarre'],
    maxDepthM: 5,
  },
  {
    id: 'neptunes-finger',
    slug: 'neptunes-finger',
    name: 'Neptune\'s Finger',
    region: 'Cabo San Lucas, Mexico',
    country: 'Mexico',
    latitude: 22.879,
    longitude: -109.896,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A finger-shaped rock pinnacle in Cabo San Lucas bay whose wall drops steeply along the submarine canyon edge. Divers follow the wall past sandfalls, schooling porkfish, and passing mobula rays.',
    highlights: ['Steep canyon wall', 'Sandfall viewpoints', 'Mobula ray fly-bys'],
    tags: ['wall', 'reef', 'canyon', 'cabo-san-lucas', 'pacific'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'neptuno-wreck-cuba',
    slug: 'neptuno-wreck-cuba',
    name: 'Neptuno Wreck',
    region: 'Varadero, Cuba',
    country: 'Cuba',
    latitude: 23.18,
    longitude: -81.17,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'The remains of an early 20th-century steel cargo steamer lying off Varadero, one of the resort area\'s standard boat-dive wrecks. Broken hull sections shelter grunts, snappers and the occasional green moray.',
    highlights: ['Historic steel steamer', 'Fish-filled hull sections', 'Varadero\'s classic wreck'],
    tags: ['wreck', 'varadero', 'historic', 'boat-dive', 'fish-life'],
  },
  {
    id: 'new-guinea-reef',
    slug: 'new-guinea-reef',
    name: 'New Guinea Reef',
    region: 'Petit Byahaut, St. Vincent',
    country: 'Saint Vincent and the Grenadines',
    latitude: 13.185,
    longitude: -61.265,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A steep volcanic reef near Petit Byahaut famous for one of the Caribbean\'s densest stands of black coral in recreational depths. Frogfish, seahorses, and other rare critters reward careful searching.',
    highlights: ['dense black coral', 'frogfish and seahorses', 'steep volcanic slope'],
    tags: ['reef', 'black-coral', 'st-vincent', 'critters', 'wall'],
    maxDepthM: 30,
  },
  {
    id: 'newfound-harbor',
    slug: 'newfound-harbor',
    name: 'Newfound Harbor',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.6153,
    longitude: -81.3922,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A very shallow inshore patch-reef Sanctuary Preservation Area near Big Pine Key, close to the private island of Little Palm. Its calm, protected coral heads are a staple for snorkel trips.',
    highlights: ['Inshore SPA patch reefs', 'Snorkel-depth coral heads', 'Protected from ocean swell'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'spa', 'snorkel'],
    aliases: ['Newfound Harbor Key'],
    maxDepthM: 5,
  },
  {
    id: 'nine-foot-stake',
    slug: 'nine-foot-stake',
    name: 'Nine Foot Stake',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.457,
    longitude: -81.75,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow hardbottom and coral-head site near the Key West ship channel, named for an old channel stake. Scattered heads, sea fans, and cleaning stations make it a relaxed shallow dive and night-dive spot.',
    highlights: ['Scattered coral heads', 'Popular night dive', 'Cleaning station activity'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'night-dive', 'key-west'],
    maxDepthM: 8,
  },
  {
    id: 'north-america-wreck',
    slug: 'north-america-wreck',
    name: 'North America',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.6325,
    longitude: -81.088,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The sand-buried remains of an 1842 sailing ship on Delta Shoal, part of the Florida Keys Shipwreck Trail. Timber frames and scattered fittings emerge from the shallow sand pocket.',
    highlights: ['1842 sailing wreck', 'Shipwreck Trail site', 'Very shallow depth'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shipwreck-trail', 'shallow'],
    maxDepthM: 5,
  },
  {
    id: 'north-dry-rocks',
    slug: 'north-dry-rocks',
    name: 'North Dry Rocks',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.1268,
    longitude: -80.2937,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef just north of Key Largo Dry Rocks known for the Minnow Caves, narrow cuts that fill with shimmering clouds of silverside minnows in summer. Easy depths suit all levels.',
    highlights: ['Minnow Caves', 'Summer silverside swarms', 'Shallow coral cuts'],
    tags: ['florida', 'keys', 'reef', 'swim-through', 'shallow'],
    aliases: ['Minnow Caves'],
    maxDepthM: 8,
  },
  {
    id: 'north-north-dry-rocks',
    slug: 'north-north-dry-rocks',
    name: 'North North Dry Rocks',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.131,
    longitude: -80.2907,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A compact shallow reef just up-current of North Dry Rocks with coral canyons and swim-throughs cut into the spur-and-groove. A favorite easy drift for Key Largo boats.',
    highlights: ['Coral canyons', 'Small swim-throughs', 'Shallow and bright'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'northwind-wreck',
    slug: 'northwind-wreck',
    name: 'Northwind',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.732,
    longitude: -64.893,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 75-foot oceangoing tug sunk in the mid-1980s, the shallowest of the Butler Bay wrecks at around 15 meters. The compact hull is fully colonized and often circled by schools of snapper.',
    highlights: ['shallow tugboat', 'easy first wreck', 'schooling snapper'],
    tags: ['wreck', 'shallow', 'usvi', 'butler-bay', 'beginner'],
    maxDepthM: 15,
  },
  {
    id: 'noula-express',
    slug: 'noula-express',
    name: 'Noula Express',
    region: 'Boca Raton, Florida',
    country: 'United States',
    latitude: 26.36,
    longitude: -80.05,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 114-foot coastal freighter scuttled in 1988 off Boca Raton. The wreck has broken with age but remains a fishy, easy-to-navigate artificial reef at recreational depth.',
    highlights: ['Coastal freighter', 'Easy navigation', 'Abundant reef fish'],
    tags: ['wreck', 'freighter', 'artificial reef', 'boca raton', 'intermediate'],
    maxDepthM: 22,
  },
  {
    id: 'nukove',
    slug: 'nukove',
    name: 'Nukove',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.2355,
    longitude: -68.369,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Remote northwest Bonaire site reached by a rough dirt road, with a sand chute entry through a small break in the elkhorn coral. Rewarding, lightly dived reef with dense coral cover.',
    highlights: ['Remote and uncrowded', 'Elkhorn coral shallows', 'Sand chute entry'],
    tags: ['shore-dive', 'coral', 'remote', 'bonaire', 'marine-park'],
    maxDepthM: 35,
  },
  {
    id: 'oil-slick-leap',
    slug: 'oil-slick-leap',
    name: 'Oil Slick Leap',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.196,
    longitude: -68.312,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Named for a refinery project that never happened, this site features a giant-stride entry from a low ironshore ledge with a ladder for exit. A healthy sloping reef begins almost immediately below the entry point.',
    highlights: ['Giant-stride ledge entry', 'Healthy sloping reef', 'Frequent turtles'],
    tags: ['shore-dive', 'coral', 'ledge-entry', 'bonaire', 'marine-park'],
    maxDepthM: 35,
  },
  {
    id: 'okinawa',
    slug: 'okinawa',
    name: 'Okinawa',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.25,
    longitude: -80.07,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 107-foot tugboat scuttled in 2011 as the first vessel of Pompano Beach\'s Shipwreck Park. It sits at a comfortable recreational depth and has developed rich sponge and coral growth.',
    highlights: ['Shipwreck Park tug', 'Comfortable depth', 'Good sponge growth'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'pompano', 'intermediate'],
    maxDepthM: 22,
  },
  {
    id: 'ol-blue-bonaire',
    slug: 'ol-blue-bonaire',
    name: 'Ol\' Blue (Tolo)',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.211,
    longitude: -68.335,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Easy shore entry off a coral rubble beach on the scenic north coast road, with a shallow terrace leading to a healthy sloping reef. Popular for both snorkeling and diving.',
    highlights: ['Easy beach entry', 'Shallow coral terrace', 'Good snorkeling'],
    tags: ['shore-dive', 'coral', 'beginner-friendly', 'bonaire', 'snorkeling'],
    aliases: ['Tolo'],
    maxDepthM: 30,
  },
  {
    id: 'orange-canyon-grand-cayman',
    slug: 'orange-canyon-grand-cayman',
    name: 'Orange Canyon',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.387,
    longitude: -81.416,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Named for the clusters of orange elephant ear sponges that cover its coral pinnacles near Northwest Point. A canyon leads out to a sponge-covered wall with frequent eagle ray sightings.',
    highlights: ['Orange elephant ear sponges', 'Canyon to the wall', 'Eagle ray sightings'],
    tags: ['wall', 'sponges', 'canyons', 'northwest-point', 'eagle-rays'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Best structure sits below 20 m on the wall.',
  },
  {
    id: 'orion-wreck',
    slug: 'orion-wreck',
    name: 'Orion',
    region: 'Miami, Florida',
    country: 'United States',
    latitude: 25.845,
    longitude: -80.077,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 118-foot tugboat sunk in 1981 off Miami Beach as an artificial reef. The compact wreck is easy to circumnavigate and holds dense clouds of baitfish with visiting barracuda.',
    highlights: ['Intact tugboat', 'Easy navigation', 'Baitfish clouds'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'miami', 'intermediate'],
    maxDepthM: 29,
  },
  {
    id: 'oro-verde-wreck-grand-cayman',
    slug: 'oro-verde-wreck-grand-cayman',
    name: 'Oro Verde Wreck',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.335,
    longitude: -81.39,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A cargo ship scuttled in 1980 off Seven Mile Beach, now broken into debris fields that shelter abundant fish life. Storms have scattered the hull, making it a fishy rummage rather than an intact wreck.',
    highlights: ['Scattered wreckage teeming with fish', 'Friendly groupers', 'Shallow and easy'],
    tags: ['wreck', 'artificial-reef', 'seven-mile-beach', 'fish-life', 'shallow'],
    maxDepthM: 15,
  },
  {
    id: 'otter-springs',
    slug: 'otter-springs',
    name: 'Otter Springs',
    region: 'Trenton, Florida',
    country: 'United States',
    latitude: 29.6446,
    longitude: -82.9414,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A second-magnitude spring at a county park and campground near the Suwannee River in Gilchrist County. The warm-hued, tannin-touched basin is used for swimming, snorkeling, and easy open-water dives.',
    highlights: ['Campground spring', 'Easy open-water basin', 'Near the Suwannee River'],
    tags: ['spring', 'open-water', 'campground', 'snorkel', 'freshwater'],
    maxDepthM: 5,
  },
  {
    id: 'over-the-wall-andros',
    slug: 'over-the-wall-andros',
    name: 'Over the Wall',
    region: 'Andros, Bahamas',
    country: 'Bahamas',
    latitude: 24.72,
    longitude: -77.73,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Small Hope Bay Lodge\'s signature dive on the lip of the Tongue of the Ocean off Fresh Creek, where the Andros Barrier Reef plunges into a mile-deep trench. Divers drop over the edge to around 40 meters on a sheer sponge-covered face.',
    highlights: ['Mile-deep trench edge', 'Sheer sponge-covered wall', 'Signature Andros dive'],
    tags: ['wall', 'deep', 'andros', 'tongue-of-the-ocean', 'drop-off'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Standard profile drops below 30 m over the wall edge.',
  },
  {
    id: 'owens-spring',
    slug: 'owens-spring',
    name: 'Owens Spring',
    region: 'Branford, Florida',
    country: 'United States',
    latitude: 30.01,
    longitude: -83.004,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A spring and siphon feature near Ruth Spring on the Suwannee River known to local cave divers. Flow reverses with river stage, and the overhead passage demands full cave training.',
    highlights: ['Spring-siphon behavior', 'Low-traffic cave', 'Suwannee River access'],
    tags: ['cave', 'spring', 'suwannee', 'overhead', 'siphon'],
    maxDepthM: 15,
    requiredCertification: 'FullCave',
    requirementNote: 'Cave-certified divers only; watch for siphon conditions at higher river stages',
  },
  {
    id: 'painted-wall-belize',
    slug: 'painted-wall-belize',
    name: 'Painted Wall',
    region: 'Lighthouse Reef, Belize',
    country: 'Belize',
    latitude: 17.208,
    longitude: -87.588,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Wall dive off Long Caye on Lighthouse Reef named for the bright patchwork of encrusting sponges and corals that paint its vertical face. Cracks and ledges shelter lobster, morays, and toadfish.',
    highlights: ['Colorful sponge-encrusted wall', 'Ledges and crevice life', 'Excellent visibility'],
    tags: ['wall', 'boat-dive', 'belize', 'lighthouse-reef', 'sponges'],
    maxDepthM: 40,
  },
  {
    id: 'painted-walls',
    slug: 'painted-walls',
    name: 'Painted Walls',
    region: 'Norman Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.305,
    longitude: -64.603,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Narrow canyons at Norman Island\'s southern tip whose walls are painted with encrusting sponges and corals in vivid reds, oranges, and purples. Surge through the gullies adds motion to one of the BVI\'s most colorful shallow dives.',
    highlights: ['vividly encrusted canyons', 'surge-swept gullies', 'photogenic colors'],
    tags: ['canyon', 'sponges', 'bvi', 'photography', 'shallow'],
    maxDepthM: 15,
  },
  {
    id: 'palancar-bricks',
    slug: 'palancar-bricks',
    name: 'Palancar Bricks',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.325,
    longitude: -87.03,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'The southernmost section of Palancar Reef, named after a cargo of bricks lost overboard here decades ago. Deep sand channels, tall coral heads, and frequent eagle ray sightings define the dive.',
    highlights: ['Tall coral heads', 'Eagle ray sightings', 'Deep sand channels'],
    tags: ['drift', 'coral', 'wall', 'cozumel', 'caribbean'],
    maxDepthM: 30,
  },
  {
    id: 'pamir-wreck-barbados',
    slug: 'pamir-wreck-barbados',
    name: 'Pamir',
    region: 'North west coast, Barbados',
    country: 'Barbados',
    latitude: 13.264,
    longitude: -59.647,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 165-foot freighter scuttled in 1985 close to shore on Barbados\' northwest coast, lying in about 18 meters. The open hull is easy to swim through and sits beside a healthy fringing reef.',
    highlights: ['easy open-hull passes', 'adjacent fringing reef', 'shallow relaxed profile'],
    tags: ['wreck', 'barbados', 'artificial-reef', 'shallow', 'beginner'],
    maxDepthM: 18,
  },
  {
    id: 'paraiso-reef-cozumel',
    slug: 'paraiso-reef-cozumel',
    name: 'Paraiso Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.475,
    longitude: -86.98,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef just south of Cozumel\'s cruise piers, long used for check-out dives, night dives, and easy afternoon drifts. Despite the boat traffic above, the coral heads host abundant morays, crabs, and octopus.',
    highlights: ['Popular night dive', 'Check-out dive site', 'Abundant morays'],
    tags: ['reef', 'shallow', 'night-dive', 'cozumel', 'beginner'],
    aliases: ['Paradise Reef'],
    maxDepthM: 14,
  },
  {
    id: 'paso-del-cedral',
    slug: 'paso-del-cedral',
    name: 'Paso del Cedral',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.365,
    longitude: -87.025,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A low-profile strip reef inshore of Cedral Wall famous for dense fish life, including walls of grunts, hogfish, and resident nurse sharks. The moderate depth and lively current make it a classic Cozumel second dive.',
    highlights: ['Dense schools of grunts', 'Resident nurse sharks', 'Classic Cozumel drift'],
    tags: ['drift', 'reef', 'fish-schools', 'cozumel', 'caribbean'],
    aliases: ['Cedral Pass'],
    maxDepthM: 18,
  },
  {
    id: 'pattis-reef-vieques',
    slug: 'pattis-reef-vieques',
    name: 'Patti\'s Reef',
    region: 'Vieques, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.085,
    longitude: -65.475,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow patch reef off Esperanza on Vieques\' south coast, one of the island\'s most dived spots. Gentle depths and abundant juvenile fish make it a standard first dive for visitors to Vieques.',
    highlights: ['Shallow patch reef', 'Juvenile fish nursery', 'Calm south-coast conditions'],
    tags: ['reef', 'vieques', 'shallow', 'esperanza', 'beginner-friendly'],
    maxDepthM: 12,
  },
  {
    id: 'peacock-iii',
    slug: 'peacock-iii',
    name: 'Peacock III',
    region: 'Luraville, Florida',
    country: 'United States',
    latitude: 30.127,
    longitude: -83.137,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A separate karst window within Wes Skiles Peacock Springs State Park giving access to passage of the Peacock cave system. It is a quieter alternative entrance dived by certified cave divers.',
    highlights: ['Karst window entrance', 'Part of the Peacock system', 'Less-trafficked access'],
    tags: ['cave', 'spring', 'state-park', 'luraville', 'overhead'],
    maxDepthM: 18,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave certification checked at the park; no open-water diving',
  },
  {
    id: 'pelican-rock',
    slug: 'pelican-rock',
    name: 'Pelican Rock',
    region: 'Cabo San Lucas, Mexico',
    country: 'Mexico',
    latitude: 22.883,
    longitude: -109.897,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sheltered rock inside Cabo San Lucas bay sitting at the edge of a dramatic sand-fall canyon that plunges into the deep. Easy conditions, tropical fish, and the famous sandfalls make it Cabo\'s most dived site.',
    highlights: ['Sandfalls into the canyon', 'Sheltered bay conditions', 'Dense tropical fish'],
    tags: ['reef', 'sandfalls', 'beginner', 'cabo-san-lucas', 'bay'],
    maxDepthM: 25,
  },
  {
    id: 'pelican-shoal',
    slug: 'pelican-shoal',
    name: 'Pelican Shoal',
    region: 'Lower Keys, Florida',
    country: 'United States',
    latitude: 24.502,
    longitude: -81.625,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A charted shoal east of the Sambo reefs with hardbottom ledges and scattered coral heads. Once home to a seabird nesting island, the shoal now draws divers and lobster hunters in season.',
    highlights: ['Hardbottom ledges', 'Seasonal lobster grounds', 'Off the beaten path'],
    tags: ['florida', 'keys', 'reef', 'ledge', 'lower-keys'],
    maxDepthM: 8,
  },
  {
    id: 'pete-tide-ii',
    slug: 'pete-tide-ii',
    name: 'Pete Tide II',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.25,
    longitude: -87.3,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 180-foot oilfield supply vessel scuttled in 1993 off Pensacola, resting upright with an accessible wheelhouse and open decks. Its multi-level structure holds baitfish, snapper, and resident morays.',
    highlights: ['Upright supply vessel', 'Accessible wheelhouse', 'Multi-level structure'],
    tags: ['wreck', 'supply vessel', 'deep', 'pensacola', 'advanced'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'pickles-reef',
    slug: 'pickles-reef',
    name: 'Pickles Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 24.9867,
    longitude: -80.415,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef south of Molasses named for the pickle-barrel-shaped cement casks from an old wreck still fused to the bottom. Ledges and coral rubble hold morays, crabs, and schooling grunts.',
    highlights: ['Pickle barrel wreck relics', 'Ledge-dwelling morays', 'Relaxed shallow profile'],
    tags: ['florida', 'keys', 'reef', 'historic', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'pillars-of-hercules',
    slug: 'pillars-of-hercules',
    name: 'Pillars of Hercules',
    region: 'English Harbour, Antigua',
    country: 'Antigua and Barbuda',
    latitude: 17.0035,
    longitude: -61.762,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Beneath the sculpted limestone columns guarding the entrance to English Harbour, a shallow reef of coral heads and gullies spreads out over sand. It is a gentle, scenic dive commonly paired with a look at the famous cliff formation.',
    highlights: ['iconic limestone cliffs', 'shallow coral gullies', 'sheltered conditions'],
    tags: ['reef', 'shallow', 'antigua', 'beginner', 'scenic'],
    maxDepthM: 10,
  },
  {
    id: 'piton-wall',
    slug: 'piton-wall',
    name: 'Piton Wall',
    region: 'Petit Piton, St. Lucia',
    country: 'Saint Lucia',
    latitude: 13.826,
    longitude: -61.072,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The near-vertical underwater continuation of Petit Piton\'s cliff face, dropping past 30 meters and plastered with sponges, gorgonians, and black coral. Seahorses hide in the shallower rubble at the wall\'s edge.',
    highlights: ['vertical piton face', 'black coral growth', 'seahorses in the shallows'],
    tags: ['wall', 'st-lucia', 'pitons', 'deep', 'marine-reserve'],
    maxDepthM: 30,
  },
  {
    id: 'pitt-spring',
    slug: 'pitt-spring',
    name: 'Pitt Spring',
    region: 'Econfina Creek, Youngstown, Florida',
    country: 'United States',
    latitude: 30.4322,
    longitude: -85.5477,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A small, clear spring beside the Highway 20 bridge over Econfina Creek with a short run into the creek. It is a well-known swimming hole and snorkel stop on the Econfina paddling trail.',
    highlights: ['Roadside access off SR 20', 'Short crystal spring run', 'Econfina paddle trail stop'],
    tags: ['spring', 'snorkel', 'econfina', 'panhandle', 'swimming'],
    maxDepthM: 5,
  },
  {
    id: 'playa-coral-cuba',
    slug: 'playa-coral-cuba',
    name: 'Playa Coral',
    region: 'Matanzas–Varadero coast, Cuba',
    country: 'Cuba',
    latitude: 23.07,
    longitude: -81.42,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-entry fringing reef on the coastal road between Matanzas and Varadero, prized as one of Cuba\'s easiest coral dives. Elkhorn stands and reef fish start within meters of the rocky beach.',
    highlights: ['Shore-entry coral reef', 'Elkhorn coral stands', 'Great snorkel-to-dive site'],
    tags: ['shore-dive', 'reef', 'shallow', 'varadero', 'snorkel-friendly'],
    maxDepthM: 12,
  },
  {
    id: 'playa-kalki-alice-in-wonderland',
    slug: 'playa-kalki-alice-in-wonderland',
    name: 'Playa Kalki (Alice in Wonderland)',
    region: 'Westpunt, Curaçao',
    country: 'Curacao',
    latitude: 12.375,
    longitude: -69.158,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Easy shore dive at Curaçao\'s westernmost beach, where the reef known locally as Alice in Wonderland features mushroom-shaped coral heads on a gentle slope. Not to be confused with Bonaire\'s site of the same name.',
    highlights: ['Mushroom-shaped coral heads', 'Easy beach entry', 'Great visibility'],
    tags: ['shore-dive', 'coral', 'curacao', 'beginner-friendly', 'westpunt'],
    aliases: ['Alice in Wonderland (Curaçao)', 'Kalki Beach'],
    maxDepthM: 30,
  },
  {
    id: 'playa-lagun',
    slug: 'playa-lagun',
    name: 'Playa Lagun',
    region: 'Lagun, Curaçao',
    country: 'Curacao',
    latitude: 12.3175,
    longitude: -69.129,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Narrow cove between high cliffs with a calm, sandy entry leading to healthy reef slopes on both sides. One of the most reliable places on Curaçao to dive or snorkel with green turtles.',
    highlights: ['Sheltered cove entry', 'Green turtles', 'Cliff-lined scenery'],
    tags: ['shore-dive', 'turtles', 'curacao', 'beginner-friendly', 'cove'],
    maxDepthM: 30,
  },
  {
    id: 'playa-piskado',
    slug: 'playa-piskado',
    name: 'Playa Piskado (Playa Grandi)',
    region: 'Westpunt, Curaçao',
    country: 'Curacao',
    latitude: 12.368,
    longitude: -69.153,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Working fishing beach near Westpunt where green turtles gather around the pier to feed on fish scraps, making close encounters almost guaranteed. A gentle reef slope extends beyond the turtle shallows.',
    highlights: ['Reliable turtle encounters', 'Fishing pier scenery', 'Easy shore entry'],
    tags: ['shore-dive', 'turtles', 'curacao', 'snorkeling', 'beginner-friendly'],
    aliases: ['Playa Grandi'],
    maxDepthM: 25,
  },
  {
    id: 'poe-springs',
    slug: 'poe-springs',
    name: 'Poe Springs',
    region: 'High Springs, Florida',
    country: 'United States',
    latitude: 29.8257,
    longitude: -82.6487,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A second-magnitude spring on the Santa Fe River in an Alachua County park near High Springs. The open, sandy basin is a popular swim and snorkel stop on the river\'s famous spring corridor.',
    highlights: ['Santa Fe River spring', 'Sandy open basin', 'County park amenities'],
    tags: ['spring', 'snorkel', 'santa-fe-river', 'swimming', 'county-park'],
    maxDepthM: 5,
  },
  {
    id: 'point-of-rocks',
    slug: 'point-of-rocks',
    name: 'Point of Rocks',
    region: 'Siesta Key, Florida',
    country: 'United States',
    latitude: 27.253,
    longitude: -82.549,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A natural limestone outcropping at the south end of Siesta Key\'s Crescent Beach, one of the Gulf coast\'s best shore snorkel sites. The shallow rocks harbor sergeant majors, snook, and octopus.',
    highlights: ['Natural rock outcrop', 'Shore snorkel', 'Clear summer water'],
    tags: ['reef', 'shore dive', 'snorkel', 'shallow', 'sarasota'],
    maxDepthM: 4,
  },
  {
    id: 'point-pleasant-salt-cay',
    slug: 'point-pleasant-salt-cay',
    name: 'Point Pleasant',
    region: 'Salt Cay, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.35,
    longitude: -71.22,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef off Salt Cay\'s northern point with coral heads, swim-through ledges, and resident turtles in calm protected water. In winter it doubles as a listening post for humpback whales passing the Turks Island Passage.',
    highlights: ['Resident turtles', 'Shallow ledges and heads', 'Winter humpback season'],
    tags: ['reef', 'salt-cay', 'shallow', 'turtles', 'whales'],
    maxDepthM: 12,
  },
  {
    id: 'ponce-de-leon-springs',
    slug: 'ponce-de-leon-springs',
    name: 'Ponce de Leon Springs State Park',
    region: 'Ponce de Leon, Florida',
    country: 'United States',
    latitude: 30.7217,
    longitude: -85.9313,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A state park spring producing 14 million gallons daily from two converging underground flows, held at a constant 68 F. It is a swimming and snorkeling site rather than a scuba destination.',
    highlights: ['Constant 68 F water', 'Two merging spring vents', 'Easy state park facilities'],
    tags: ['spring', 'snorkel', 'state-park', 'panhandle', 'swimming'],
    maxDepthM: 5,
    requirementNote: 'Swimming and snorkeling only; scuba is not permitted',
  },
  {
    id: 'porto-mari',
    slug: 'porto-mari',
    name: 'Porto Mari',
    region: 'Sint Willibrordus, Curaçao',
    country: 'Curacao',
    latitude: 12.221,
    longitude: -69.09,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Beach dive famous for its double reef: two parallel coral ridges separated by a sandy valley, connected by a marked underwater trail. Easy entry from a well-equipped beach.',
    highlights: ['Double reef system', 'Underwater trail', 'Easy beach facilities'],
    tags: ['shore-dive', 'double-reef', 'curacao', 'beginner-friendly', 'coral'],
    maxDepthM: 30,
  },
  {
    id: 'prickly-pear-anguilla',
    slug: 'prickly-pear-anguilla',
    name: 'Prickly Pear',
    region: 'Prickly Pear Cays, Anguilla',
    country: 'Anguilla',
    latitude: 18.265,
    longitude: -63.175,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An underwater canyon and ledge system off the Prickly Pear Cays northwest of Anguilla, where nurse sharks commonly rest beneath the overhangs. Shallow reef flats nearby keep the site friendly for newer divers.',
    highlights: ['ledge canyons', 'resting nurse sharks', 'clear shallow reef'],
    tags: ['reef', 'ledges', 'anguilla', 'nurse-sharks', 'beginner'],
    maxDepthM: 12,
  },
  {
    id: 'princess-anne',
    slug: 'princess-anne',
    name: 'Princess Anne',
    region: 'West Palm Beach, Florida',
    country: 'United States',
    latitude: 26.8,
    longitude: -80.01,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 350-foot former Chesapeake Bay car ferry scuttled in 1993 off Palm Beach. The massive open hull is dived as a drift and offers wide, light-filled passages through the car deck.',
    highlights: ['350-foot ferry', 'Open car deck', 'Drift wreck'],
    tags: ['wreck', 'ferry', 'deep', 'drift', 'palm beach'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'proselyte-reef',
    slug: 'proselyte-reef',
    name: 'Proselyte Reef',
    region: 'Philipsburg, St. Maarten',
    country: 'Sint Maarten',
    latitude: 18.003,
    longitude: -63.043,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered remains of HMS Proselyte, a Dutch-built frigate that wrecked on this reef off Great Bay in 1801, including anchors, cannons, and ballast. Coral heads have grown over the artifacts, mixing history with a lively reef dive.',
    highlights: ['1801 frigate artifacts', 'cannons and anchors', 'coral-covered ballast'],
    tags: ['wreck', 'historic', 'reef', 'st-maarten', 'shallow'],
    aliases: ['HMS Proselyte'],
    maxDepthM: 16,
  },
  {
    id: 'pulaski-shoal',
    slug: 'pulaski-shoal',
    name: 'Pulaski Shoal',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.6933,
    longitude: -82.7733,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A broad shallow shoal on the northeast edge of the Dry Tortugas marked by a light tower, with hardbottom, coral heads, and several historic wreck scatters. Clear water and light traffic reward the long run out.',
    highlights: ['Remote lit shoal', 'Historic wreck scatter', 'Unspoiled hardbottom'],
    tags: ['florida', 'dry-tortugas', 'reef', 'national-park', 'remote'],
    maxDepthM: 6,
  },
  {
    id: 'punta-cancun',
    slug: 'punta-cancun',
    name: 'Punta Cancún',
    region: 'Cancún, Mexico',
    country: 'Mexico',
    latitude: 21.14,
    longitude: -86.74,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A set of reef fingers off the northeastern corner of Cancún\'s hotel zone, where currents converge and fish life concentrates. Ledges and small caves shelter nurse sharks, rays, and schooling grunts.',
    highlights: ['Reef ledges and caves', 'Nurse sharks', 'Converging currents'],
    tags: ['reef', 'drift', 'current', 'cancun', 'caribbean'],
    maxDepthM: 18,
  },
  {
    id: 'punta-frances-cuba',
    slug: 'punta-frances-cuba',
    name: 'Punta Francés',
    region: 'Isla de la Juventud, Cuba',
    country: 'Cuba',
    latitude: 21.605,
    longitude: -83.18,
    matchRadiusKm: 10,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'The protected marine park at the southwest tip of Isla de la Juventud, served by the El Colony dive center, with dozens of buoyed wall and cave sites. Long regarded as one of Cuba\'s premier diving areas for its coral walls and grouper-rich reefs.',
    highlights: ['Marine park with 50+ sites', 'Coral walls and caves', 'Remote unspoiled reefs'],
    tags: ['destination', 'marine-park', 'wall', 'isla-de-la-juventud', 'remote'],
    aliases: ['El Colony'],
  },
  {
    id: 'punta-nizuc',
    slug: 'punta-nizuc',
    name: 'Punta Nizuc',
    region: 'Cancún, Mexico',
    country: 'Mexico',
    latitude: 21.03,
    longitude: -86.78,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef at the southern tip of Cancún\'s hotel zone, part of the Costa Occidental marine park and home to a MUSA sculpture gallery. Calm, shallow water makes it a mainstay for beginner dives and snorkel trips.',
    highlights: ['Marine park reef', 'MUSA sculpture gallery', 'Very shallow and calm'],
    tags: ['reef', 'shallow', 'beginner', 'cancun', 'marine-park'],
    maxDepthM: 8,
  },
  {
    id: 'punta-perdiz-cuba',
    slug: 'punta-perdiz-cuba',
    name: 'Punta Perdiz',
    region: 'Bay of Pigs, Cuba',
    country: 'Cuba',
    latitude: 22.13,
    longitude: -81.12,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shore-entry site on the eastern rim of the Bay of Pigs where a coral shelf drops abruptly into a deep blue wall just a short swim from the rocky beach. Clear, calm water makes it one of Cuba\'s most accessible wall dives.',
    highlights: ['Wall dive from shore', 'Very clear calm water', 'Easy entry platforms'],
    tags: ['shore-dive', 'wall', 'bay-of-pigs', 'drop-off', 'budget-friendly'],
    maxDepthM: 30,
  },
  {
    id: 'punta-sur-devils-throat',
    slug: 'punta-sur-devils-throat',
    name: 'Punta Sur (Devil\'s Throat)',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.286,
    longitude: -87.032,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'Cozumel\'s signature advanced dive, where the Devil\'s Throat tunnel drops through the reef from about 24 m and exits on the wall near 40 m. Strong currents and overhead passages make this a dive for experienced divers only.',
    highlights: ['Devil\'s Throat tunnel', 'Wall exit at 40 m', 'Advanced drift diving'],
    tags: ['drift', 'wall', 'tunnel', 'deep', 'cozumel', 'advanced'],
    aliases: ['Devil\'s Throat', 'Punta Sur Reef'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Operators require Advanced Open Water and recent deep/drift experience for the Devil\'s Throat swim-through.',
  },
  {
    id: 'punta-tosca-socorro',
    slug: 'punta-tosca-socorro',
    name: 'Punta Tosca (Socorro)',
    region: 'Revillagigedo Islands, Mexico',
    country: 'Mexico',
    latitude: 18.72,
    longitude: -111.01,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A point on Socorro\'s southwestern shore with sloping volcanic reef, frequent dolphin encounters, and reliable shark and manta traffic. Surge and current keep it firmly in advanced territory.',
    highlights: ['Dolphin encounters', 'Volcanic reef slope', 'Shark and manta traffic'],
    tags: ['reef', 'dolphins', 'sharks', 'revillagigedo', 'liveaboard'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Liveaboard-only marine park; advanced certification and experience required.',
  },
  {
    id: 'punta-tunich',
    slug: 'punta-tunich',
    name: 'Punta Tunich',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.42,
    longitude: -87.02,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A sloping sand-and-coral drop-off known for one of the fastest drifts on Cozumel, often described as flying over the reef. Eagle rays, turtles, and barracuda ride the same current as the divers.',
    highlights: ['Fast flying drift', 'Eagle rays in current', 'Sloping drop-off'],
    tags: ['drift', 'current', 'reef', 'cozumel', 'eagle-rays'],
    aliases: ['Tunich'],
    maxDepthM: 24,
  },
  {
    id: 'puruni-wreck',
    slug: 'puruni-wreck',
    name: 'Puruni Wreck',
    region: 'Mayreau, the Grenadines',
    country: 'Saint Vincent and the Grenadines',
    latitude: 12.655,
    longitude: -61.398,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A British WWI-era gunboat that sank off Mayreau in 1918, now resting in shallow water with its boilers and hull plates encrusted in coral. It is one of the very few genuine historic wrecks divable in the Grenadines.',
    highlights: ['WWI gunboat', 'coral-crusted boilers', 'shallow historic wreck'],
    tags: ['wreck', 'historic', 'grenadines', 'shallow', 'beginner'],
    aliases: ['Purina Wreck', 'Mayreau Wreck'],
    maxDepthM: 13,
  },
  {
    id: 'pygmy-caves',
    slug: 'pygmy-caves',
    name: 'Pygmy Caves',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.49,
    longitude: -78.64,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A reef site off Grand Bahama\'s south shore where low coral ledges and short swim-throughs cut through the reef structure. The overhangs shelter groupers, lobsters, and copper sweepers.',
    highlights: ['Short swim-throughs', 'Fish-filled overhangs', 'Healthy reef structure'],
    tags: ['reef', 'swim-through', 'grand-bahama', 'ledges', 'boat-dive'],
    maxDepthM: 20,
  },
  {
    id: 'radar-reef-cayman-brac',
    slug: 'radar-reef-cayman-brac',
    name: 'Radar Reef',
    region: 'Cayman Brac, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.72,
    longitude: -79.805,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow spur-and-groove reef off Stake Bay on Cayman Brac\'s north shore, laced with sand channels and swim-throughs. Nearby sit the bronze figures of the Lost City of Atlantis sculpture project.',
    highlights: ['Spur-and-groove coral fingers', 'Atlantis sculpture garden nearby', 'Easy shore or boat access'],
    tags: ['reef', 'cayman-brac', 'shallow', 'sculptures', 'shore-dive'],
    aliases: ['Stake Bay Reef'],
    maxDepthM: 15,
  },
  {
    id: 'rancho-luna-cuba',
    slug: 'rancho-luna-cuba',
    name: 'Rancho Luna',
    region: 'Cienfuegos, Cuba',
    country: 'Cuba',
    latitude: 22.06,
    longitude: -80.41,
    matchRadiusKm: 6,
    siteType: 'destination',
    difficulty: 'Beginner',
    summary: 'The dive area off Playa Rancho Luna near Cienfuegos, known for tall coral columns and pinnacle formations dubbed Notre Dame after their cathedral-like shape. Reefs and several small wrecks lie a short boat ride from the beach.',
    highlights: ['Cathedral-like coral columns', 'Nearby small wrecks', 'Short boat rides'],
    tags: ['destination', 'reef', 'cienfuegos', 'coral-pinnacles', 'resort'],
    aliases: ['Notre Dame, Cienfuegos'],
  },
  {
    id: 'randys-gazebo-little-cayman',
    slug: 'randys-gazebo-little-cayman',
    name: 'Randy\'s Gazebo',
    region: 'Little Cayman (Bloody Bay), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.699,
    longitude: -80.082,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'One of Bloody Bay Wall\'s most photographed sites, featuring a chimney through the reef lip and a sponge-covered arch known as the gazebo on the wall face. Vase sponges and black coral decorate the vertical drop.',
    highlights: ['Chimney through the reef', 'Arch on the sheer wall', 'Colorful vase sponges'],
    tags: ['wall', 'bloody-bay', 'chimney', 'arch', 'photography'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Chimney exits onto the wall near 20 m.',
  },
  {
    id: 'rappel',
    slug: 'rappel',
    name: 'Rappel',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.216,
    longitude: -68.3455,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Boat-access site beneath a sheer limestone cliff on Bonaire\'s northwest coast, named for the days when divers were lowered down the rock face. Dense coral cover, overhangs, and frequent turtle and seahorse sightings.',
    highlights: ['Dramatic cliff backdrop', 'Lush coral overhangs', 'Seahorses and turtles'],
    tags: ['boat-dive', 'coral', 'cliff', 'bonaire', 'marine-park'],
    maxDepthM: 40,
  },
  {
    id: 'ray-of-hope-wreck',
    slug: 'ray-of-hope-wreck',
    name: 'Ray of Hope Wreck',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.988,
    longitude: -77.545,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 60-meter former Haitian freighter scuttled in 2003 off southwest New Providence as an artificial reef. It sits upright on sand near Stuart Cove\'s shark dive sites and is frequently circled by Caribbean reef sharks.',
    highlights: ['Upright intact freighter', 'Caribbean reef sharks', 'Easy penetration-free tour'],
    tags: ['wreck', 'sharks', 'artificial-reef', 'nassau', 'photography'],
    maxDepthM: 15,
  },
  {
    id: 'rebel-wreck',
    slug: 'rebel-wreck',
    name: 'Rebel',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.17,
    longitude: -80.07,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 150-foot coastal freighter sunk in 1985 off Fort Lauderdale in deeper water. The wreck sits mostly intact and is a favorite for divers stepping up to deeper wreck profiles.',
    highlights: ['Intact freighter', 'Deeper training wreck', 'Resident barracuda'],
    tags: ['wreck', 'freighter', 'deep', 'artificial reef', 'fort lauderdale'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
  },
  {
    id: 'red-sea-barge',
    slug: 'red-sea-barge',
    name: 'Red Sea',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.12,
    longitude: -85.79,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A steel coastal vessel scuttled in 2009 off Panama City Beach as part of the county reef program. The newer wreck sits upright at friendly depth and is developing rich encrusting growth.',
    highlights: ['Modern scuttling', 'Upright hull', 'Growing reef life'],
    tags: ['wreck', 'artificial reef', 'panama city', 'intermediate', 'gulf'],
    maxDepthM: 24,
  },
  {
    id: 'red-slave',
    slug: 'red-slave',
    name: 'Red Slave',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.027,
    longitude: -68.259,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'The southernmost dive site on Bonaire beside the red slave huts, exposed to current and surge but rewarding with big fish, turtles, and occasional sharks. Historic anchors from colonial wrecks lie on the reef.',
    highlights: ['Historic anchors', 'Big fish and pelagics', 'Southern-tip current dive'],
    tags: ['shore-dive', 'current', 'bonaire', 'historic', 'advanced'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Exposed to strong current and surge; recommended for experienced divers.',
  },
  {
    id: 'regina-wreck',
    slug: 'regina-wreck',
    name: 'Regina',
    region: 'Bradenton Beach, Florida',
    country: 'United States',
    latitude: 27.468,
    longitude: -82.699,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A steel molasses barge wrecked in a 1940 storm just off Bradenton Beach, now a Florida Underwater Archaeological Preserve reachable by a short swim from shore. The shallow hull hosts baitfish, stone crabs, and occasional manatees.',
    highlights: ['Swim-from-beach wreck', 'Archaeological preserve', '1940 molasses barge'],
    tags: ['wreck', 'historic', 'preserve', 'shore dive', 'bradenton'],
    aliases: ['Bruni'],
    maxDepthM: 6,
  },
  {
    id: 'rendezvous-bay-reef',
    slug: 'rendezvous-bay-reef',
    name: 'Rendezvous Bay Reef',
    region: 'Northwest coast, Montserrat',
    country: 'Montserrat',
    latitude: 16.812,
    longitude: -62.21,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Fringing reef off Montserrat\'s only white-sand beach at the island\'s quiet northwest tip, with coral heads and volcanic boulders in clear, lightly dived water. The island\'s small dive community treats it as the signature easy site.',
    highlights: ['rarely crowded reef', 'volcanic boulders', 'white-sand beach access'],
    tags: ['reef', 'montserrat', 'beginner', 'off-the-beaten-path', 'volcanic'],
    maxDepthM: 15,
  },
  {
    id: 'riding-rock-wall',
    slug: 'riding-rock-wall',
    name: 'Riding Rock Wall',
    region: 'San Salvador, Bahamas',
    country: 'Bahamas',
    latitude: 24.05,
    longitude: -74.54,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A sheer wall just off Cockburn Town on San Salvador\'s leeward coast, dropping from a shallow lip into thousands of meters of open Atlantic. Exceptional visibility and passing pelagics define this classic wall dive.',
    highlights: ['Sheer oceanic wall', 'Outstanding visibility', 'Hammerhead season sightings'],
    tags: ['wall', 'san-salvador', 'drop-off', 'pelagics', 'boat-dive'],
    maxDepthM: 35,
  },
  {
    id: 'river-taw',
    slug: 'river-taw',
    name: 'River Taw',
    region: 'St. Kitts',
    country: 'Saint Kitts and Nevis',
    latitude: 17.272,
    longitude: -62.685,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 144-foot island freighter that sank off St. Kitts\' Frigate Bay area in the 1980s and later broke into sections in shallow water. Its scattered hull plates are overgrown and easy to tour at around 14 meters.',
    highlights: ['shallow broken freighter', 'easy wreck introduction', 'encrusted hull sections'],
    tags: ['wreck', 'shallow', 'st-kitts', 'beginner', 'artificial-reef'],
    maxDepthM: 14,
  },
  {
    id: 'robert-edmister',
    slug: 'robert-edmister',
    name: 'Robert Edmister',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.09,
    longitude: -80.09,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 95-foot former Coast Guard cutter sunk in 1989 off Fort Lauderdale. The small, intact wreck sits at recreational depth and is often paired with nearby reefs on a two-tank trip.',
    highlights: ['Ex-Coast Guard cutter', 'Intact and compact', 'Recreational depth'],
    tags: ['wreck', 'coast guard', 'artificial reef', 'fort lauderdale', 'intermediate'],
    maxDepthM: 21,
  },
  {
    id: 'rocher-du-diamant',
    slug: 'rocher-du-diamant',
    name: 'Rocher du Diamant',
    region: 'Diamond Rock, Martinique',
    country: 'Martinique',
    latitude: 14.4405,
    longitude: -61.04,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'The volcanic sea stack once commissioned by the Royal Navy as \'HMS Diamond Rock\' offers Martinique\'s most spectacular diving, including a long tunnel-cavern and steep drop-offs. Current and depth reserve it for experienced divers.',
    highlights: ['famous volcanic sea stack', 'tunnel swim-through', 'steep drop-offs'],
    tags: ['pinnacle', 'cavern', 'martinique', 'advanced', 'current', 'volcanic'],
    aliases: ['Diamond Rock (Martinique)'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
  },
  {
    id: 'rock-key',
    slug: 'rock-key',
    name: 'Rock Key',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4547,
    longitude: -81.859,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A compact Sanctuary Preservation Area between Sand Key and Eastern Dry Rocks with tall coral spurs split by narrow sand channels. An 1800s brick-carrying wreck left debris scattered in the grooves.',
    highlights: ['Tall coral spurs', 'Historic brick wreck scatter', 'Compact easy layout'],
    tags: ['florida', 'keys', 'reef', 'spa', 'spur-and-groove', 'key-west'],
    maxDepthM: 9,
  },
  {
    id: 'rock-springs-kelly-park',
    slug: 'rock-springs-kelly-park',
    name: 'Rock Springs (Kelly Park)',
    region: 'Apopka, Florida',
    country: 'United States',
    latitude: 28.7561,
    longitude: -81.501,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A swift, crystal-clear spring run emerging from a rock bluff in Kelly Park near Apopka. It is Florida\'s signature lazy-river tubing and snorkeling run; scuba is not part of the experience.',
    highlights: ['Natural lazy river', 'Spring from a rock bluff', 'Snorkel-friendly shallows'],
    tags: ['spring', 'river', 'snorkel', 'tubing', 'central-florida'],
    maxDepthM: 3,
    requirementNote: 'Tubing, swimming, and snorkeling only',
  },
  {
    id: 'rodeo-25',
    slug: 'rodeo-25',
    name: 'Rodeo 25',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.26,
    longitude: -80.06,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 215-foot coastal freighter scuttled in 1990 to mark the 25th anniversary of the Pompano Beach Fishing Rodeo. The upright wreck in deep water regularly hosts goliath grouper.',
    highlights: ['215-foot freighter', 'Goliath grouper', 'Upright in deep water'],
    tags: ['wreck', 'freighter', 'deep', 'goliath grouper', 'pompano'],
    maxDepthM: 37,
    requiredCertification: 'AOW',
  },
  {
    id: 'roraima-wreck',
    slug: 'roraima-wreck',
    name: 'Roraima',
    region: 'Saint-Pierre, Martinique',
    country: 'Martinique',
    latitude: 14.735,
    longitude: -61.183,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'The best known of the ships sunk in Saint-Pierre harbor by the 1902 eruption of Mont Pelée, lying upright between roughly 40 and 60 meters. The intact, sponge-shrouded steamer is a historic deep dive within a genuine volcanic disaster site.',
    highlights: ['1902 eruption casualty', 'intact deep steamer', 'historic harbor graveyard'],
    tags: ['wreck', 'historic', 'deep', 'martinique', 'technical'],
    maxDepthM: 60,
    requiredCertification: 'Tec40',
    requirementNote: 'Hull lies below 40 m; dived on technical or deep-qualified profiles only.',
  },
  {
    id: 'rosaomaira-wreck',
    slug: 'rosaomaira-wreck',
    name: 'Rosaomaira',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.737,
    longitude: -64.897,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'The deepest of the Butler Bay wrecks, this 177-foot Venezuelan freighter sits upright in about 33 meters off St. Croix\'s west coast. Its masts and superstructure are thickly colonized by cup corals and sponges.',
    highlights: ['upright deep freighter', 'coral-encrusted masts', 'part of Butler Bay wreck trail'],
    tags: ['wreck', 'deep', 'usvi', 'butler-bay', 'artificial-reef'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
  },
  {
    id: 'rube-allyn-reef',
    slug: 'rube-allyn-reef',
    name: 'Rube Allyn Reef',
    region: 'Indian Shores, Florida',
    country: 'United States',
    latitude: 27.87,
    longitude: -82.97,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A Pinellas County artificial reef named for a local outdoors writer, built from barges, concrete, and bridge material. The scattered structure draws Goliath grouper, snapper, and schools of spadefish.',
    highlights: ['Pinellas artificial reef', 'Goliath grouper', 'Varied structure'],
    tags: ['artificial reef', 'barge', 'pinellas', 'beginner', 'gulf'],
    maxDepthM: 14,
  },
  {
    id: 'running-springs',
    slug: 'running-springs',
    name: 'Running Springs',
    region: 'Luraville, Florida',
    country: 'United States',
    latitude: 30.1046,
    longitude: -83.2103,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'Twin spring basins on the north bank of the Suwannee River west of Luraville with cave passage beneath. The privately accessed site is dived by cave divers when the river is low and clear.',
    highlights: ['Twin riverside basins', 'Cave passage below', 'Quiet private setting'],
    tags: ['cave', 'spring', 'suwannee', 'overhead', 'north-florida'],
    maxDepthM: 15,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave-certified divers only; private access arrangements required',
  },
  {
    id: 'ruth-spring',
    slug: 'ruth-spring',
    name: 'Ruth Spring',
    region: 'Branford, Florida',
    country: 'United States',
    latitude: 30.008,
    longitude: -83.001,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A small spring on the west bank of the Suwannee River near Troy Spring with a shallow cave system behind the vent. It sees light traffic from cave divers exploring the Troy area springs.',
    highlights: ['Quiet Suwannee bank spring', 'Shallow cave passage', 'Near Troy Spring'],
    tags: ['cave', 'spring', 'suwannee', 'overhead', 'north-florida'],
    maxDepthM: 12,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave-certified divers only; river level dependent',
  },
  {
    id: 'sabalos-reef',
    slug: 'sabalos-reef',
    name: 'Sabalos Reef',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.62,
    longitude: -87.07,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow patch reef off central Playa del Carmen named for the tarpon (sábalos) that often hover in the blue nearby. Easy conditions make it a staple for courses and relaxed morning dives.',
    highlights: ['Tarpon encounters', 'Easy shallow profile', 'Course-friendly'],
    tags: ['reef', 'shallow', 'beginner', 'playa-del-carmen', 'riviera-maya'],
    maxDepthM: 14,
  },
  {
    id: 'salt-river-canyon-east',
    slug: 'salt-river-canyon-east',
    name: 'Salt River Canyon East',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.7855,
    longitude: -64.758,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The east wall of the submarine canyon off Salt River Bay drops in sponge-covered terraces past 30 meters. Anemones, black coral, and passing eagle rays reward divers along the canyon rim.',
    highlights: ['canyon wall terraces', 'black coral', 'eagle rays'],
    tags: ['wall', 'canyon', 'usvi', 'boat-dive', 'deep'],
    maxDepthM: 35,
  },
  {
    id: 'salt-springs',
    slug: 'salt-springs',
    name: 'Salt Springs',
    region: 'Ocala National Forest, Florida',
    country: 'United States',
    latitude: 29.3513,
    longitude: -81.733,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A mineral-rich spring in the Ocala National Forest whose slightly salty boils bubble through limestone crevices. Snorkelers watch blue crabs and mullet in the shallow run; scuba is not used here.',
    highlights: ['Mineral spring boils', 'Blue crabs in freshwater', 'National forest recreation area'],
    tags: ['spring', 'snorkel', 'ocala-forest', 'swimming', 'freshwater'],
    maxDepthM: 6,
    requirementNote: 'Snorkeling and swimming only',
  },
  {
    id: 'salvatierra-wreck',
    slug: 'salvatierra-wreck',
    name: 'Salvatierra Wreck',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.38,
    longitude: -110.3,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A ferry that sank in the San Lorenzo Channel in 1976, now broken across the sand at about 18-20 m and thick with green morays, grouper, and schooling porkfish. Channel currents usually make it a drift-style wreck dive.',
    highlights: ['Ferry wreckage field', 'Green morays everywhere', 'Channel drift diving'],
    tags: ['wreck', 'drift', 'la-paz', 'sea-of-cortez', 'fish-life'],
    maxDepthM: 20,
  },
  {
    id: 'san-francisco-reef-cozumel',
    slug: 'san-francisco-reef-cozumel',
    name: 'San Francisco Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.39,
    longitude: -87.02,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'One of Cozumel\'s oldest named dive sites, a strip reef and mini-wall off San Francisco beach with reliable current and good visibility. Expect turtles, angelfish, and lobster tucked into the coral ledges.',
    highlights: ['Mini-wall ledges', 'Turtles and angelfish', 'Reliable visibility'],
    tags: ['drift', 'reef', 'wall', 'cozumel', 'caribbean'],
    maxDepthM: 20,
  },
  {
    id: 'san-juan-reef-cozumel',
    slug: 'san-juan-reef-cozumel',
    name: 'San Juan Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.53,
    longitude: -86.98,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'A fast northern drift over low-profile coral fingers where ripping currents draw schooling jacks, rays, and the occasional shark. Like Barracuda Reef, it is scheduled only when conditions allow.',
    highlights: ['High-speed drift', 'Schooling jacks and rays', 'Northern Cozumel wilderness'],
    tags: ['drift', 'advanced', 'current', 'cozumel', 'pelagics'],
    maxDepthM: 25,
    requiredCertification: 'AOW',
  },
  {
    id: 'san-pablo',
    slug: 'san-pablo',
    name: 'San Pablo',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.28,
    longitude: -87.26,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A freighter deliberately destroyed off Pensacola in 1944 after earlier wartime torpedo damage, known locally as the Russian Freighter. The broken wreckage spreads across the sand and shelters grouper and octopus.',
    highlights: ['WWII-era wreck', 'Broken debris field', 'Local legend'],
    tags: ['wreck', 'historic', 'wwii', 'pensacola', 'intermediate'],
    aliases: ['Russian Freighter'],
    maxDepthM: 24,
  },
  {
    id: 'san-pedro-wreck',
    slug: 'san-pedro-wreck',
    name: 'San Pedro',
    region: 'Islamorada, Florida',
    country: 'United States',
    latitude: 24.8634,
    longitude: -80.68,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A Dutch-built Spanish galleon from the 1733 fleet, preserved as Florida\'s San Pedro Underwater Archaeological Preserve State Park near Indian Key. Ballast stones, replica cannons, and an anchor sit in shallow grass and sand.',
    highlights: ['1733 fleet galleon', 'State underwater preserve', 'Replica cannons and anchor'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'spanish-galleon', 'shallow'],
    aliases: ['San Pedro Underwater Archaeological Preserve'],
    maxDepthM: 6,
  },
  {
    id: 'sand-island',
    slug: 'sand-island',
    name: 'Sand Island',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.0183,
    longitude: -80.369,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef northeast of Molasses named for a sand island that washed away in the 1960s. Coral ridges and rubble flats attract turtles and schooling porkfish.',
    highlights: ['Shallow coral ridges', 'Turtle sightings', 'Easy anchorless mooring dive'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'snorkel'],
    maxDepthM: 8,
  },
  {
    id: 'sand-key',
    slug: 'sand-key',
    name: 'Sand Key',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4507,
    longitude: -81.8777,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Key West\'s landmark reef, a Sanctuary Preservation Area surrounding the 1853 Sand Key lighthouse. Snorkel-depth coral around the tower gives way to deeper spurs on the seaward side.',
    highlights: ['1853 Sand Key light', 'Snorkel to scuba depths', 'Sanctuary Preservation Area'],
    tags: ['florida', 'keys', 'reef', 'lighthouse', 'spa', 'key-west'],
    aliases: ['Sand Key Light'],
    maxDepthM: 12,
  },
  {
    id: 'sandy-cay-reef-abaco',
    slug: 'sandy-cay-reef-abaco',
    name: 'Sandy Cay Reef',
    region: 'Abacos, Bahamas',
    country: 'Bahamas',
    latitude: 26.39,
    longitude: -76.98,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The centerpiece reef of Pelican Cays Land and Sea Park in southern Abaco, known for dense elkhorn and staghorn stands and mooring-buoy access. Turtles, rays, and big parrotfish are regulars in the shallow protected coral.',
    highlights: ['Elkhorn coral stands', 'Protected park waters', 'Turtles and rays'],
    tags: ['reef', 'marine-park', 'abacos', 'shallow', 'coral'],
    maxDepthM: 10,
  },
  {
    id: 'santa-maria-cove',
    slug: 'santa-maria-cove',
    name: 'Santa Maria Cove',
    region: 'Cabo San Lucas Corridor, Mexico',
    country: 'Mexico',
    latitude: 22.938,
    longitude: -109.818,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A protected horseshoe cove along the tourist corridor with rocky reef fingers and calm, clear water. Green morays, king angelfish, and schooling sergeant majors make it a reliable easy dive.',
    highlights: ['Calm protected cove', 'Rocky reef fingers', 'Green morays'],
    tags: ['reef', 'cove', 'beginner', 'los-cabos', 'sea-of-cortez'],
    maxDepthM: 15,
  },
  {
    id: 'santa-monica-rock',
    slug: 'santa-monica-rock',
    name: 'Santa Monica Rock',
    region: 'South of Norman Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.292,
    longitude: -64.628,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An offshore seamount south of Norman Island, the last stop before open ocean, where ridges drop past 25 meters and pelagics cruise the up-current side. Exposure to swell and current reserves it for experienced divers.',
    highlights: ['offshore seamount', 'pelagic traffic', 'dramatic ridgelines'],
    tags: ['seamount', 'current', 'advanced', 'bvi', 'pelagics'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'sayonara-wreck',
    slug: 'sayonara-wreck',
    name: 'Sayonara Wreck',
    region: 'Turneffe Atoll, Belize',
    country: 'Belize',
    latitude: 17.168,
    longitude: -87.915,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'Small wooden passenger boat sunk in 1985 near Caye Bokel on Turneffe Atoll, now a low debris field on sand at about 15 meters beside a healthy reef slope. An easy wreck often paired with nearby Elbow-area reef dives.',
    highlights: ['Easy shallow wreck', 'Adjacent reef slope', 'Macro life in the wreckage'],
    tags: ['wreck', 'boat-dive', 'belize', 'turneffe', 'beginner-friendly'],
    maxDepthM: 15,
  },
  {
    id: 'scotts-head-pinnacle',
    slug: 'scotts-head-pinnacle',
    name: 'Scotts Head Pinnacle',
    region: 'Soufriere-Scotts Head Marine Reserve, Dominica',
    country: 'Dominica',
    latitude: 15.21,
    longitude: -61.377,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A volcanic pinnacle at the tip of Dominica\'s Scotts Head peninsula where a swim-through arch opens onto walls packed with soldierfish and grunts. It is the flagship dive of the Soufriere-Scotts Head Marine Reserve.',
    highlights: ['swim-through arch', 'soldierfish-packed walls', 'marine reserve flagship'],
    tags: ['pinnacle', 'swim-through', 'dominica', 'marine-reserve', 'volcanic'],
    maxDepthM: 27,
  },
  {
    id: 'sea-emperor',
    slug: 'sea-emperor',
    name: 'Sea Emperor',
    region: 'Boca Raton, Florida',
    country: 'United States',
    latitude: 26.33,
    longitude: -80.05,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 171-foot hopper barge scuttled in 1991 with a load of concrete culverts, creating the site nicknamed the Aqua Zoo. Southern stingrays, goliath grouper, and green morays gather around the debris field.',
    highlights: ['Aqua Zoo debris field', 'Southern stingrays', 'Goliath grouper'],
    tags: ['wreck', 'barge', 'artificial reef', 'boca raton', 'stingrays'],
    aliases: ['Aqua Zoo'],
    maxDepthM: 22,
  },
  {
    id: 'sea-gardens',
    slug: 'sea-gardens',
    name: 'Sea Gardens',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.157,
    longitude: -80.262,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A gently rolling reef area north of the Elbow with dense soft coral growth and sandy channels. A frequent second-dive and training site for Key Largo operators.',
    highlights: ['Dense gorgonian fields', 'Easy conditions', 'Good training reef'],
    tags: ['florida', 'keys', 'reef', 'coral', 'beginner-friendly'],
    maxDepthM: 9,
  },
  {
    id: 'sea-viking-wreck',
    slug: 'sea-viking-wreck',
    name: 'Sea Viking Wreck',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.98,
    longitude: -77.55,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A former fishing vessel scuttled near the Tongue of the Ocean wall off southwest New Providence as part of Stuart Cove\'s wreck trail. Caribbean reef sharks from the nearby feed sites frequently pass over the hull.',
    highlights: ['Sharks over the wreck', 'Near the wall drop-off', 'Part of a multi-wreck circuit'],
    tags: ['wreck', 'sharks', 'nassau', 'artificial-reef', 'boat-dive'],
    maxDepthM: 18,
  },
  {
    id: 'sebastian-inlet',
    slug: 'sebastian-inlet',
    name: 'Sebastian Inlet',
    region: 'Sebastian, Florida',
    country: 'United States',
    latitude: 27.86,
    longitude: -80.447,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'The jetties and channel of Sebastian Inlet State Park, dived and snorkeled around slack tide when the strong tidal flow eases. Rock structure holds snook, sheepshead, lobster, and juvenile tropicals.',
    highlights: ['State park jetties', 'Snook and lobster', 'Slack-tide diving'],
    tags: ['drift', 'inlet', 'shore dive', 'state park', 'sebastian'],
    maxDepthM: 6,
    requirementNote: 'Dive only at slack tide; strong tidal current otherwise',
  },
  {
    id: 'sec-pate',
    slug: 'sec-pate',
    name: 'Sec Pâté',
    region: 'Les Saintes Channel, Guadeloupe',
    country: 'Guadeloupe',
    latitude: 15.918,
    longitude: -61.645,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An underwater mountain in the deep channel between Basse-Terre and Les Saintes, its summit near 15 meters and flanks falling away into hundreds of meters. Often called one of the Caribbean\'s finest dives for its barrel sponges, black coral, and pelagic traffic.',
    highlights: ['mid-channel seamount', 'giant barrel sponges', 'pelagic encounters'],
    tags: ['seamount', 'deep', 'guadeloupe', 'les-saintes', 'advanced', 'current'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Open-water seamount with current; typically reserved for experienced divers.',
  },
  {
    id: 'shakem-wreck',
    slug: 'shakem-wreck',
    name: 'Shakem',
    region: 'St. George\'s, Grenada',
    country: 'Grenada',
    latitude: 12.01,
    longitude: -61.77,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A cement-laden coastal freighter that sank near Grenada\'s capital in 2001, sitting upright with its cargo still stacked in the holds at around 30 meters. The intact bow and crane draw wreck enthusiasts.',
    highlights: ['upright freighter', 'cement cargo in holds', 'intact bow and crane'],
    tags: ['wreck', 'deep', 'grenada', 'advanced', 'boat-dive'],
    maxDepthM: 32,
    requiredCertification: 'AOW',
  },
  {
    id: 'shangri-la-spring',
    slug: 'shangri-la-spring',
    name: 'Shangri-La Spring',
    region: 'Merritt\'s Mill Pond, Marianna, Florida',
    country: 'United States',
    latitude: 30.7876,
    longitude: -85.1489,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A small cave system entered from Merritt\'s Mill Pond near the upper end of the pond. Its tight, clear passage is a well-known short cave dive in the Marianna area.',
    highlights: ['Compact decorated cave', 'Upper Mill Pond location', 'Gin-clear water'],
    tags: ['cave', 'mill-pond', 'marianna', 'panhandle', 'overhead'],
    maxDepthM: 18,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave-certified divers only',
  },
  {
    id: 'shark-arena-nassau',
    slug: 'shark-arena-nassau',
    name: 'Shark Arena',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.985,
    longitude: -77.545,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A sand amphitheater off southwest New Providence where Stuart Cove\'s conducts its famous chainmail-suited shark feeds. Dozens of Caribbean reef sharks circle divers kneeling on the bottom at about 14 meters.',
    highlights: ['Baited shark feed', 'Dozens of reef sharks', 'Sand arena setting'],
    tags: ['sharks', 'shark-feed', 'nassau', 'sand', 'adrenaline'],
    aliases: ['The Arena'],
    maxDepthM: 14,
  },
  {
    id: 'shark-hotel-provo',
    slug: 'shark-hotel-provo',
    name: 'Shark Hotel',
    region: 'Providenciales, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.85,
    longitude: -72.34,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Northwest Point wall dive off Providenciales named for the grey reef sharks that reliably cruise its face and the sandy chute at its lip. A coral buttress splits the wall into ledges where sharks and groupers hold station.',
    highlights: ['Reliable reef sharks', 'Sand chute to the wall', 'Ledged coral buttress'],
    tags: ['wall', 'sharks', 'providenciales', 'northwest-point', 'drop-off'],
    maxDepthM: 30,
  },
  {
    id: 'shark-junction',
    slug: 'shark-junction',
    name: 'Shark Junction',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.49,
    longitude: -78.66,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'UNEXSO\'s long-running shark dive site off Lucaya, a sandy arena at about 14 meters where Caribbean reef sharks gather for organized feeds. Scattered wreckage and coral heads ring the feeding area.',
    highlights: ['UNEXSO shark feed', 'Caribbean reef sharks up close', 'Sandy arena with wreckage'],
    tags: ['sharks', 'shark-feed', 'grand-bahama', 'lucaya', 'sand'],
    maxDepthM: 14,
  },
  {
    id: 'shark-reef-long-island',
    slug: 'shark-reef-long-island',
    name: 'Shark Reef (Stella Maris)',
    region: 'Long Island, Bahamas',
    country: 'Bahamas',
    latitude: 23.63,
    longitude: -75.35,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The site of the world\'s first organized shark-feeding dive, run by Stella Maris Resort off northern Long Island since the 1970s. Caribbean reef sharks circle a shallow coral amphitheater in predictable numbers.',
    highlights: ['World\'s first shark feed', 'Reliable reef sharks', 'Shallow coral amphitheater'],
    tags: ['sharks', 'shark-feed', 'long-island', 'history', 'shallow'],
    maxDepthM: 12,
  },
  {
    id: 'shark-wall-nassau',
    slug: 'shark-wall-nassau',
    name: 'Shark Wall',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.975,
    longitude: -77.555,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A coral wall on the edge of the Tongue of the Ocean off southwest New Providence, made famous by Stuart Cove\'s shark dives. Caribbean reef sharks patrol the drop-off in numbers even without bait in the water.',
    highlights: ['Tongue of the Ocean drop-off', 'Resident Caribbean reef sharks', 'Colorful wall corals'],
    tags: ['wall', 'sharks', 'nassau', 'drop-off', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'sharons-serenity',
    slug: 'sharons-serenity',
    name: 'Sharon\'s Serenity',
    region: 'Klein Bonaire, Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.155,
    longitude: -68.316,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Calm, protected boat dive on Klein Bonaire\'s west side with pristine hard coral gardens in the shallows and a gentle slope. Often paired with a drift along the adjacent moorings.',
    highlights: ['Pristine coral gardens', 'Calm conditions', 'Gentle drift'],
    tags: ['boat-dive', 'coral', 'klein-bonaire', 'beginner-friendly', 'drift'],
    maxDepthM: 30,
  },
  {
    id: 'sheri-lyn',
    slug: 'sheri-lyn',
    name: 'Sheri-Lyn',
    region: 'Key Biscayne, Florida',
    country: 'United States',
    latitude: 25.687,
    longitude: -80.077,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A steel freighter scuttled off Key Biscayne as part of the Miami-Dade artificial reef program. The broken hull sections create swim-throughs and shelter for snapper and grouper.',
    highlights: ['Freighter hull sections', 'Swim-throughs', 'Snapper and grouper'],
    tags: ['wreck', 'freighter', 'artificial reef', 'miami', 'intermediate'],
    maxDepthM: 29,
  },
  {
    id: 'sherwood-forest',
    slug: 'sherwood-forest',
    name: 'Sherwood Forest',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.71,
    longitude: -83.05,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A famed area of Tortugas Bank west of the Dry Tortugas where mushroom-shaped coral heads form a canopy over the deep reef. Reached only by liveaboard or long-range charter, with protections under the Tortugas Ecological Reserve.',
    highlights: ['Mushroom-shaped coral canopy', 'Liveaboard-only access', 'Ecological reserve waters'],
    tags: ['florida', 'dry-tortugas', 'reef', 'remote', 'deep', 'liveaboard'],
    maxDepthM: 25,
    requiredCertification: 'AOW',
    requirementNote: 'Remote offshore bank averaging 18-25 m; check current reserve regulations.',
  },
  {
    id: 'silver-glen-springs',
    slug: 'silver-glen-springs',
    name: 'Silver Glen Springs',
    region: 'Ocala National Forest, Florida',
    country: 'United States',
    latitude: 29.2463,
    longitude: -81.6437,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A first-magnitude spring flowing to Lake George with a striking natural well vent and schools of striped bass. It is a busy swimming and snorkeling area within the Ocala National Forest.',
    highlights: ['Natural well vent', 'Schooling striped bass', 'Run to Lake George'],
    tags: ['spring', 'snorkel', 'ocala-forest', 'swimming', 'wildlife'],
    maxDepthM: 6,
    requirementNote: 'Snorkeling and swimming only',
  },
  {
    id: 'sisters-rocks-tobago',
    slug: 'sisters-rocks-tobago',
    name: 'Sisters Rocks',
    region: 'Bloody Bay, Tobago',
    country: 'Trinidad and Tobago',
    latitude: 11.3055,
    longitude: -60.6435,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Cluster of volcanic pinnacles off Tobago\'s Caribbean coast dropping steeply into deep water, best known for scalloped hammerhead sightings in the cooler months. Exposed conditions and depth make it a site for experienced divers.',
    highlights: ['Hammerhead season', 'Volcanic pinnacles', 'Deep drop-offs'],
    tags: ['pinnacle', 'boat-dive', 'tobago', 'sharks', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deep pinnacles with current and open-ocean exposure.',
  },
  {
    id: 'smith-shoal',
    slug: 'smith-shoal',
    name: 'Smith Shoal',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.72,
    longitude: -81.92,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A lit Gulf-side shoal northwest of Key West known for summer aggregations of goliath grouper around its rocky ledges. Visibility varies but the fish life can be spectacular.',
    highlights: ['Goliath grouper aggregation', 'Gulf-side ledges', 'Lit navigational shoal'],
    tags: ['florida', 'keys', 'reef', 'gulf-side', 'grouper'],
    maxDepthM: 9,
  },
  {
    id: 'snake-bay',
    slug: 'snake-bay',
    name: 'Snake Bay',
    region: 'Sint Michiel, Curaçao',
    country: 'Curacao',
    latitude: 12.151,
    longitude: -69.007,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Shore dive next to the fishing village of Sint Michiel with a steep, healthy reef slope and frequent sightings of snake eels that give the site its name. Often clearer than sites nearer Willemstad.',
    highlights: ['Steep healthy slope', 'Snake eel sightings', 'Local fishing village setting'],
    tags: ['shore-dive', 'coral', 'curacao', 'eels', 'wall'],
    maxDepthM: 35,
  },
  {
    id: 'snapper-hole-grand-cayman',
    slug: 'snapper-hole-grand-cayman',
    name: 'Snapper Hole',
    region: 'Grand Cayman (East End), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.302,
    longitude: -81.077,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'An East End maze of tunnels, caverns and chimneys cut through the shallow reef, home to schooling snapper and tarpon. An 1872 anchor is embedded in one of the passages.',
    highlights: ['Tunnel and cavern network', 'Schooling snapper and tarpon', '1872 anchor in the reef'],
    tags: ['east-end', 'swim-throughs', 'caverns', 'schooling-fish', 'reef'],
    maxDepthM: 18,
  },
  {
    id: 'snapper-ledge',
    slug: 'snapper-ledge',
    name: 'Snapper Ledge',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 24.982,
    longitude: -80.421,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A low ledge system near Pickles Reef famous for enormous resident schools of yellowtail snapper, grunts, and porkfish that blanket the bottom. One of the fishiest easy dives in the Upper Keys.',
    highlights: ['Massive snapper schools', 'Photographer favorite', 'Shallow ledge terrain'],
    tags: ['florida', 'keys', 'reef', 'fish-schools', 'shallow', 'photography'],
    maxDepthM: 8,
  },
  {
    id: 'sombrero-reef',
    slug: 'sombrero-reef',
    name: 'Sombrero Reef',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.6262,
    longitude: -81.1103,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Marathon\'s signature reef, a Sanctuary Preservation Area beneath the 142-foot Sombrero Key lighthouse. Well-developed spur-and-groove coral fingers radiate from the tower with thick fish life.',
    highlights: ['Historic Sombrero Key light', 'Classic spur-and-groove', 'Dense tropical fish'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'spa', 'lighthouse'],
    aliases: ['Sombrero Key'],
    maxDepthM: 9,
  },
  {
    id: 'something-special',
    slug: 'something-special',
    name: 'Something Special',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.1605,
    longitude: -68.2815,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Shore dive just north of the Harbour Village marina entrance, known for its garden eel colonies on the sand slope and frequent sightings of eagle rays. Easy conditions close to Kralendijk.',
    highlights: ['Garden eel colonies', 'Eagle ray sightings', 'Close to town'],
    tags: ['shore-dive', 'sand-slope', 'bonaire', 'beginner-friendly', 'eels'],
    maxDepthM: 30,
  },
  {
    id: 'sonesta-airplane-wrecks',
    slug: 'sonesta-airplane-wrecks',
    name: 'Sonesta Airplane Wrecks',
    region: 'Renaissance Island, Aruba',
    country: 'Aruba',
    latitude: 12.503,
    longitude: -70.04,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'Two sunken aircraft, including a Convair airliner, placed as artificial reefs off Renaissance (formerly Sonesta) Island near the airport. The fuselages sit on sand and attract barracuda and schooling fish.',
    highlights: ['Sunken airliner fuselage', 'Artificial reef', 'Barracuda'],
    tags: ['wreck', 'airplane', 'aruba', 'boat-dive', 'artificial-reef'],
    maxDepthM: 24,
  },
  {
    id: 'soufriere-pinnacles',
    slug: 'soufriere-pinnacles',
    name: 'Soufriere Pinnacles',
    region: 'Soufriere Bay, Dominica',
    country: 'Dominica',
    latitude: 15.227,
    longitude: -61.365,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Volcanic spires rising from the floor of Soufriere Bay\'s submerged crater toward the surface, wrapped in crinoids, sponges, and dense small fish. The vertical structures showcase Dominica\'s dramatic underwater geology.',
    highlights: ['volcanic spires', 'crinoid-covered rock', 'crater-bay setting'],
    tags: ['pinnacle', 'volcanic', 'dominica', 'marine-reserve', 'boat-dive'],
    maxDepthM: 25,
  },
  {
    id: 'south-carysfort-reef',
    slug: 'south-carysfort-reef',
    name: 'South Carysfort Reef',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.2083,
    longitude: -80.2183,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The southern section of the Carysfort Sanctuary Preservation Area, with shallow coral ridges and sandy channels. A quieter alternative to the lighthouse moorings with similar fish life.',
    highlights: ['Shallow coral ridges', 'Part of Carysfort SPA', 'Abundant reef fish'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'spa'],
    maxDepthM: 12,
  },
  {
    id: 'spanish-anchor-grand-cayman',
    slug: 'spanish-anchor-grand-cayman',
    name: 'Spanish Anchor',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.294,
    longitude: -81.389,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A George Town-area reef named for an old coral-encrusted anchor wedged into a crevice in the reef. Shallow ridges and grooves make it a relaxed second dive full of reef fish.',
    highlights: ['Coral-encrusted historic anchor', 'Shallow ridge-and-groove reef', 'Relaxed easy dive'],
    tags: ['reef', 'shallow', 'george-town', 'historic', 'artifact'],
    maxDepthM: 15,
  },
  {
    id: 'spanish-anchor-negril-jamaica',
    slug: 'spanish-anchor-negril-jamaica',
    name: 'Spanish Anchor',
    region: 'Negril, Jamaica',
    country: 'Jamaica',
    latitude: 18.305,
    longitude: -78.368,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A Negril reef dive centered on an old anchor grown into the coral, said to date from the Spanish colonial era. Ledges and small swim-throughs around it hold lobster, eels and schooling grunts.',
    highlights: ['Colonial-era anchor', 'Ledges and swim-throughs', 'Lobster and moray eels'],
    tags: ['reef', 'negril', 'anchor', 'historic', 'ledges'],
    maxDepthM: 18,
  },
  {
    id: 'ss-antilla',
    slug: 'ss-antilla',
    name: 'SS Antilla',
    region: 'Malmok, Aruba',
    country: 'Aruba',
    latitude: 12.6017,
    longitude: -70.0575,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A 120-meter German freighter scuttled in 1940, one of the largest wrecks in the Caribbean, resting in about 18 meters off Malmok with parts breaking the surface. Heavily encrusted and swarming with fish, it suits divers and snorkelers alike.',
    highlights: ['One of the Caribbean\'s largest wrecks', 'Shallow and snorkel-friendly', 'WWII history'],
    tags: ['wreck', 'boat-dive', 'aruba', 'history', 'snorkeling'],
    aliases: ['Antilla Wreck', 'The Ghost Ship'],
    maxDepthM: 18,
  },
  {
    id: 'breconshire',
    slug: 'breconshire',
    name: 'SS Breconshire',
    region: 'Vero Beach, Florida',
    country: 'United States',
    latitude: 27.66,
    longitude: -80.35,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A British steamer that struck the reef and sank in 1894 just off Vero Beach, with its boiler still breaking the surface at low tide. The shallow wreckage is a popular swim-out shore dive and snorkel.',
    highlights: ['Visible boiler', '1894 steamer', 'Shore swim-out'],
    tags: ['wreck', 'historic', 'shore dive', 'snorkel', 'vero beach'],
    aliases: ['Boiler Wreck'],
    maxDepthM: 5,
  },
  {
    id: 'ss-copenhagen',
    slug: 'ss-copenhagen',
    name: 'SS Copenhagen',
    region: 'Lauderdale-by-the-Sea, Florida',
    country: 'United States',
    latitude: 26.188,
    longitude: -80.085,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A British steamer that ran aground on the reef in 1900 and is now a Florida Underwater Archaeological Preserve. The scattered hull plates and boilers sit in shallow water thick with reef fish.',
    highlights: ['1900 shipwreck', 'Underwater Archaeological Preserve', 'Shallow and fishy'],
    tags: ['wreck', 'historic', 'preserve', 'shallow', 'beginner'],
    maxDepthM: 9,
  },
  {
    id: 'ss-pedernales',
    slug: 'ss-pedernales',
    name: 'SS Pedernales',
    region: 'Palm Beach, Aruba',
    country: 'Aruba',
    latitude: 12.5735,
    longitude: -70.053,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'Midsection of a WWII lake tanker torpedoed in 1942, lying scattered in about 8 meters of sand off Palm Beach. Its shallow, open wreckage makes it a popular second dive and training site.',
    highlights: ['WWII torpedo casualty', 'Shallow scattered wreckage', 'Easy conditions'],
    tags: ['wreck', 'boat-dive', 'aruba', 'history', 'beginner-friendly'],
    maxDepthM: 10,
  },
  {
    id: 'sapona-wreck',
    slug: 'sapona-wreck',
    name: 'SS Sapona',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.643,
    longitude: -79.292,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A World War I-era concrete-hulled cargo ship that ran aground in a 1926 hurricane between South Bimini and Cat Cay, its upper structure still standing above the surface. The hull sits in under five meters of water and doubles as a snorkel and training site.',
    highlights: ['Half-exposed concrete ship', 'Prohibition-era history', 'Shallow swim-throughs'],
    tags: ['wreck', 'shallow', 'bimini', 'history', 'snorkel'],
    aliases: ['Sapona Shipwreck'],
    maxDepthM: 5,
  },
  {
    id: 'stavronikita',
    slug: 'stavronikita',
    name: 'SS Stavronikita',
    region: 'West coast, Barbados',
    country: 'Barbados',
    latitude: 13.147,
    longitude: -59.633,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 365-foot Greek freighter sunk in 1978 as an artificial reef in Folkestone Marine Park, sitting upright with its masts reaching toward 6 meters and the hull bottoming near 40. It is widely rated among the Caribbean\'s best wreck dives.',
    highlights: ['365-foot upright freighter', 'masts from 6 m to hull at 40 m', 'Folkestone Marine Park'],
    tags: ['wreck', 'deep', 'barbados', 'advanced', 'artificial-reef'],
    aliases: ['Stavi'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deck near 25-30 m; wreck certification recommended for interior corridors.',
  },
  {
    id: 'ss-tarpon',
    slug: 'ss-tarpon',
    name: 'SS Tarpon',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.095,
    longitude: -85.943,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A coastal steamer that sank in a 1937 storm after decades of Gulf freight service, now a Florida Underwater Archaeological Preserve off Panama City Beach. The historic wreckage lies in about 29 meters of open Gulf water.',
    highlights: ['1937 historic sinking', 'Archaeological preserve', 'Genuine steamship'],
    tags: ['wreck', 'historic', 'preserve', 'deep', 'panama city'],
    maxDepthM: 29,
    requiredCertification: 'AOW',
  },
  {
    id: 'st-george-wreck-bayahibe',
    slug: 'st-george-wreck-bayahibe',
    name: 'St. George Wreck',
    region: 'Bayahibe, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 18.355,
    longitude: -68.825,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 73-meter freighter scuttled off Bayahibe in 1999, sitting upright with its deck around 20-35 meters and the sand near 44 meters. Barracuda and jacks patrol the masts while the hull hosts thick encrusting growth.',
    highlights: ['Large upright freighter', 'Barracuda over the deck', 'Deep dramatic profile'],
    tags: ['wreck', 'bayahibe', 'deep', 'artificial-reef', 'barracuda'],
    maxDepthM: 44,
    requiredCertification: 'AOW',
    requirementNote: 'Deck lies below 20 m; penetration only for trained wreck divers.',
  },
  {
    id: 'stage-ii',
    slug: 'stage-ii',
    name: 'Stage II',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.14,
    longitude: -85.8,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The remains of a former Navy research platform close to shore off Panama City Beach, long used for training and night dives. The pilings and debris shelter octopus, urchins, and juvenile fish.',
    highlights: ['Old Navy platform', 'Night dive favorite', 'Close to shore'],
    tags: ['artificial reef', 'platform', 'training', 'panama city', 'beginner'],
    maxDepthM: 18,
  },
  {
    id: 'suffolk-maid-wreck',
    slug: 'suffolk-maid-wreck',
    name: 'Suffolk Maid',
    region: 'St. Croix, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 17.735,
    longitude: -64.895,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A 144-foot North Sea trawler driven ashore by a hurricane and later sunk in Butler Bay as an artificial reef in about 20 meters. Its open wheelhouse and deck machinery are easy to explore on a single tank.',
    highlights: ['intact trawler profile', 'open wheelhouse', 'mid-depth wreck trail stop'],
    tags: ['wreck', 'usvi', 'butler-bay', 'artificial-reef', 'boat-dive'],
    maxDepthM: 20,
  },
  {
    id: 'sugar-wreck',
    slug: 'sugar-wreck',
    name: 'Sugar Wreck',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.92,
    longitude: -79.06,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered remains of an old sailing barge on the shallow Little Bahama Bank off West End, sitting in about six meters of clear water. The wreckage teems with fish life and is a favorite second dive and night dive for liveaboards.',
    highlights: ['Very shallow and bright', 'Dense fish aggregations', 'Great night dive'],
    tags: ['wreck', 'shallow', 'grand-bahama', 'night-dive', 'beginner-friendly'],
    maxDepthM: 6,
  },
  {
    id: 'sunken-rock',
    slug: 'sunken-rock',
    name: 'Sunken Rock',
    region: 'English Harbour, Antigua',
    country: 'Antigua and Barbuda',
    latitude: 17,
    longitude: -61.775,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Antigua\'s deepest regularly dived site, a submerged pinnacle near English Harbour that drops in steps toward 40 meters. The deeper ledges attract barracuda, black durgon, and occasional reef sharks.',
    highlights: ['deep pinnacle steps', 'barracuda and durgon', 'Antigua\'s deepest regular dive'],
    tags: ['pinnacle', 'deep', 'antigua', 'advanced', 'boat-dive'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
  },
  {
    id: 'sunset-reef-grand-cayman',
    slug: 'sunset-reef-grand-cayman',
    name: 'Sunset Reef',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.284,
    longitude: -81.39,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The house reef of Sunset House just south of George Town, famous for the bronze mermaid statue Amphitrite sitting on the sand at nine meters. An easy shore dive with coral heads and a mini-wall.',
    highlights: ['Amphitrite mermaid statue', 'Easy shore access', 'Popular night dive'],
    tags: ['shore-dive', 'statue', 'house-reef', 'shallow', 'night-dive'],
    aliases: ['Sunset House Reef'],
    maxDepthM: 15,
  },
  {
    id: 'suwanee-reef',
    slug: 'suwanee-reef',
    name: 'Suwanee Reef',
    region: 'La Paz, Mexico',
    country: 'Mexico',
    latitude: 24.3,
    longitude: -110.29,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow rocky reef crest in La Paz bay topped with hard corals and clouds of yellow snapper and sergeant majors. Its easy depth and calm conditions make it a staple first dive on La Paz itineraries.',
    highlights: ['Clouds of yellow snapper', 'Shallow coral crest', 'Easy conditions'],
    tags: ['reef', 'shallow', 'beginner', 'la-paz', 'sea-of-cortez'],
    aliases: ['Swanee Reef'],
    maxDepthM: 12,
  },
  {
    id: 'suwannacoochee-spring',
    slug: 'suwannacoochee-spring',
    name: 'Suwannacoochee Spring',
    region: 'Ellaville, Florida',
    country: 'United States',
    latitude: 30.3877,
    longitude: -83.171,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Intermediate',
    summary: 'A spring emerging beside an old stone bathhouse wall at the confluence of the Withlacoochee and Suwannee rivers near Suwannee River State Park. A low limestone conduit carries flow beneath the riverbank.',
    highlights: ['Historic bathhouse ruins', 'River confluence setting', 'Limestone conduit'],
    tags: ['spring', 'cavern', 'suwannee', 'historic', 'north-florida'],
    maxDepthM: 9,
    requiredCertification: 'Cavern',
    requirementNote: 'Overhead training required to enter the conduit',
  },
  {
    id: 'sylvan-springs',
    slug: 'sylvan-springs',
    name: 'Sylvan Springs',
    region: 'Econfina Creek, Youngstown, Florida',
    country: 'United States',
    latitude: 30.428,
    longitude: -85.552,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A cluster of small, clear spring vents feeding Econfina Creek between Pitt and Gainer springs. Paddlers stop here to swim and snorkel over the sandy boils.',
    highlights: ['Cluster of clear vents', 'Quiet paddle-in stop', 'Sandy shallow boils'],
    tags: ['spring', 'snorkel', 'econfina', 'kayak', 'panhandle'],
    maxDepthM: 4,
  },
  {
    id: 'tarpon-alley-grand-cayman',
    slug: 'tarpon-alley-grand-cayman',
    name: 'Tarpon Alley',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.407,
    longitude: -81.345,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A winding canyon system on the North Wall where schools of silvery tarpon hover in the shaded ravines. The alley runs out to the wall edge overlooking the Cayman Trench.',
    highlights: ['Schooling tarpon', 'Winding coral canyons', 'North Wall drop-off'],
    tags: ['wall', 'north-wall', 'tarpon', 'canyons', 'schooling-fish'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Canyons and wall sections below 18 m.',
  },
  {
    id: 'tartar-bank',
    slug: 'tartar-bank',
    name: 'Tartar Bank',
    region: 'Cat Island, Bahamas',
    country: 'Bahamas',
    latitude: 24.07,
    longitude: -75.55,
    matchRadiusKm: 8,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'An offshore seamount southwest of Cat Island whose plateau rises from deep ocean, drawing hammerheads, sharks, and huge schools of jacks. Exposure and current make it an advanced open-ocean dive.',
    highlights: ['Open-ocean seamount', 'Hammerheads and pelagics', 'Big schooling fish'],
    tags: ['seamount', 'pelagics', 'cat-island', 'current', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Blue-water descents and current; experienced divers only.',
  },
  {
    id: 'tears-of-allah-wreck',
    slug: 'tears-of-allah-wreck',
    name: 'Tears of Allah (James Bond Wreck)',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.989,
    longitude: -77.54,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A small freighter sunk for the 1983 James Bond film Never Say Never Again, resting in shallow water off southwest New Providence. The wreck is heavily encrusted and often visited on the same dive as the nearby Bond film props.',
    highlights: ['James Bond film wreck', 'Shallow and well-lit', 'Coral-encrusted hull'],
    tags: ['wreck', 'movie-site', 'nassau', 'shallow', 'photography'],
    aliases: ['James Bond Wreck', 'Never Say Never Again Wreck'],
    maxDepthM: 13,
  },
  {
    id: 'telephone-pole-san-salvador',
    slug: 'telephone-pole-san-salvador',
    name: 'Telephone Pole',
    region: 'San Salvador, Bahamas',
    country: 'Bahamas',
    latitude: 24.03,
    longitude: -74.54,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A long-standing favorite on San Salvador\'s west wall, named for an old telephone pole once used as a shore marker. A sand chute funnels divers through the reef lip onto a steep sponge-covered face.',
    highlights: ['Sand chute to the wall', 'Giant barrel sponges', 'Frequent turtle traffic'],
    tags: ['wall', 'san-salvador', 'sponges', 'drop-off', 'boat-dive'],
    maxDepthM: 35,
  },
  {
    id: 'telford-spring',
    slug: 'telford-spring',
    name: 'Telford Spring',
    region: 'Luraville, Florida',
    country: 'United States',
    latitude: 30.1069,
    longitude: -83.1666,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A Suwannee River spring at Luraville with a well-traveled cave system beneath a small basin. It has long served as a classic intro-to-cave site when river levels allow clear water.',
    highlights: ['Classic Suwannee cave dive', 'Intro-friendly passage', 'Riverside setting'],
    tags: ['cave', 'spring', 'suwannee', 'luraville', 'overhead'],
    maxDepthM: 21,
    requiredCertification: 'IntroCave',
    requirementNote: 'Cave-certified divers only; conditions depend on Suwannee River level',
  },
  {
    id: 'ten-fathom-ledge',
    slug: 'ten-fathom-ledge',
    name: 'Ten Fathom Ledge',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.437,
    longitude: -81.883,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A deeper ledge line seaward of Sand Key dropping to around 18 meters, undercut with holes that hold big grouper, morays, and passing pelagics. Named for its ten-fathom depth on old charts.',
    highlights: ['Undercut deep ledge', 'Large grouper and morays', 'Pelagic traffic from the Stream'],
    tags: ['florida', 'keys', 'reef', 'ledge', 'deep', 'key-west'],
    aliases: ['Ten Fathom Bar'],
    maxDepthM: 18,
  },
  {
    id: 'tenneco-towers',
    slug: 'tenneco-towers',
    name: 'Tenneco Towers',
    region: 'Hallandale Beach, Florida',
    country: 'United States',
    latitude: 25.98,
    longitude: -80.085,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'Sections of a decommissioned Gulf of Mexico oil production platform deployed in 1985 as an artificial reef off Hallandale Beach. The steel lattice structures rise from deep sand and attract huge schools of baitfish, jacks, and barracuda.',
    highlights: ['Oil platform structure', 'Large fish schools', 'Multiple depth levels'],
    tags: ['artificial reef', 'platform', 'deep', 'fish life', 'advanced'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
    requirementNote: 'Base sections sit beyond 30 m; strong current possible',
  },
  {
    id: 'tent-reef',
    slug: 'tent-reef',
    name: 'Tent Reef',
    region: 'Saba',
    country: 'Caribbean Netherlands',
    latitude: 17.612,
    longitude: -63.25,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow ledge system near Saba\'s Fort Bay harbor that drops onto a sponge-crowded wall, one of the most frequently dived sites in the Saba Marine Park. Frogfish, turtles, and dense macro life reward slow exploration.',
    highlights: ['sponge-covered ledge', 'frogfish and macro life', 'marine park staple'],
    tags: ['reef', 'wall', 'saba', 'macro', 'marine-park'],
    aliases: ['Tent Reef Wall'],
    maxDepthM: 20,
  },
  {
    id: 'texas-rock',
    slug: 'texas-rock',
    name: 'Texas Rock',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.662,
    longitude: -82.885,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A high-relief coral mound north of Garden Key in Dry Tortugas National Park, rising from deeper sand to within a few meters of the surface. Towering star coral heads shelter grouper and snapper.',
    highlights: ['High-relief coral pinnacle', 'Big grouper habitat', 'Remote park diving'],
    tags: ['florida', 'dry-tortugas', 'reef', 'national-park', 'pinnacle'],
    maxDepthM: 15,
  },
  {
    id: 'amphitheater-grand-turk',
    slug: 'amphitheater-grand-turk',
    name: 'The Amphitheater (Grand Turk)',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.49,
    longitude: -71.16,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A huge concave sweep in the Grand Turk wall that forms a natural amphitheater of coral and sand. Divers hang in the bowl watching sharks, turtles, and eagle rays pass along the face.',
    highlights: ['Concave wall bowl', 'Eagle rays along the face', 'Grandstand viewing effect'],
    tags: ['wall', 'grand-turk', 'drop-off', 'pelagics', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'amphitheatre-northwest-point',
    slug: 'amphitheatre-northwest-point',
    name: 'The Amphitheatre (Northwest Point)',
    region: 'Providenciales, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.86,
    longitude: -72.34,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A vast bowl-shaped cutback in the Northwest Point wall off Providenciales, sweeping from a sandy stage down the vertical face. The natural arena effect and sponge-covered walls make it a signature Provo dive.',
    highlights: ['Bowl-shaped wall cutback', 'Sandy amphitheater stage', 'Vertical sponge walls'],
    tags: ['wall', 'providenciales', 'northwest-point', 'drop-off', 'boat-dive'],
    maxDepthM: 30,
  },
  {
    id: 'the-anchor-grand-turk',
    slug: 'the-anchor-grand-turk',
    name: 'The Anchor',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.44,
    longitude: -71.15,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A southern Grand Turk wall site marked by an old ship\'s anchor wedged into the coral at the reef lip. The historic anchor makes a natural photo stop before divers drop onto the sponge-lined face.',
    highlights: ['Historic wedged anchor', 'Photo-friendly reef lip', 'Sponge-lined wall'],
    tags: ['wall', 'grand-turk', 'history', 'drop-off', 'photography'],
    maxDepthM: 30,
  },
  {
    id: 'the-barge-andros',
    slug: 'the-barge-andros',
    name: 'The Barge (Andros)',
    region: 'Andros, Bahamas',
    country: 'Bahamas',
    latitude: 24.73,
    longitude: -77.76,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A steel barge sunk in the late 1960s off Fresh Creek as an artificial reef, now one of Small Hope Bay\'s most reliable fish dives. Resident groupers, snappers, and morays crowd the collapsing structure at about 21 meters.',
    highlights: ['Tame resident groupers', 'Fish-packed structure', 'Easy navigation'],
    tags: ['wreck', 'artificial-reef', 'andros', 'fish-life', 'boat-dive'],
    maxDepthM: 21,
  },
  {
    id: 'the-boiler-san-benedicto',
    slug: 'the-boiler-san-benedicto',
    name: 'The Boiler (San Benedicto)',
    region: 'Revillagigedo Islands, Mexico',
    country: 'Mexico',
    latitude: 19.325,
    longitude: -110.823,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A flat-topped volcanic pinnacle off San Benedicto Island, world-famous for close encounters with giant oceanic manta rays that seek out divers\' bubbles. Dolphins, sharks, and seasonal humpbacks round out one of the planet\'s great big-animal dives.',
    highlights: ['Friendly giant mantas', 'Wild dolphin encounters', 'Volcanic pinnacle'],
    tags: ['pinnacle', 'mantas', 'liveaboard', 'revillagigedo', 'pacific'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Liveaboard-only marine park; operators require Advanced Open Water and typically 50+ logged dives.',
  },
  {
    id: 'the-caves-norman-island',
    slug: 'the-caves-norman-island',
    name: 'The Caves (Norman Island)',
    region: 'Norman Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.3175,
    longitude: -64.6185,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Three sea caves at Treasure Point on Norman Island, linked by legend to Robert Louis Stevenson\'s Treasure Island. The shallow caverns and surrounding reef shelter glassy sweepers, tarpon, and turtles.',
    highlights: ['treasure-legend sea caves', 'glassy sweepers', 'easy shallow profile'],
    tags: ['cavern', 'shallow', 'bvi', 'snorkel', 'beginner'],
    aliases: ['Treasure Point Caves'],
    maxDepthM: 12,
  },
  {
    id: 'the-chimney',
    slug: 'the-chimney',
    name: 'The Chimney',
    region: 'Great Dog Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.474,
    longitude: -64.456,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'On the west side of Great Dog, a narrow rock chimney and coral-lined archway funnel divers through walls covered in cup corals and sponges. It is widely considered one of the BVI\'s prettiest shallow swim-throughs.',
    highlights: ['famous narrow swim-through', 'cup coral walls', 'fish-filled arch'],
    tags: ['swim-through', 'reef', 'bvi', 'dog-islands', 'shallow'],
    maxDepthM: 14,
  },
  {
    id: 'the-cracks-la-parguera',
    slug: 'the-cracks-la-parguera',
    name: 'The Cracks',
    region: 'La Parguera, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 17.935,
    longitude: -67.055,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow inner-shelf reef near La Parguera cut by long parallel fissures that divers weave through. The cracks shelter lobster, eels and schooling grunts, making a relaxed complement to the wall dives.',
    highlights: ['Long reef fissures', 'Lobster and eels', 'Easy shallow profile'],
    tags: ['reef', 'la-parguera', 'shallow', 'swim-throughs', 'fish-life'],
    maxDepthM: 15,
  },
  {
    id: 'the-driveway-west-caicos',
    slug: 'the-driveway-west-caicos',
    name: 'The Driveway',
    region: 'West Caicos, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.66,
    longitude: -72.48,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A West Caicos wall dive where a broad sand ramp slopes off the shelf and pours over the drop-off like a driveway. Garden eels line the sand while sharks and turtles work the wall below.',
    highlights: ['Sand ramp over the wall', 'Garden eel colonies', 'Turtles and reef sharks'],
    tags: ['wall', 'west-caicos', 'sand-chute', 'drop-off', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'elbow-reef',
    slug: 'elbow-reef',
    name: 'The Elbow',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.144,
    longitude: -80.2583,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An elbow-shaped bend in the outer reef line marked by a light tower, protected as a Sanctuary Preservation Area. Several historic wrecks are scattered across its shallow spur-and-groove coral.',
    highlights: ['Multiple historic wrecks', 'Spur-and-groove coral', 'Light tower landmark'],
    tags: ['florida', 'keys', 'reef', 'spur-and-groove', 'spa', 'wreck'],
    aliases: ['Elbow Reef'],
    maxDepthM: 11,
  },
  {
    id: 'the-elbow-turneffe',
    slug: 'the-elbow-turneffe',
    name: 'The Elbow',
    region: 'Turneffe Atoll, Belize',
    country: 'Belize',
    latitude: 17.163,
    longitude: -87.905,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'Signature drift dive at the southern tip of Turneffe Atoll, where converging currents sweep a coral promontory patrolled by huge schools of horse-eye jacks, snapper, and pelagics. Depth and current make it Turneffe\'s premier advanced dive.',
    highlights: ['Massive jack schools', 'Pelagic action', 'Current-swept promontory'],
    tags: ['drift', 'boat-dive', 'belize', 'turneffe', 'advanced'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Open-water drift with current and depth; experienced divers only.',
  },
  {
    id: 'the-gullies-west-caicos',
    slug: 'the-gullies-west-caicos',
    name: 'The Gullies',
    region: 'West Caicos, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.67,
    longitude: -72.48,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A series of parallel sand gullies slicing through the reef crest on the West Caicos wall, each channel emptying onto the vertical face. Nurse sharks and lobsters shelter in the cuts while pelagics pass in the blue.',
    highlights: ['Parallel sand cuts', 'Sheltering nurse sharks', 'Vertical wall exits'],
    tags: ['wall', 'west-caicos', 'canyons', 'drop-off', 'liveaboard'],
    maxDepthM: 30,
  },
  {
    id: 'the-indians',
    slug: 'the-indians',
    name: 'The Indians',
    region: 'Norman Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.3113,
    longitude: -64.6262,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Four jagged pinnacles rising from 12 meters to above the surface near Norman Island, ringed by coral gardens, a small cave, and clouds of reef fish. It is one of the most dived and snorkeled sites in the BVI.',
    highlights: ['four rock pinnacles', 'coral-lined canyons', 'snorkel-friendly shallows'],
    tags: ['pinnacle', 'reef', 'bvi', 'beginner', 'snorkel'],
    maxDepthM: 12,
  },
  {
    id: 'the-lake-bonaire',
    slug: 'the-lake-bonaire',
    name: 'The Lake',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.1075,
    longitude: -68.291,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Part of Bonaire\'s southern double-reef system, where two parallel coral ridges are separated by a sand channel resembling a lake. Just north of the Hilma Hooker mooring.',
    highlights: ['Double reef system', 'Sand channel between ridges', 'Garden eels'],
    tags: ['shore-dive', 'double-reef', 'bonaire', 'coral', 'sand-channel'],
    maxDepthM: 33,
  },
  {
    id: 'the-library-grand-turk',
    slug: 'the-library-grand-turk',
    name: 'The Library',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.46,
    longitude: -71.15,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A Grand Turk wall site opposite the island\'s old library, with a gentle reef shelf giving way to the vertical face. Its easy conditions and dense fish life make it a staple check-out and night dive.',
    highlights: ['Easy shelf-to-wall profile', 'Popular night dive', 'Dense small fish life'],
    tags: ['wall', 'grand-turk', 'night-dive', 'beginner-friendly', 'boat-dive'],
    maxDepthM: 25,
  },
  {
    id: 'the-maze-grand-cayman',
    slug: 'the-maze-grand-cayman',
    name: 'The Maze',
    region: 'Grand Cayman (East End), Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.269,
    longitude: -81.098,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A convoluted system of winding channels and chutes on Grand Cayman\'s southeast wall that spill out over the deep drop-off. Reef sharks and eagle rays patrol the wall face.',
    highlights: ['Labyrinth of wall channels', 'Reef shark sightings', 'Dramatic drop-off'],
    tags: ['wall', 'east-end', 'canyons', 'sharks', 'deep'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Channels exit the wall below 20 m.',
  },
  {
    id: 'the-pit-cenote',
    slug: 'the-pit-cenote',
    name: 'The Pit',
    region: 'Tulum, Mexico',
    country: 'Mexico',
    latitude: 20.324,
    longitude: -87.414,
    matchRadiusKm: 3,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'The deepest cenote in the Dos Ojos/Sac Actun system, a dramatic shaft where light beams pierce a hydrogen sulfide cloud at around 30 m. Recreational dives descend the open shaft to about 30-40 m with a guide.',
    highlights: ['Light beams in the shaft', 'Hydrogen sulfide cloud', 'Deep open descent'],
    tags: ['cenote', 'deep', 'sinkhole', 'tulum', 'advanced'],
    aliases: ['El Pit'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Guided deep cenote dive; Advanced Open Water or deep experience required. Cave lines beyond require full cave certification.',
  },
  {
    id: 'the-point-negril-jamaica',
    slug: 'the-point-negril-jamaica',
    name: 'The Point',
    region: 'Negril, Jamaica',
    country: 'Jamaica',
    latitude: 18.29,
    longitude: -78.375,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'A deep reef off Negril\'s West End cliffs near the lighthouse, where the bottom steps down past ledges and overhangs into deeper water. Currents can run here, drawing in bigger fish and rays.',
    highlights: ['Deep ledges and overhangs', 'Bigger pelagic fish', 'West End cliff scenery'],
    tags: ['deep', 'negril', 'west-end', 'ledges', 'current'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Depth and occasional current.',
  },
  {
    id: 'runway-nassau',
    slug: 'runway-nassau',
    name: 'The Runway',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.983,
    longitude: -77.542,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sandy channel bordered by coral ridges off southwest New Providence, used as a swim-along route on Stuart Cove\'s shark dives. Reef sharks cruise the sand strip alongside divers, with stingrays and garden eels in the flats.',
    highlights: ['Sharks cruising the sand channel', 'Stingrays and garden eels', 'Gentle easy profile'],
    tags: ['sharks', 'sand', 'nassau', 'beginner-friendly', 'boat-dive'],
    maxDepthM: 12,
  },
  {
    id: 'the-tunnels-grand-turk',
    slug: 'the-tunnels-grand-turk',
    name: 'The Tunnels',
    region: 'Grand Turk, Turks and Caicos',
    country: 'Turks and Caicos Islands',
    latitude: 21.48,
    longitude: -71.155,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Twin coral chimneys and tunnels that drop divers through the Grand Turk reef lip onto the sheer wall. The swim-throughs exit around 30 meters on a face draped in black coral and sponges.',
    highlights: ['Chimney swim-throughs', 'Black coral on the face', 'Dramatic wall exit'],
    tags: ['wall', 'swim-through', 'grand-turk', 'drop-off', 'photography'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
    requirementNote: 'Tunnel exits open onto the wall near 30 m.',
  },
  {
    id: 'theos-wreck',
    slug: 'theos-wreck',
    name: 'Theo\'s Wreck',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.487,
    longitude: -78.795,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 70-meter steel freighter scuttled in 1982 off Freeport, lying on its port side in about 30 meters near the edge of the Grand Bahama ledge. It is the island\'s signature wreck, home to green morays, groupers, and dense encrusting growth.',
    highlights: ['Iconic 70 m freighter', 'Resident green morays', 'Ledge-edge setting'],
    tags: ['wreck', 'deep', 'grand-bahama', 'freeport', 'photography'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
    requirementNote: 'Depth of 30 m+ puts the hull beyond Open Water limits.',
  },
  {
    id: 'third-encounter',
    slug: 'third-encounter',
    name: 'Third Encounter',
    region: 'Saba',
    country: 'Caribbean Netherlands',
    latitude: 17.648,
    longitude: -63.268,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'The most famous of Saba\'s offshore seamounts, a flat-topped pinnacle rising to about 27 meters that includes the freestanding spire called Eye of the Needle. Blue open water, black coral, and circling sharks make it a bucket-list deep dive.',
    highlights: ['Eye of the Needle spire', 'seamount in blue water', 'shark encounters'],
    tags: ['seamount', 'deep', 'saba', 'advanced', 'pelagics'],
    aliases: ['Eye of the Needle'],
    maxDepthM: 34,
    requiredCertification: 'AOW',
    requirementNote: 'Pinnacle top at ~27 m; the entire dive is deep with no shallow reference.',
  },
  {
    id: 'thomas-heyward',
    slug: 'thomas-heyward',
    name: 'Thomas Heyward Liberty Ship',
    region: 'Destin, Florida',
    country: 'United States',
    latitude: 30.31,
    longitude: -86.44,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A WWII Liberty ship hull scuttled in 1977 as an artificial reef off Destin\'s East Pass. The broken sections create high relief on the sand and hold big grouper, snapper, and amberjack.',
    highlights: ['Liberty ship reef', 'High relief sections', 'Big Gulf fish'],
    tags: ['wreck', 'liberty ship', 'artificial reef', 'destin', 'intermediate'],
    aliases: ['Destin Liberty Ship'],
    maxDepthM: 28,
  },
  {
    id: 'three-coal-barges',
    slug: 'three-coal-barges',
    name: 'Three Coal Barges',
    region: 'Pensacola Beach, Florida',
    country: 'United States',
    latitude: 30.31,
    longitude: -87.1,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'Three early-1900s wooden coal barges lying close together in shallow water off Pensacola Beach. The low-lying wreckage is a favorite for training dives, snorkeling, and spearfishing.',
    highlights: ['Trio of barges', 'Shallow and calm', 'Training favorite'],
    tags: ['wreck', 'barge', 'shallow', 'beginner', 'pensacola'],
    maxDepthM: 8,
  },
  {
    id: 'three-rocks-sosua',
    slug: 'three-rocks-sosua',
    name: 'Three Rocks',
    region: 'Sosúa, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 19.765,
    longitude: -70.495,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A cluster of three large coral mounds on a sandy plain outside Sosúa Bay, each ringed with soft corals and reef fish. Its shallow depth and calm water make it a staple training and second-dive site.',
    highlights: ['Three coral mounds', 'Calm shallow water', 'Ideal for new divers'],
    tags: ['reef', 'sosua', 'shallow', 'training', 'coral-heads'],
    maxDepthM: 12,
  },
  {
    id: 'three-sisters-reef',
    slug: 'three-sisters-reef',
    name: 'Three Sisters',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.021,
    longitude: -80.397,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A trio of coral mounds in Hawk Channel inshore of the main reef line, sheltered enough for windy-day diving. The patch reefs concentrate angelfish, grunts, and lobster.',
    highlights: ['Three coral mounds', 'Sheltered from wind', 'Lobster hideouts'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'three-sisters-springs',
    slug: 'three-sisters-springs',
    name: 'Three Sisters Springs',
    region: 'Crystal River, Florida',
    country: 'United States',
    latitude: 28.8887,
    longitude: -82.589,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A trio of turquoise spring lobes off Kings Bay within the Crystal River National Wildlife Refuge, world-famous for winter manatee aggregations. Access is by swim or paddle; snorkeling only, with seasonal closures.',
    highlights: ['Iconic turquoise lobes', 'Hundreds of wintering manatees', 'Wildlife refuge protection'],
    tags: ['spring', 'manatees', 'snorkel', 'crystal-river', 'wildlife-refuge'],
    maxDepthM: 4,
    requirementNote: 'Snorkeling only; no scuba, fins restrictions and manatee-season closures apply',
  },
  {
    id: 'throne-room-negril-jamaica',
    slug: 'throne-room-negril-jamaica',
    name: 'Throne Room',
    region: 'Negril, Jamaica',
    country: 'Jamaica',
    latitude: 18.3,
    longitude: -78.37,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Negril\'s best-known site, a large cavern entered through a crack in the reef whose interior is dominated by a huge orange elephant ear sponge shaped like a throne. Nurse sharks and lobsters often shelter inside.',
    highlights: ['Cavern with throne sponge', 'Nurse sharks inside', 'Dramatic light shafts'],
    tags: ['cavern', 'negril', 'sponges', 'nurse-sharks', 'west-end'],
    maxDepthM: 21,
  },
  {
    id: 'thunderball-grotto',
    slug: 'thunderball-grotto',
    name: 'Thunderball Grotto',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 24.174,
    longitude: -76.449,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sunlit sea cave beside Staniel Cay used in the James Bond films Thunderball and Never Say Never Again. Skylights beam light into the fish-filled chamber, dived and snorkeled at slack tide in only a few meters of water.',
    highlights: ['Sunbeam-lit cave chamber', 'James Bond film location', 'Swarms of tame reef fish'],
    tags: ['cavern', 'snorkel', 'exumas', 'movie-site', 'shallow'],
    maxDepthM: 4,
    requirementNote: 'Enter at slack tide; strong current flows through the grotto mid-tide.',
  },
  {
    id: 'thunderbolt-wreck',
    slug: 'thunderbolt-wreck',
    name: 'Thunderbolt',
    region: 'Marathon, Florida',
    country: 'United States',
    latitude: 24.658,
    longitude: -80.964,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 188-foot cable layer scuttled in 1986 off Marathon, sitting upright in about 36 meters with its prominent bow cable wheel intact. Coral-encrusted rails and resident goliath grouper reward the deep descent.',
    highlights: ['Upright 188-foot wreck', 'Iconic bow cable wheel', 'Goliath grouper encounters'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'deep', 'shipwreck-trail'],
    aliases: ['Randolph'],
    maxDepthM: 36,
    requiredCertification: 'AOW',
    requirementNote: 'Deck at 23-26 m, sand at 36 m; current common on the mooring.',
  },
  {
    id: 'tiger-beach',
    slug: 'tiger-beach',
    name: 'Tiger Beach',
    region: 'Grand Bahama, Bahamas',
    country: 'Bahamas',
    latitude: 26.86,
    longitude: -79.04,
    matchRadiusKm: 8,
    siteType: 'destination',
    difficulty: 'Intermediate',
    summary: 'A shallow sand bank on the Little Bahama Bank northwest of West End, world famous for close encounters with tiger sharks. Lemon, nurse, and Caribbean reef sharks also gather over the bright white sand at only a few meters depth.',
    highlights: ['Tiger sharks at close range', 'Lemon and reef sharks', 'Shallow white-sand bottom'],
    tags: ['sharks', 'tiger-sharks', 'grand-bahama', 'shallow', 'photography', 'liveaboard'],
    maxDepthM: 7,
    requirementNote: 'Operators typically require prior shark-diving experience and a briefing; long shallow bottom times.',
  },
  {
    id: 'timber-holes',
    slug: 'timber-holes',
    name: 'Timber Holes',
    region: 'Destin, Florida',
    country: 'United States',
    latitude: 30.32,
    longitude: -86.55,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A natural limestone bottom off Destin pocked with holes, cuts, and small ledges that concentrate marine life on an otherwise sandy shelf. Renowned for grouper, flounder, and octopus in the crevices.',
    highlights: ['Natural limestone holes', 'Grouper and flounder', 'Unique Gulf structure'],
    tags: ['reef', 'ledge', 'natural bottom', 'destin', 'spearfishing'],
    maxDepthM: 26,
  },
  {
    id: 'tintamarre',
    slug: 'tintamarre',
    name: 'Tintamarre',
    region: 'Île Tintamarre, St. Martin',
    country: 'Saint Martin',
    latitude: 18.115,
    longitude: -62.985,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'Off the uninhabited island of Tintamarre in St. Martin\'s nature reserve, a small tugboat wreck sits in shallow water surrounded by seagrass and coral patches. Green turtles feeding in the grass are nearly guaranteed.',
    highlights: ['shallow tug wreck', 'green turtles', 'nature reserve setting'],
    tags: ['wreck', 'turtles', 'st-martin', 'marine-reserve', 'shallow'],
    maxDepthM: 12,
  },
  {
    id: 'tonawanda-wreck',
    slug: 'tonawanda-wreck',
    name: 'Tonawanda',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.149,
    longitude: -80.254,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The broken remains of a Civil War-era steamer lost on the north end of Elbow Reef in 1866. Ribs, plates, and machinery lie in shallow coral and are often combined with the City of Washington.',
    highlights: ['Civil War-era steamer', 'Shallow scattered wreckage', 'Combined with Elbow dives'],
    tags: ['florida', 'keys', 'wreck', 'historic', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'toppinos-buoy',
    slug: 'toppinos-buoy',
    name: 'Toppino\'s Buoy',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.462,
    longitude: -81.723,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A shallow reef near channel marker 32 off Key West, long known by the local Toppino family name. Low coral ridges and sponge-dotted hardbottom suit training dives and snorkelers.',
    highlights: ['Marker 32 landmark', 'Shallow training reef', 'Sponge and soft coral bottom'],
    tags: ['florida', 'keys', 'reef', 'shallow', 'key-west'],
    aliases: ['Marker 32'],
    maxDepthM: 8,
  },
  {
    id: 'tormentos-reef',
    slug: 'tormentos-reef',
    name: 'Tormentos Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.45,
    longitude: -87.015,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Beginner',
    summary: 'A lively shallow reef of scattered coral heads swept by a steady current, its name referring to the torment of currents rather than storms. Flamingo tongues, arrow crabs, and free-swimming morays keep the reef busy.',
    highlights: ['Colorful coral heads', 'Free-swimming morays', 'Steady beginner drift'],
    tags: ['drift', 'reef', 'coral', 'cozumel', 'macro'],
    maxDepthM: 18,
  },
  {
    id: 'tortugas-playa-del-carmen',
    slug: 'tortugas-playa-del-carmen',
    name: 'Tortugas Reef',
    region: 'Playa del Carmen, Mexico',
    country: 'Mexico',
    latitude: 20.635,
    longitude: -87.055,
    matchRadiusKm: 4,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'Playa del Carmen\'s best-known deep drift, named for the loggerhead and green turtles that feed on its sponge-covered slope. Currents can be brisk, and bull sharks pass through in winter months.',
    highlights: ['Reliable turtle sightings', 'Winter bull sharks', 'Sponge-covered slope'],
    tags: ['drift', 'turtles', 'deep', 'playa-del-carmen', 'riviera-maya'],
    maxDepthM: 28,
    requiredCertification: 'AOW',
  },
  {
    id: 'toucari-caves',
    slug: 'toucari-caves',
    name: 'Toucari Caves',
    region: 'Toucari Bay, Dominica',
    country: 'Dominica',
    latitude: 15.612,
    longitude: -61.47,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A series of shallow caverns and swim-throughs in the volcanic rock off Toucari Bay in Dominica\'s quiet north. Lobster, banded coral shrimp, and schooling blackbar soldierfish fill the recesses.',
    highlights: ['shallow swim-through caverns', 'lobster-filled recesses', 'quiet northern setting'],
    tags: ['cavern', 'swim-through', 'dominica', 'beginner', 'shallow'],
    maxDepthM: 15,
  },
  {
    id: 'tracey-rsb-1',
    slug: 'tracey-rsb-1',
    name: 'Tracey (RSB-1)',
    region: 'Fort Lauderdale, Florida',
    country: 'United States',
    latitude: 26.1,
    longitude: -80.088,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A small steel vessel scuttled off Fort Lauderdale as part of Broward County\'s artificial reef program. Its manageable depth makes it a popular second-tank wreck dive.',
    highlights: ['Compact wreck', 'Moderate depth', 'Good second dive'],
    tags: ['wreck', 'artificial reef', 'fort lauderdale', 'intermediate'],
    aliases: ['RSB-1', 'Tracy'],
    maxDepthM: 22,
  },
  {
    id: 'train-wreck-eleuthera',
    slug: 'train-wreck-eleuthera',
    name: 'Train Wreck (Eleuthera)',
    region: 'Eleuthera, Bahamas',
    country: 'Bahamas',
    latitude: 25.57,
    longitude: -76.74,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The remains of a Civil War-era barge that sank in 1865 on the Devil\'s Backbone while carrying a steam locomotive, leaving wheels and framework scattered in about five meters. It is one of the only diveable train wrecks in the world.',
    highlights: ['1865 locomotive remains', 'Unique train-on-a-reef story', 'Easy shallow profile'],
    tags: ['wreck', 'history', 'eleuthera', 'shallow', 'unique'],
    maxDepthM: 5,
  },
  {
    id: 'trinity-caves-grand-cayman',
    slug: 'trinity-caves-grand-cayman',
    name: 'Trinity Caves',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.372,
    longitude: -81.405,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A classic West Bay wall dive where three coral-lined ravines funnel divers out onto the sheer drop-off. Swim-throughs open onto the wall at around 18-25 meters.',
    highlights: ['Three canyon swim-throughs', 'Sheer wall exit', 'Rope sponges and sea fans'],
    tags: ['wall', 'swim-throughs', 'canyons', 'west-bay', 'sponges'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Canyon exits open onto the wall below 18 m.',
  },
  {
    id: 'tuna-alley-bimini',
    slug: 'tuna-alley-bimini',
    name: 'Tuna Alley',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.56,
    longitude: -79.31,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A classic Bimini-area wall dive near Cat Cay where coral canyons funnel toward the Gulf Stream drop-off. Named for the migrating tuna once channeled through it, the site still delivers turtles, sharks, and dense coral ridges.',
    highlights: ['Coral canyons to the wall', 'Pelagic fly-bys', 'Classic Gulf Stream site'],
    tags: ['wall', 'reef', 'bimini', 'pelagics', 'drift'],
    maxDepthM: 25,
  },
  {
    id: 'tunnel-wall-nassau',
    slug: 'tunnel-wall-nassau',
    name: 'Tunnel Wall',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.99,
    longitude: -77.56,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A section of the New Providence wall cut by swim-through tunnels and crevices that open onto the Tongue of the Ocean drop-off. Divers descend through the reef top and exit onto the sheer face amid sponges and gorgonians.',
    highlights: ['Swim-through tunnels', 'Sheer wall exit', 'Sponge-covered drop-off'],
    tags: ['wall', 'swim-through', 'nassau', 'drop-off', 'boat-dive'],
    maxDepthM: 25,
  },
  {
    id: 'tunnels-jupiter',
    slug: 'tunnels-jupiter',
    name: 'Tunnels',
    region: 'Jupiter, Florida',
    country: 'United States',
    latitude: 26.95,
    longitude: -80.02,
    matchRadiusKm: 5,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A sculpted section of Jupiter\'s natural reef ledge where erosion has cut short swim-through tunnels and overhangs. Dived as a drift, it holds turtles, nurse sharks, and clouds of grunts.',
    highlights: ['Natural swim-throughs', 'Drift diving', 'Turtle encounters'],
    tags: ['drift', 'ledge', 'swim-through', 'turtles', 'jupiter'],
    maxDepthM: 21,
  },
  {
    id: 'turtle-reef',
    slug: 'turtle-reef',
    name: 'Turtle Reef',
    region: 'North Key Largo, Florida',
    country: 'United States',
    latitude: 25.2833,
    longitude: -80.2117,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A bank reef at the far northern end of the Key Largo reef tract, dived mostly by Ocean Reef and North Key Largo operators. Gentle profiles and healthy soft corals.',
    highlights: ['Northernmost Key Largo diving', 'Soft coral gardens', 'Relaxed conditions'],
    tags: ['florida', 'keys', 'reef', 'coral', 'north-key-largo'],
    maxDepthM: 10,
  },
  {
    id: 'turtle-reef-grand-cayman',
    slug: 'turtle-reef-grand-cayman',
    name: 'Turtle Reef',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.383,
    longitude: -81.418,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A popular West Bay shore dive beside the old turtle farm, where a coral mini-wall begins just meters from the entry ladder. Green turtles, tarpon and macro life make it a favorite for easy day and night dives.',
    highlights: ['Shore-entry mini-wall', 'Frequent green turtles', 'Excellent night diving'],
    tags: ['shore-dive', 'mini-wall', 'turtles', 'west-bay', 'night-dive'],
    maxDepthM: 18,
  },
  {
    id: 'turtle-rocks',
    slug: 'turtle-rocks',
    name: 'Turtle Rocks',
    region: 'North Key Largo, Florida',
    country: 'United States',
    latitude: 25.2917,
    longitude: -80.2183,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A cluster of shallow patch reefs off North Key Largo near Ocean Reef, popular with snorkelers and novice divers. Boulder corals and grunts dominate the shallow coral heads.',
    highlights: ['Shallow patch reefs', 'Frequent turtle sightings', 'Good snorkel option'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'snorkel'],
    maxDepthM: 8,
  },
  {
    id: 'twin-cave',
    slug: 'twin-cave',
    name: 'Twin Cave',
    region: 'Merritt\'s Mill Pond, Marianna, Florida',
    country: 'United States',
    latitude: 30.7809,
    longitude: -85.1655,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A pair of cave openings in the floor of Merritt\'s Mill Pond frequently used for cavern and cave training. Fossil beds and clean limestone make it a favorite short overhead dive.',
    highlights: ['Twin cave entrances', 'Fossils in the walls', 'Popular cavern training site'],
    tags: ['cave', 'cavern', 'mill-pond', 'marianna', 'overhead'],
    aliases: ['Twin Caves'],
    maxDepthM: 17,
    requiredCertification: 'Cavern',
    requirementNote: 'Cavern zone only for cavern divers; cave certification required beyond',
  },
  {
    id: 'twin-dees',
    slug: 'twin-dees',
    name: 'Twin Dees Spring',
    region: 'Weeki Wachee, Florida',
    country: 'United States',
    latitude: 28.515,
    longitude: -82.578,
    matchRadiusKm: 5,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'A deep spring near Weeki Wachee explored to great depths by Karst Underwater Research teams. Access is restricted to permitted exploration and survey projects rather than open recreation.',
    highlights: ['Deep exploration cave', 'KUR survey projects', 'Restricted-permit site'],
    tags: ['cave', 'spring', 'deep', 'restricted-access', 'technical'],
    aliases: ['Twin D\'s'],
    maxDepthM: 80,
    requiredCertification: 'FullCave',
    requirementNote: 'Permit-based research access only; not open for recreational diving',
  },
  {
    id: 'twin-tugs',
    slug: 'twin-tugs',
    name: 'Twin Tugs',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.1,
    longitude: -85.82,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A pair of tugboats resting close together on the sand off Panama City Beach, connected by a short swim. The wrecks concentrate snapper, spadefish, and toadfish on an otherwise open bottom.',
    highlights: ['Paired tug wrecks', 'Short swim between', 'Concentrated fish life'],
    tags: ['wreck', 'tugboat', 'artificial reef', 'panama city', 'intermediate'],
    maxDepthM: 24,
  },
  {
    id: 'ultra-freeze',
    slug: 'ultra-freeze',
    name: 'Ultra Freeze',
    region: 'Miami, Florida',
    country: 'United States',
    latitude: 25.815,
    longitude: -80.078,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 195-foot steel freighter sunk in 1984 as part of Miami-Dade\'s artificial reef program. The hull sits upright in deep water and draws goliath grouper, permit, and schooling jacks.',
    highlights: ['Upright freighter', 'Goliath grouper', 'Deep artificial reef'],
    tags: ['wreck', 'deep', 'freighter', 'artificial reef', 'miami'],
    maxDepthM: 37,
    requiredCertification: 'AOW',
  },
  {
    id: 'ultrafreeze-wreck',
    slug: 'ultrafreeze-wreck',
    name: 'Ultrafreeze Wreck',
    region: 'Cancún, Mexico',
    country: 'Mexico',
    latitude: 21.28,
    longitude: -86.7,
    matchRadiusKm: 10,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A large refrigerator ship that sank northeast of Isla Mujeres in the late 1970s, resting at around 28-30 m in open water. Currents and depth make it an advanced dive rewarded with big groupers, barracuda, and passing pelagics.',
    highlights: ['Large intact freighter', 'Big groupers', 'Open-water pelagics'],
    tags: ['wreck', 'deep', 'advanced', 'cancun', 'current'],
    aliases: ['El Frio'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
  },
  {
    id: 'uncle-charlies-blue-hole',
    slug: 'uncle-charlies-blue-hole',
    name: 'Uncle Charlie\'s Blue Hole',
    region: 'Andros, Bahamas',
    country: 'Bahamas',
    latitude: 24.72,
    longitude: -77.77,
    matchRadiusKm: 6,
    siteType: 'blue-hole',
    difficulty: 'Advanced',
    summary: 'An oceanic blue hole near Fresh Creek made famous by Jacques Cousteau\'s Andros expeditions, opening in the reef flat and dropping into a wide cavern system. Tidal flow through the hole creates noticeable currents at the entrance.',
    highlights: ['Cousteau-documented blue hole', 'Cavern-like walls', 'Tidal current effects'],
    tags: ['blue-hole', 'andros', 'cavern', 'tidal', 'advanced'],
    maxDepthM: 27,
    requirementNote: 'Best dived at slack tide; overhead sections beyond the entrance require cave training.',
  },
  {
    id: 'united-caribbean',
    slug: 'united-caribbean',
    name: 'United Caribbean',
    region: 'Pompano Beach, Florida',
    country: 'United States',
    latitude: 26.27,
    longitude: -80.06,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A steel coastal freighter scuttled off Pompano Beach as part of Broward County\'s artificial reef program. The wreck lies at recreational depth and shelters snapper, grunts, and moray eels.',
    highlights: ['Coastal freighter', 'Recreational depth', 'Moray eels'],
    tags: ['wreck', 'freighter', 'artificial reef', 'pompano', 'intermediate'],
    maxDepthM: 21,
  },
  {
    id: 'urca-de-lima',
    slug: 'urca-de-lima',
    name: 'Urca de Lima',
    region: 'Fort Pierce, Florida',
    country: 'United States',
    latitude: 27.5,
    longitude: -80.29,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A ship of the 1715 Spanish Plate Fleet driven ashore by a hurricane north of Fort Pierce Inlet, and Florida\'s first Underwater Archaeological Preserve. Ballast stones and replica cannons lie in very shallow water close to the beach.',
    highlights: ['1715 Spanish fleet', 'First state preserve', 'Very shallow'],
    tags: ['wreck', 'historic', 'preserve', 'shore dive', 'fort pierce'],
    maxDepthM: 4,
  },
  {
    id: 'uss-bibb',
    slug: 'uss-bibb',
    name: 'USCGC Bibb',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 24.9952,
    longitude: -80.3795,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 327-foot Coast Guard cutter scuttled in 1987 as an artificial reef, resting on its starboard side in about 40 meters. Deeper and less visited than its sister ship, it draws big pelagics and strong current.',
    highlights: ['327-foot cutter on its side', 'Pelagic encounters', 'Sister ship to the Duane'],
    tags: ['florida', 'keys', 'wreck', 'artificial-reef', 'deep', 'advanced'],
    aliases: ['Bibb'],
    maxDepthM: 40,
    requiredCertification: 'AOW',
    requirementNote: 'Deep dive to 30-40 m with frequent strong current; deep or tec experience recommended.',
  },
  {
    id: 'uss-adirondack-wreck',
    slug: 'uss-adirondack-wreck',
    name: 'USS Adirondack Wreck',
    region: 'Abacos, Bahamas',
    country: 'Bahamas',
    latitude: 26.59,
    longitude: -77,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The wreckage of a Union Navy gunboat that struck the reef off Man-O-War Cay in 1862, leaving cannons and hull remains scattered in shallow water. Several large guns are still clearly visible among the coral.',
    highlights: ['Civil War cannons', 'Shallow historic wreckage', 'Combined reef dive'],
    tags: ['wreck', 'history', 'abacos', 'shallow', 'cannons'],
    maxDepthM: 6,
  },
  {
    id: 'uss-massachusetts',
    slug: 'uss-massachusetts',
    name: 'USS Massachusetts (BB-2)',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.297,
    longitude: -87.312,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'An 1896 pre-dreadnought battleship scuttled in 1921 just outside Pensacola Pass and later used for gunnery practice, now a Florida Underwater Archaeological Preserve. Its turrets and hull sit in shallow water teeming with fish.',
    highlights: ['Pre-dreadnought battleship', 'Archaeological preserve', 'Shallow historic wreck'],
    tags: ['wreck', 'battleship', 'historic', 'preserve', 'pensacola'],
    aliases: ['Battleship Massachusetts', 'BB-2'],
    maxDepthM: 8,
  },
  {
    id: 'uss-mohawk',
    slug: 'uss-mohawk',
    name: 'USS Mohawk (CGC)',
    region: 'Fort Myers, Florida',
    country: 'United States',
    latitude: 26.55,
    longitude: -82.73,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 165-foot WWII Coast Guard cutter that escorted North Atlantic convoys before being scuttled in 2012 as a veterans memorial reef off Sanibel and Fort Myers. The upright cutter is southwest Florida\'s premier wreck dive.',
    highlights: ['WWII convoy escort', 'Veterans memorial reef', 'Upright and intact'],
    tags: ['wreck', 'coast guard', 'wwii', 'memorial', 'fort myers'],
    aliases: ['Mohawk', 'USCGC Mohawk'],
    maxDepthM: 27,
    requiredCertification: 'AOW',
    requirementNote: 'Long offshore run from Fort Myers or Sanibel',
  },
  {
    id: 'uss-narcissus',
    slug: 'uss-narcissus',
    name: 'USS Narcissus',
    region: 'St. Petersburg, Florida',
    country: 'United States',
    latitude: 27.592,
    longitude: -82.792,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A Civil War-era Navy tug that sank in an 1866 storm off Egmont Key with the loss of all hands, designated Florida\'s twelfth Underwater Archaeological Preserve. The boiler and hull remains lie in very shallow water.',
    highlights: ['Civil War Navy tug', 'Archaeological preserve', 'Shallow historic site'],
    tags: ['wreck', 'historic', 'preserve', 'shallow', 'st petersburg'],
    maxDepthM: 5,
  },
  {
    id: 'uss-rankin',
    slug: 'uss-rankin',
    name: 'USS Rankin',
    region: 'Fort Pierce, Florida',
    country: 'United States',
    latitude: 27.5,
    longitude: -80.16,
    matchRadiusKm: 6,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 459-foot WWII attack cargo ship scuttled in 1988 as an artificial reef off Fort Pierce. The huge hull is one of the Treasure Coast\'s premier deep wrecks, home to goliath grouper and big snapper.',
    highlights: ['WWII attack cargo ship', 'Massive hull', 'Goliath grouper'],
    tags: ['wreck', 'navy', 'deep', 'artificial reef', 'fort pierce'],
    aliases: ['Rankin'],
    maxDepthM: 33,
    requiredCertification: 'AOW',
  },
  {
    id: 'uss-strength',
    slug: 'uss-strength',
    name: 'USS Strength',
    region: 'Panama City Beach, Florida',
    country: 'United States',
    latitude: 30.11,
    longitude: -85.76,
    matchRadiusKm: 5,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A WWII Admirable-class minesweeper that survived a kamikaze attack before being scuttled off Panama City Beach in 1987. The 184-foot warship rests at recreational depth with recognizable deck features.',
    highlights: ['WWII minesweeper', 'Combat history', 'Recreational depth'],
    tags: ['wreck', 'navy', 'wwii', 'panama city', 'intermediate'],
    maxDepthM: 23,
  },
  {
    id: 'uss-sturtevant',
    slug: 'uss-sturtevant',
    name: 'USS Sturtevant',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.758,
    longitude: -82.025,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A WWII destroyer sunk in 1942 by mines from an American defensive field northwest of Key West. The broken hull sections lie in under 20 meters and are visited by local wreck charters.',
    highlights: ['WWII destroyer', 'Sunk by friendly minefield', 'Fish-covered debris sections'],
    tags: ['florida', 'keys', 'wreck', 'wwii', 'historic', 'gulf-side'],
    maxDepthM: 19,
  },
  {
    id: 'uss-wilkes-barre',
    slug: 'uss-wilkes-barre',
    name: 'USS Wilkes-Barre',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.38,
    longitude: -81.6,
    matchRadiusKm: 8,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 610-foot WWII light cruiser scuttled in explosives tests in 1972, lying in two sections in roughly 43 to 76 meters off Key West. One of Florida\'s premier technical wreck dives with intact guns and superstructure.',
    highlights: ['WWII light cruiser', 'Intact gun turrets', 'World-class technical dive'],
    tags: ['florida', 'keys', 'wreck', 'wwii', 'tec', 'deep'],
    aliases: ['Wilkes-Barre'],
    maxDepthM: 76,
    requiredCertification: 'TecTrimix',
    requirementNote: 'Depths of 43-76 m require full technical trimix training and support.',
  },
  {
    id: 'vamar',
    slug: 'vamar',
    name: 'Vamar',
    region: 'Mexico Beach, Florida',
    country: 'United States',
    latitude: 29.93,
    longitude: -85.42,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A steamer with a storied past, including service on Admiral Byrd\'s Antarctic expedition, that sank off Mexico Beach in 1942 and is now a Florida Underwater Archaeological Preserve. The low-lying wreckage rests in shallow water close to shore.',
    highlights: ['Byrd expedition history', 'Archaeological preserve', 'Shallow wreck'],
    tags: ['wreck', 'historic', 'preserve', 'shallow', 'mexico beach'],
    maxDepthM: 8,
  },
  {
    id: 'veronica-l',
    slug: 'veronica-l',
    name: 'Veronica L',
    region: 'St. George\'s, Grenada',
    country: 'Grenada',
    latitude: 12.055,
    longitude: -61.76,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'A small coastal cargo boat resting upright in about 15 meters near St. George\'s, fully carpeted in sponges and hydroids. Its compact size and calm setting make it Grenada\'s favorite easy wreck and photography dive.',
    highlights: ['compact upright wreck', 'sponge-carpeted deck', 'great for photography'],
    tags: ['wreck', 'shallow', 'grenada', 'photography', 'beginner'],
    maxDepthM: 15,
  },
  {
    id: 'veterans-reef',
    slug: 'veterans-reef',
    name: 'Veterans Reef',
    region: 'Clearwater, Florida',
    country: 'United States',
    latitude: 27.97,
    longitude: -82.97,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'An artificial reef complex off Clearwater built from concrete structures and scuttled material honoring military veterans. The modest depth and abundant grouper, sheepshead, and baitfish make it a popular Gulf training site.',
    highlights: ['Veterans memorial reef', 'Easy Gulf diving', 'Grouper and sheepshead'],
    tags: ['artificial reef', 'memorial', 'clearwater', 'beginner', 'gulf'],
    maxDepthM: 14,
  },
  {
    id: 'victory-reef-bimini',
    slug: 'victory-reef-bimini',
    name: 'Victory Reef',
    region: 'Bimini, Bahamas',
    country: 'Bahamas',
    latitude: 25.47,
    longitude: -79.29,
    matchRadiusKm: 6,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A reef and mini-wall system near the Victory Cays south of Cat Cay, on the eastern edge of the Gulf Stream. Coral ridges drop toward deeper water, drawing pelagics, turtles, and reef sharks in typically excellent visibility.',
    highlights: ['Gulf Stream visibility', 'Coral ridges and drop-offs', 'Turtles and pelagics'],
    tags: ['reef', 'wall', 'bimini', 'gulf-stream', 'boat-dive'],
    maxDepthM: 24,
  },
  {
    id: 'vista-blue',
    slug: 'vista-blue',
    name: 'Vista Blue',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.04,
    longitude: -68.273,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'One of the southernmost shore dives on Bonaire, with a sandy entry and a reef slope frequented by turtles and, in season, passing tarpon. Its exposed position means stronger current than sites farther north.',
    highlights: ['Southern-tip reef', 'Turtle sightings', 'Blue-water views'],
    tags: ['shore-dive', 'coral', 'bonaire', 'south-coast', 'current'],
    maxDepthM: 35,
  },
  {
    id: 'vulcan-bomber',
    slug: 'vulcan-bomber',
    name: 'Vulcan Bomber',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.988,
    longitude: -77.548,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The skeletal framework of a mock aircraft built as a prop for the 1965 James Bond film Thunderball, now a coral-covered lattice on shallow sand off southwest New Providence. Its structure shelters dense schools of grunts and sergeant majors.',
    highlights: ['Thunderball film prop', 'Coral-covered framework', 'Schooling reef fish'],
    tags: ['wreck', 'movie-site', 'nassau', 'shallow', 'artificial-reef'],
    aliases: ['Thunderball Bomber'],
    maxDepthM: 13,
  },
  {
    id: 'wakulla-springs',
    slug: 'wakulla-springs',
    name: 'Wakulla Springs',
    region: 'Wakulla Springs State Park, Florida',
    country: 'United States',
    latitude: 30.2352,
    longitude: -84.3025,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Advanced',
    summary: 'One of the world\'s largest and deepest freshwater springs, feeding the Wakulla River inside a state park. Diving is closed to the public and limited to permitted scientific projects such as the WKPP exploration.',
    highlights: ['One of the largest springs on Earth', 'Vast mapped cave system', 'Glass-bottom boat views'],
    tags: ['spring', 'cave', 'state-park', 'restricted-access', 'panhandle'],
    maxDepthM: 90,
    requiredCertification: 'FullCave',
    requirementNote: 'Closed to recreational diving; research permit holders only',
  },
  {
    id: 'washing-machine-exuma',
    slug: 'washing-machine-exuma',
    name: 'Washing Machine',
    region: 'Exumas, Bahamas',
    country: 'Bahamas',
    latitude: 24.71,
    longitude: -76.83,
    matchRadiusKm: 6,
    siteType: 'drift',
    difficulty: 'Intermediate',
    summary: 'A tidal cut near Highbourne Cay where incoming flow tumbles divers through a natural chute before spitting them onto a coral garden. The spin-cycle start gives the site its name; the ride is short, shallow, and repeatable.',
    highlights: ['Spin-cycle tidal chute', 'Repeatable drift runs', 'Coral garden finish'],
    tags: ['drift', 'current', 'exumas', 'fun-dive', 'shallow'],
    maxDepthM: 12,
    requirementNote: 'Run on the incoming tide; comfort in strong current required.',
  },
  {
    id: 'watamula',
    slug: 'watamula',
    name: 'Watamula',
    region: 'Westpunt, Curaçao',
    country: 'Curacao',
    latitude: 12.39,
    longitude: -69.155,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Advanced',
    summary: 'The northernmost dive site on Curaçao off the island\'s tip, famous for lush, current-swept coral meadows often described as an underwater flower garden. Usually dived as a boat drift when conditions allow.',
    highlights: ['Dense coral coverage', 'Drift diving', 'Big fish traffic'],
    tags: ['boat-dive', 'drift', 'curacao', 'coral', 'advanced'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Exposed point with current; dived by boat in suitable conditions only.',
  },
  {
    id: 'wekiwa-springs',
    slug: 'wekiwa-springs',
    name: 'Wekiwa Springs',
    region: 'Apopka, Florida',
    country: 'United States',
    latitude: 28.7119,
    longitude: -81.463,
    matchRadiusKm: 3,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'The headspring of the Wekiva River in a busy state park north of Orlando, with a grassy amphitheater bowl around the swimming basin. Visitors swim and snorkel; scuba is not allowed.',
    highlights: ['Wekiva River headspring', 'Classic swimming bowl', 'Paddling access downstream'],
    tags: ['spring', 'snorkel', 'state-park', 'swimming', 'central-florida'],
    maxDepthM: 5,
    requirementNote: 'Swimming and snorkeling only',
  },
  {
    id: 'western-dry-rocks',
    slug: 'western-dry-rocks',
    name: 'Western Dry Rocks',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.4453,
    longitude: -81.926,
    matchRadiusKm: 4,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A reef and important fish-spawning area west of Sand Key where deeper spurs, ledges, and cuts attract permit, grouper, and sharks. Seasonal closures protect spawning aggregations.',
    highlights: ['Fish spawning aggregations', 'Deeper cuts and ledges', 'Shark and permit sightings'],
    tags: ['florida', 'keys', 'reef', 'spawning', 'key-west'],
    maxDepthM: 12,
  },
  {
    id: 'western-sambo',
    slug: 'western-sambo',
    name: 'Western Sambo',
    region: 'Key West, Florida',
    country: 'United States',
    latitude: 24.478,
    longitude: -81.717,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'The largest of the Sambo reefs and an Ecological Reserve stretching from shore to the reef edge. Its no-take protection since 1997 has produced dense coral and conspicuous large fish.',
    highlights: ['Ecological Reserve since 1997', 'Large protected fish', 'Extensive shallow coral'],
    tags: ['florida', 'keys', 'reef', 'ecological-reserve', 'key-west', 'spur-and-groove'],
    maxDepthM: 9,
  },
  {
    id: 'white-banks-dry-rocks',
    slug: 'white-banks-dry-rocks',
    name: 'White Banks Dry Rocks',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.0395,
    longitude: -80.373,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A pair of very shallow patch reefs inshore of French Reef, ideal for snorkeling and shallow scuba. Soft corals and sea fans sway over bright sand between the two coral mounds.',
    highlights: ['Twin patch reefs', 'Sea fan gardens', 'Great visibility over sand'],
    tags: ['florida', 'keys', 'reef', 'patch-reef', 'snorkel', 'shallow'],
    aliases: ['White Bank Dry Rocks'],
    maxDepthM: 5,
  },
  {
    id: 'white-slave',
    slug: 'white-slave',
    name: 'White Slave',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.063,
    longitude: -68.284,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'Shore dive beside the white-painted historic slave huts on Bonaire\'s southern coast, with a sloping reef that often hosts turtles and passing eagle rays. Entry over ironshore requires some care in swell.',
    highlights: ['Historic slave hut landmark', 'Turtles and eagle rays', 'Healthy southern reef'],
    tags: ['shore-dive', 'coral', 'bonaire', 'historic', 'turtles'],
    maxDepthM: 35,
  },
  {
    id: 'widowmakers-cave-jamaica',
    slug: 'widowmakers-cave-jamaica',
    name: 'Widowmaker\'s Cave',
    region: 'Montego Bay, Jamaica',
    country: 'Jamaica',
    latitude: 18.494,
    longitude: -77.932,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Advanced',
    summary: 'Montego Bay\'s most famous dive, a vertical chimney that divers enter at about 24 meters and ascend through the reef to exit near 10 meters. The sponge-lined shaft is wide enough for one diver at a time and packed with glassy sweepers.',
    highlights: ['Vertical chimney swim-through', 'Sponge-lined shaft', 'Glassy sweepers inside'],
    tags: ['swim-through', 'chimney', 'montego-bay', 'marine-park', 'advanced'],
    maxDepthM: 24,
    requiredCertification: 'AOW',
    requirementNote: 'Chimney entrance lies near 24 m; good buoyancy control required.',
  },
  {
    id: 'willaurie-wreck',
    slug: 'willaurie-wreck',
    name: 'Willaurie Wreck',
    region: 'Nassau, Bahamas',
    country: 'Bahamas',
    latitude: 24.99,
    longitude: -77.55,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A roughly 40-meter mail and cargo boat that sank at its Nassau mooring and was later moved to the southwest reef line as a dive attraction. The hull is richly overgrown and photogenic, with resident schools of grunts and the occasional reef shark.',
    highlights: ['Photogenic overgrown hull', 'Resident fish schools', 'Close to shark sites'],
    tags: ['wreck', 'artificial-reef', 'nassau', 'photography', 'boat-dive'],
    maxDepthM: 20,
  },
  {
    id: 'williford-spring',
    slug: 'williford-spring',
    name: 'Williford Spring',
    region: 'Econfina Creek, Youngstown, Florida',
    country: 'United States',
    latitude: 30.4368,
    longitude: -85.5464,
    matchRadiusKm: 4,
    siteType: 'spring',
    difficulty: 'Beginner',
    summary: 'A restored second-magnitude spring on Econfina Creek managed by the Northwest Florida Water Management District. A deep central vent and boardwalk access make it the most popular swim and snorkel spot on the creek.',
    highlights: ['Restored spring run', 'Deep blue central vent', 'Boardwalk and picnic access'],
    tags: ['spring', 'snorkel', 'econfina', 'panhandle', 'freshwater'],
    maxDepthM: 6,
  },
  {
    id: 'winch-hole',
    slug: 'winch-hole',
    name: 'Winch Hole',
    region: 'Key Largo, Florida',
    country: 'United States',
    latitude: 25.155,
    longitude: -80.263,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'A sandy pocket in the Sea Gardens reef area named for the large 19th-century ship\'s winch resting at its center. Shallow depths and abundant grunts make it a relaxed second dive.',
    highlights: ['Historic salvage winch', 'Sheltered sand pocket', 'Schooling grunts'],
    tags: ['florida', 'keys', 'reef', 'artifact', 'shallow'],
    maxDepthM: 8,
  },
  {
    id: 'windjammer-wreck',
    slug: 'windjammer-wreck',
    name: 'Windjammer Wreck',
    region: 'Dry Tortugas, Florida',
    country: 'United States',
    latitude: 24.6202,
    longitude: -82.9394,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The iron-hulled sailing ship Avanti, wrecked on Loggerhead Reef in 1907 and now the signature dive of Dry Tortugas National Park. The largely intact bow and scattered hull sit in shallow clear water.',
    highlights: ['1907 iron windjammer', 'Snorkel-accessible wreck', 'National park protection'],
    tags: ['florida', 'dry-tortugas', 'wreck', 'historic', 'national-park', 'shallow'],
    aliases: ['Avanti', 'Killean'],
    maxDepthM: 7,
  },
  {
    id: 'windsock',
    slug: 'windsock',
    name: 'Windsock',
    region: 'Bonaire',
    country: 'Caribbean Netherlands',
    latitude: 12.13,
    longitude: -68.283,
    matchRadiusKm: 2,
    siteType: 'reef',
    difficulty: 'Beginner',
    summary: 'Easy sandy beach entry beside the airport runway, with a gentle reef slope popular for training and check-out dives. Turtles graze the shallows and squid are common near the entry.',
    highlights: ['Sandy beach entry', 'Frequent turtles', 'Ideal training site'],
    tags: ['shore-dive', 'beginner-friendly', 'bonaire', 'training', 'turtles'],
    maxDepthM: 25,
  },
  {
    id: 'wit-shoal-ii',
    slug: 'wit-shoal-ii',
    name: 'WIT Shoal II',
    region: 'St. Thomas, US Virgin Islands',
    country: 'US Virgin Islands',
    latitude: 18.31,
    longitude: -64.99,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A 327-foot WWII-era LST landing ship sitting upright on sand off St. Thomas\' south side, heavily encrusted after decades underwater. Multiple deck levels and open holds make it the island\'s signature wreck penetration dive.',
    highlights: ['intact upright LST', 'multi-level penetration', 'resident groupers and jacks'],
    tags: ['wreck', 'penetration', 'deep', 'usvi', 'artificial-reef'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Deck levels start around 20 m; wreck training recommended for interior passes.',
  },
  {
    id: 'worlds-end-reef',
    slug: 'worlds-end-reef',
    name: 'World\'s End Reef',
    region: 'Tobago Cays, the Grenadines',
    country: 'Saint Vincent and the Grenadines',
    latitude: 12.618,
    longitude: -61.335,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The outermost horseshoe reef of the Tobago Cays Marine Park, taking the full Atlantic swell and rewarding divers with pristine hard coral and big fish. Its exposed position means diving is conditions-dependent.',
    highlights: ['outer horseshoe reef', 'pristine hard corals', 'Atlantic-side big fish'],
    tags: ['reef', 'marine-park', 'grenadines', 'tobago-cays', 'exposed'],
    maxDepthM: 20,
  },
  {
    id: 'wreck-alley-cooper-island',
    slug: 'wreck-alley-cooper-island',
    name: 'Wreck Alley (Cooper Island)',
    region: 'Cooper Island, British Virgin Islands',
    country: 'British Virgin Islands',
    latitude: 18.379,
    longitude: -64.518,
    matchRadiusKm: 3,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A cluster of intentionally sunk vessels off Cooper Island, including the Marie L, the tug Pat, and the island freighter Beata, resting on sand near 26 meters. Divers can visit multiple hulls on a single tank as garden eels sway on the surrounding bottom.',
    highlights: ['multiple wrecks one dive', 'Marie L and Pat side by side', 'garden eel flats'],
    tags: ['wreck', 'artificial-reef', 'bvi', 'multi-wreck', 'boat-dive'],
    aliases: ['Marie L', 'Pat', 'Beata'],
    maxDepthM: 26,
  },
  {
    id: 'wreck-of-the-cali-grand-cayman',
    slug: 'wreck-of-the-cali-grand-cayman',
    name: 'Wreck of the Cali',
    region: 'Grand Cayman, Cayman Islands',
    country: 'Cayman Islands',
    latitude: 19.3,
    longitude: -81.386,
    matchRadiusKm: 2,
    siteType: 'wreck',
    difficulty: 'Beginner',
    summary: 'The scattered remains of a four-masted schooner that sank off George Town in the 1940s, lying in very shallow water just off the ironshore. An easy shore dive or snorkel with ribs and machinery covered in fish.',
    highlights: ['Very shallow historic wreckage', 'Easy shore entry', 'Great for snorkelers too'],
    tags: ['wreck', 'shore-dive', 'shallow', 'george-town', 'snorkel-friendly'],
    maxDepthM: 8,
  },
  {
    id: 'ydt-14',
    slug: 'ydt-14',
    name: 'YDT-14',
    region: 'Pensacola, Florida',
    country: 'United States',
    latitude: 30.26,
    longitude: -87.29,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Intermediate',
    summary: 'A former Navy yard diving tender scuttled in 2000 off Pensacola Pass, sitting upright and intact. Once used to train Navy divers, it is now one of the area\'s most popular wreck dives.',
    highlights: ['Navy diving tender', 'Upright and intact', 'Easy penetration lines'],
    tags: ['wreck', 'navy', 'artificial reef', 'pensacola', 'intermediate'],
    maxDepthM: 27,
  },
  {
    id: 'yellow-reef-desecheo',
    slug: 'yellow-reef-desecheo',
    name: 'Yellow Reef',
    region: 'Desecheo Island, Puerto Rico',
    country: 'Puerto Rico',
    latitude: 18.392,
    longitude: -67.478,
    matchRadiusKm: 3,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'The flagship site at Desecheo Island off Rincón, a pinnacle-and-spur reef with canyons, arches and some of Puerto Rico\'s clearest water. Dense yellow sponges and cup corals give the site its name.',
    highlights: ['30m-plus visibility', 'Canyons and archways', 'Yellow sponge coverage'],
    tags: ['reef', 'desecheo', 'clear-water', 'pinnacles', 'boat-dive'],
    maxDepthM: 30,
    requiredCertification: 'AOW',
    requirementNote: 'Open-ocean island with structure below 18 m.',
  },
  {
    id: 'yemaya-maria-la-gorda-cuba',
    slug: 'yemaya-maria-la-gorda-cuba',
    name: 'Yemayá',
    region: 'María la Gorda, Cuba',
    country: 'Cuba',
    latitude: 21.8,
    longitude: -84.505,
    matchRadiusKm: 5,
    siteType: 'reef',
    difficulty: 'Intermediate',
    summary: 'A María la Gorda wall dive named after the Yoruba sea goddess, with a coral face dropping past tunnels and overhangs. Whip corals, big sponges and passing pelagics reward divers along the drop.',
    highlights: ['Sheer coral wall', 'Tunnels and overhangs', 'Occasional pelagic visitors'],
    tags: ['wall', 'maria-la-gorda', 'tunnels', 'sponges', 'national-park'],
    maxDepthM: 32,
    requiredCertification: 'AOW',
    requirementNote: 'Wall profile below 18 m.',
  },
  {
    id: 'yucab-reef',
    slug: 'yucab-reef',
    name: 'Yucab Reef',
    region: 'Cozumel, Mexico',
    country: 'Mexico',
    latitude: 20.44,
    longitude: -87.02,
    matchRadiusKm: 3,
    siteType: 'drift',
    difficulty: 'Beginner',
    summary: 'A shallow strip reef packed with macro life, from splendid toadfish and seahorses to scorpionfish and juvenile drums. The moderate current and 15 m depth make it a favorite for photographers and newer divers alike.',
    highlights: ['Macro photography', 'Splendid toadfish', 'Easy drift'],
    tags: ['drift', 'reef', 'macro', 'cozumel', 'photography'],
    maxDepthM: 15,
  },
  {
    id: 'zingara-wreck-sosua',
    slug: 'zingara-wreck-sosua',
    name: 'Zingara Wreck',
    region: 'Sosúa, Dominican Republic',
    country: 'Dominican Republic',
    latitude: 19.78,
    longitude: -70.51,
    matchRadiusKm: 4,
    siteType: 'wreck',
    difficulty: 'Advanced',
    summary: 'A cargo ship scuttled off Sosúa in 1993 that sits upright on sand at around 35 meters. The intact hull, masts and holds make it the north coast\'s premier deep wreck dive.',
    highlights: ['Upright intact freighter', 'Deep 35-meter profile', 'Masts rising toward the light'],
    tags: ['wreck', 'sosua', 'deep', 'artificial-reef', 'advanced'],
    maxDepthM: 35,
    requiredCertification: 'AOW',
    requirementNote: 'Hull rests near the recreational depth limit.',
  },
];
